import {Link} from "react-router";
import corporateTripsImg from "../../../assets/services/campbelltown-corporate-trips.jpeg";
export const allLocationsData2 = {
  "sutherland-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d26450.735390441856!2d151.05491085!3d-34.0350992!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12c12d084b5da1%3A0x5017d681632cca0!2sSutherland%20NSW%202232%2C%20Australia!5e0!3m2!1sen!2sbd!4v1774724033830!5m2!1sen!2sbd",
    pageTitle:
      "Taxi & Maxi Cabs Services in Sutherland, NSW - Family & Local Travel Experts",
    metaDescription:
      "Book Taxi & Maxi Cabs Services in Sutherland for family travel, local trips & cruise transfers. Trusted drivers, baby seat options & fixed pricing available. Book now!",
    heroTitle:
      "24/7 Taxi & Maxi Cabs Services in Sutherland for Fast & Safe Travel",
    heroDescription: (
      <>
        Need dependable rides around Sutherland? Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs Services
        </Link>
        in Sutherland deliver quick pickups every time you call. We handle your
        local trips with sharp timing that never fails. Our vehicles fit single
        travellers and large groups equally well. You get plenty of cabin space
        for people and luggage together. No one gets left out or squeezed inside.
        We run day and night without stopping. Your flight might land at 2 AM.
        Your shift could end at sunrise. Either way, we show up fast. Choose our
        luxury option for extra comfort. We manage smooth Sutherland pick up and
        drop off to keep your schedule on track. You avoid delays. You skip
        stress.
        <Link to={`/`} className="underline font-semibold px-1">
          Campbelltown Taxi Cabs
        </Link>{" "}
        puts your timetable first always.
      </>
    ),
    bookingFormTitle: "Book Baby Taxi in Sutherland NSW",
    locationSectionTitle: "Reliable Taxi Service in Sutherland for Groups",
    locationSectionDescription: (
      <>
        Taking family or friends somewhere nice? Our Sutherland Taxi Service suits
        small and large groups perfectly. Everyone travels together in one car.
        You miss the hassle of splitting into different vehicles. You avoid
        confusing planning. Through our dedicated
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab Services in Sutherland,
        </Link>
        each person enjoys safe, comfortable travel. Maybe you leave Sutherland
        for Sydney Airport. Maybe you head home after long trips. We keep our
        promises on timing. Our drivers know the best routes. They avoid traffic
        jams. They cut the waiting time. You can trust our Group Transport Curl
        Curl options when you need space, reliability, and clean cars. Booking
        takes seconds through our online system. You get confirmation quickly.
        You travel with confidence.
      </>
    ),
    locationSection2Title:
      "Affordable Taxi Service in Sutherland with Maxi Cabs: safe and 24/7 transport",
    locationSection2Desctiption: (
      <>
        We believe cheap should never mean uncomfortable. Our
        <Link
          to={`/book-a-taxi`}
          className="underline font-semibold px-1"
        >
          Local Taxi Service
        </Link>
        in Sutherland offers fair prices with full clarity. You see the cost
        before booking. You plan your budget with assurance. This helps when
        travelling with others. You can book a
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab for Group Travel
        </Link>{" "}
        that carries many passengers plus bags. Want something better? Upgrade to
        our premium service for nicer travel. Families can ask for
        <Link
          to={`/services/baby-seat-taxi-sydney`}
          className="underline font-semibold px-1"
        >
          Baby Seat Taxi
        </Link>{" "}
        options. Your children ride in approved, properly fitted seats. Our
        drivers have experience and manners. They help with special needs. They
        assist with luggage. From early flights to late arrivals, our 24/7 Taxi
        Sutherland keeps you moving. Campbelltown{" "}
        <Link
          to={`/book-a-taxi`}
          className="underline font-semibold px-1"
        >
          Taxi & Maxi Cabs
        </Link>{" "}
        promises safe, reliable, stress-free transport for every customer.
      </>
    ),
    locationSection3Title:
      "Comfortable Corporate & Baby Seat Taxi Booking in Sutherland",
    locationSection3Description: (
      <>
        Our
        <Link
          to={`/book-a-taxi`}
          className="underline font-semibold px-1"
        >
          Taxi Service in Sutherland
        </Link>{" "}
        gives you lots of legroom. You get plenty of luggage space. You relax
        even when the car is full. You avoid tight seating. You miss awkward bag
        packing. Your trip becomes pleasant. Choosing our Taxi & Maxi Cabs
        Services in Sutherland lets your group focus on the journey. We specialise
        in group transfers for families, sports teams, and work groups. Everyone
        arrives together. Booking is fast through our Sutherland Cab Booking page.
        You arrange transport early. Business travellers can use our
        <Link
          to={`/services/corporate-tips`}
          className="underline font-semibold px-1"
        >
          Corporate Taxi Service
        </Link>{" "}
        for on-time, professional rides to meetings. Families add Baby Seat Taxi
        options for safer trips with young children. When style matters, our
        premium service gives extra comfort. Every car gets cleaned regularly. We
        keep high standards. You enjoy smooth, safe travel without traffic
        worries.
      </>
    ),
    locationSection4Title:
      "Reliable Sutherland Taxi & Maxi Cab: Premium Solutions for All Your Travel Needs",
    locationSection4Desctiption: (
      <>
        Find professional transport made for Sutherland residents and visitors.
        Our full range gives you exactly what you need, whether catching early
        flights or arranging
        <Link
          to={`/services/wedding-transfer`}
          className="underline font-semibold px-1"
        >
          wedding transport
        </Link>{" "}
        for many guests. We provide
        <Link
          to={`/services/book-taxi-sydney-airport`}
          className="underline font-semibold px-1"
        >
          Airport Transfers in Sutherland
        </Link>{" "}
        with live flight tracking, Maxi Cab Services fitting up to eleven
        passengers,
        <Link
          to={`/services/baby-seat-taxi-sydney`}
          className="underline font-semibold px-1"
        >
          Baby Seat Taxi
        </Link>{" "}
        options with certified restraints, and Local Taxi Service for daily
        tasks. Business people rely on our Corporate Taxi Service, while those
        wanting luxury choose our Premium Service. We specialise in Wedding
        Transport,
        <Link
          to={`/services/event-transfer`}
          className="underline font-semibold px-1"
        >
          Event Transport,
        </Link>{" "}
        Cruise Transfers, Group Transport for large parties, and
        <Link
          to={`/services/wheelchair-accessible-taxi`}
          className="underline font-semibold px-1"
        >
          Wheelchair Accessible Taxi
        </Link>{" "}
        services. Every trip includes clear upfront pricing, real 24/7
        availability, and experienced local drivers who know Sutherland well. From
        Door-to-Door Taxi Service to complex plans, Campbelltown Taxi & Maxi Cabs
        combines deep local knowledge with steady reliability—because your
        destination matters, and getting there should feel easy.
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle: "Taxi and Maxi Cab Solutions, Sutherland for Every Occasion",
    serviceSubtitle: (
      <>
        We adjust transport to match your needs. Our
        <Link to={`/`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs Services
        </Link>{" "}
        in Sutherland support family holidays, group outings, and business travel.
        Safety and punctuality guide everything we do. Every vehicle looks neat.
        Every driver trains well. You depend on us for airport trips, special
        events, and work journeys. Each ride stays simple and relaxed.
      </>
    ),
  
    cabChargeSectionTitle: "CabCharge Taxi Near Sutherland",
    cabChargeSectionDesctiption: (
      <>
        Need flexible payment for work or personal trips? Our
        <Link
          to={`/cabcharge-taxi`}
          className="underline font-semibold px-1"
        >
          CabCharge Taxi Service in Sutherland
        </Link>
        makes every journey simple and trackable. We accept secure CabCharge
        Payments, including the handy CabCharge Card, perfect for company
        travellers and approved users. Enjoy cashless payments, clear trip
        records, and easy billing every time. Dependable transport backed by
        trusted Cabcharge payment options.
      </>
    ),
  
    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            Travel in roomy vehicles. Bridal parties, relatives, and guests enjoy
            nice, comfortable rides to and from venues.
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },
  
      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            Pick our luxury option for VIP transfers, executive travel, and
            clients wanting more privacy and comfort.
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },
  
      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Families book cars with approved child seats. Young passengers stay
            safe throughout the trip.
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },
  
      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            Made for meetings and group business travel. On-time pickups help
            busy schedules.
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },
  
      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Enjoy easy trips between Sutherland and cruise terminals. Plenty of
            space handles passengers and luggage together.
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },
  
      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            Use our service for concerts, parties, and social gatherings. Arrive
            on time. Avoid parking problems.
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },
  
      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            Ideal for larger groups in Sutherland. Roomy seating and luggage space
            keep everyone together.
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },
  
      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            Safe, well-organised transfers from Sutherland to Sydney Airport or
            business locations. Your team travels without worry.
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },
  
      S009: {
        service_id: "S009",
        title: "Reliable Airport Transfers",
        description: (
          <>
            Reliable 24/7 option across Sutherland for everyday trips,
            appointments, and leisure activities.
          </>
        ),
        image: "/airport.png",
        pathname: "/services/taxi-sydney-service",
      },
  
      S010: {
        service_id: "S010",
        title: "Emergency Taxi",
        description: (
          <>
            Urgent need? Our Emergency Taxi in Sutherland responds fast. We put
            your safety and speed first.
          </>
        ),
        image: "/emergency.png",
        pathname: "/book-a-taxi",
      },
    },
  
    fleetSectionTitle: "Premium Fleet for Your Sutherland Transfer",
    fleetSectionSubTitle: (
      <>
        Choose from different vehicles matching your group size and comfort
        needs.
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Our fleet
        </Link>{" "}
        focuses on safety, space, and smooth rides. Solo travellers find good
        matches. Full groups get suitable options too.
      </>
    ),
  
    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Perfect for single riders or couples wanting quiet, comfortable trips
            with our reliable Door-to-Door Taxi Service throughout Sutherland.
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },
  
      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Great for VIPs and business guests who value privacy, quality leather
            seats, and smart presentation on every trip.
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },
  
      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            Extra room for passengers and luggage. Good choice for families or
            small groups heading to Sydney Airport with comfort.
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },
  
      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Fits 6–7 passengers comfortably. Large luggage capacity suits group
            transfers, family holidays, and longer trips.
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },
  
      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Built for bigger groups or large families wanting spacious, clean
            interiors and a fully relaxed travel experience together.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
  
      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Provides accessible transport with properly trained drivers and the
            right safety features for all mobility needs and comfort.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },
  
    faqSectionTitle:
      "Frequently Asked Questions About Taxi Service in Sutherland",
    faqs: [
      {
        question: "Which coastal spots near Sutherland do you cover?",
        answer: (
          <>
            We service Sutherland Beach, Freshwater, and Dee Why. Surf trips
            welcome. Boards fit in <Link
          to={`https://en.wikipedia.org/wiki/Maxi_taxi`}
          className="underline font-semibold px-1"
          target="_blank"
        >Maxi
        </Link> cabs. Beach transport sorted.
          </>
        ),
      },
      {
        question: "How do I arrange transport from Sutherland to Manly Wharf?",
        answer: (
          <>
            Ring 1300 450 428. Short trips our specialty. Ferry connections are
            timed. Quick, reliable service every time.
          </>
        ),
      },
      {
        question: "Can I book a maxi cab for Sutherland surf club functions?",
        answer: (
          <>
            Yes. We carry surfboards, gear, and teams. Nippers' events covered.
            Beach transport expertise guaranteed.
          </>
        ),
      },
      {
        question: "Do your drivers know ways around Pittwater Road congestion?",
        answer: (
          <>
            Absolutely. Northern Beaches locals. Traffic hotspots avoided. Back
            streets mastered. You get smart navigators.
          </>
        ),
      },
      {
        question: "What if I need a taxi for the Sutherland dawn patrol surfing?",
        answer: (
          <>
            Early surf trips welcome. 4 AM pickups arranged. Wetsuit-friendly
            vehicles. Your wave chase is supported.
          </>
        ),
      },
      {
        question: "Can I ask for the same driver for regular Sutherland trips?",
        answer: (
          <>
            Request when booking. Preferences noted. Same driver when possible.
            Relationship builds over time.
          </>
        ),
      },
      {
        question: "How do I organise wheelchair transport to Sutherland Beach?",
        answer: (
          <>
            State needs when calling. Beach access vehicles are available. Help
            provided. Inclusion matters to us.
          </>
        ),
      },
      {
        question: "Are your Sutherland taxis pet-friendly for vet visits?",
        answer: (
          <>
            Small pets in carriers are accepted. Harbord Vet trips are common.
            Service animals are always welcome. Mention when booking.
          </>
        ),
      },
      {
        question: "Can I set up account billing for Sutherland business travel?",
        answer: (
          <>
            Corporate accounts available. Monthly statements. Priority bookings.
            Expense management simplified.
          </>
        ),
      },
      {
        question: "What sets you apart from rideshare apps in Sutherland?",
        answer: (
          <>
            Phone bookings. Fixed rates. Local knowledge. No surge pricing.
            Personal service every trip.
          </>
        ),
      },
      {
        question: "Do you provide Sutherland to Sutherland direct trips?",
        answer: (
          <>
            Yes. Northern Beaches peninsula runs. Scenic coastal route. Fixed
            prices available. Comfortable journey.
          </>
        ),
      },
      {
        question: "How early should I book wedding cars for Sutherland ceremonies?",
        answer: (
          <>
            Secure months ahead. Beach weddings are popular. Multiple vehicles
            coordinated. Your special day is perfected.
          </>
        ),
      },
      {
        question: "Can I pay with CabCharge for Sutherland airport transfers?",
        answer: (
          <>
            CabCharge welcome. Corporate cards accepted. Cash and EFTPOS too.
            Flexible payment options.
          </>
        ),
      },
      {
        question: "What happens if my flight arrives early at Sydney Airport?",
        answer: (
          <>
            Live tracking is active. The driver adjusts the pickup. No waiting
            fees. Seamless collection guaranteed.
          </>
        ),
      },
      {
        question: "Do you service all Sutherland streets including beachside lanes?",
        answer: (
          <>
            Yes. Every address found. Narrow lanes navigated. Beachfront pickups
            arranged. No confusion.
          </>
        ),
      },
    ],
  },
"miranda-nsw": {
  mapUrl:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d26450.735390441856!2d151.05491085!3d-34.0350992!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12b84572e5978d%3A0x5017d681632c180!2sMiranda%20NSW%202228%2C%20Australia!5e0!3m2!1sen!2sbd!4v1774724306476!5m2!1sen!2sbd",
  pageTitle:
    "Taxi & Maxi Cabs Services in Miranda, NSW - Family & Local Travel Experts",
  metaDescription:
    "Book Taxi & Maxi Cabs Services in Miranda for family travel, local trips & cruise transfers. Trusted drivers, baby seat options & fixed pricing available. Book now!",
  heroTitle:
    "24/7 Taxi & Maxi Cabs Services in Miranda for Fast & Safe Travel",
  heroDescription: (
    <>
      Need dependable rides around Miranda? Our
      <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
        Taxi & Maxi Cabs Services
      </Link>
      in Miranda deliver quick pickups every time you call. We handle your
      local trips with sharp timing that never fails. Our vehicles fit single
      travellers and large groups equally well. You get plenty of cabin space
      for people and luggage together. No one gets left out or squeezed inside.
      We run day and night without stopping. Your flight might land at 2 AM.
      Your shift could end at sunrise. Either way, we show up fast. Choose our
      luxury option for extra comfort. We manage smooth Miranda pick up and
      drop off to keep your schedule on track. You avoid delays. You skip
      stress.
      <Link to={`/`} className="underline font-semibold px-1">
        Campbelltown Taxi Cabs
      </Link>{" "}
      puts your timetable first always.
    </>
  ),
  bookingFormTitle: "Book Baby Taxi in Miranda NSW",
  locationSectionTitle: "Reliable Taxi Service in Miranda for Groups",
  locationSectionDescription: (
    <>
      Taking family or friends somewhere nice? Our Miranda Taxi Service suits
      small and large groups perfectly. Everyone travels together in one car.
      You miss the hassle of splitting into different vehicles. You avoid
      confusing planning. Through our dedicated
      <Link
        to={`/services/maxi-taxi-service`}
        className="underline font-semibold px-1"
      >
        Maxi Cab Services in Miranda,
      </Link>
      each person enjoys safe, comfortable travel. Maybe you leave Miranda
      for Sydney Airport. Maybe you head home after long trips. We keep our
      promises on timing. Our drivers know the best routes. They avoid traffic
      jams. They cut the waiting time. You can trust our Group Transport Curl
      Curl options when you need space, reliability, and clean cars. Booking
      takes seconds through our online system. You get confirmation quickly.
      You travel with confidence.
    </>
  ),
  locationSection2Title:
    "Affordable Taxi Service in Miranda with Maxi Cabs: safe and 24/7 transport",
  locationSection2Desctiption: (
    <>
      We believe cheap should never mean uncomfortable. Our
      <Link
        to={`/book-a-taxi`}
        className="underline font-semibold px-1"
      >
        Local Taxi Service
      </Link>
      in Miranda offers fair prices with full clarity. You see the cost
      before booking. You plan your budget with assurance. This helps when
      travelling with others. You can book a
      <Link
        to={`/services/maxi-taxi-service`}
        className="underline font-semibold px-1"
      >
        Maxi Cab for Group Travel
      </Link>{" "}
      that carries many passengers plus bags. Want something better? Upgrade to
      our premium service for nicer travel. Families can ask for
      <Link
        to={`/services/baby-seat-taxi-sydney`}
        className="underline font-semibold px-1"
      >
        Baby Seat Taxi
      </Link>{" "}
      options. Your children ride in approved, properly fitted seats. Our
      drivers have experience and manners. They help with special needs. They
      assist with luggage. From early flights to late arrivals, our 24/7 Taxi
      Miranda keeps you moving. Campbelltown{" "}
      <Link
        to={`/book-a-taxi`}
        className="underline font-semibold px-1"
      >
        Taxi & Maxi Cabs
      </Link>{" "}
      promises safe, reliable, stress-free transport for every customer.
    </>
  ),
  locationSection3Title:
    "Comfortable Corporate & Baby Seat Taxi Booking in Miranda",
  locationSection3Description: (
    <>
      Our
      <Link
        to={`/book-a-taxi`}
        className="underline font-semibold px-1"
      >
        Taxi Service in Miranda
      </Link>{" "}
      gives you lots of legroom. You get plenty of luggage space. You relax
      even when the car is full. You avoid tight seating. You miss awkward bag
      packing. Your trip becomes pleasant. Choosing our Taxi & Maxi Cabs
      Services in Miranda lets your group focus on the journey. We specialise
      in group transfers for families, sports teams, and work groups. Everyone
      arrives together. Booking is fast through our Miranda Cab Booking page.
      You arrange transport early. Business travellers can use our
      <Link
        to={`/services/corporate-tips`}
        className="underline font-semibold px-1"
      >
        Corporate Taxi Service
      </Link>{" "}
      for on-time, professional rides to meetings. Families add Baby Seat Taxi
      options for safer trips with young children. When style matters, our
      premium service gives extra comfort. Every car gets cleaned regularly. We
      keep high standards. You enjoy smooth, safe travel without traffic
      worries.
    </>
  ),
  locationSection4Title:
    "Reliable Miranda Taxi & Maxi Cab: Premium Solutions for All Your Travel Needs",
  locationSection4Desctiption: (
    <>
      Find professional transport made for Miranda residents and visitors.
      Our full range gives you exactly what you need, whether catching early
      flights or arranging
      <Link
        to={`/services/wedding-transfer`}
        className="underline font-semibold px-1"
      >
        wedding transport
      </Link>{" "}
      for many guests. We provide
      <Link
        to={`/services/book-taxi-sydney-airport`}
        className="underline font-semibold px-1"
      >
        Airport Transfers in Miranda
      </Link>{" "}
      with live flight tracking, Maxi Cab Services fitting up to eleven
      passengers,
      <Link
        to={`/services/baby-seat-taxi-sydney`}
        className="underline font-semibold px-1"
      >
        Baby Seat Taxi
      </Link>{" "}
      options with certified restraints, and Local Taxi Service for daily
      tasks. Business people rely on our Corporate Taxi Service, while those
      wanting luxury choose our Premium Service. We specialise in Wedding
      Transport,
      <Link
        to={`/services/event-transfer`}
        className="underline font-semibold px-1"
      >
        Event Transport,
      </Link>{" "}
      Cruise Transfers, Group Transport for large parties, and
      <Link
        to={`/services/wheelchair-accessible-taxi`}
        className="underline font-semibold px-1"
      >
        Wheelchair Accessible Taxi
      </Link>{" "}
      services. Every trip includes clear upfront pricing, real 24/7
      availability, and experienced local drivers who know Miranda well. From
      Door-to-Door Taxi Service to complex plans, Campbelltown Taxi & Maxi Cabs
      combines deep local knowledge with steady reliability—because your
      destination matters, and getting there should feel easy.
    </>
  ),
  locationSectionImg: corporateTripsImg,
  serviceTitle: "Taxi and Maxi Cab Solutions, Miranda for Every Occasion",
  serviceSubtitle: (
    <>
      We adjust transport to match your needs. Our
      <Link to={`/`} className="underline font-semibold px-1">
        Taxi & Maxi Cabs Services
      </Link>{" "}
      in Miranda support family holidays, group outings, and business travel.
      Safety and punctuality guide everything we do. Every vehicle looks neat.
      Every driver trains well. You depend on us for airport trips, special
      events, and work journeys. Each ride stays simple and relaxed.
    </>
  ),

  cabChargeSectionTitle: "CabCharge Taxi Near Miranda",
  cabChargeSectionDesctiption: (
    <>
      Need flexible payment for work or personal trips? Our
      <Link
        to={`/cabcharge-taxi`}
        className="underline font-semibold px-1"
      >
        CabCharge Taxi Service in Miranda
      </Link>
      makes every journey simple and trackable. We accept secure CabCharge
      Payments, including the handy CabCharge Card, perfect for company
      travellers and approved users. Enjoy cashless payments, clear trip
      records, and easy billing every time. Dependable transport backed by
      trusted Cabcharge payment options.
    </>
  ),

  locationServices: {
    S001: {
      service_id: "S001",
      title: "Wedding Transfer",
      description: (
        <>
          Travel in roomy vehicles. Bridal parties, relatives, and guests enjoy
          nice, comfortable rides to and from venues.
        </>
      ),
      image: "/car.png",
      pathname: "/services/wedding-transfer",
    },

    S002: {
      service_id: "S002",
      title: "Luxury Transfer",
      description: (
        <>
          Pick our luxury option for VIP transfers, executive travel, and
          clients wanting more privacy and comfort.
        </>
      ),
      image: "/vehicle.png",
      pathname: "/services/luxury-transfer",
    },

    S003: {
      service_id: "S003",
      title: "Baby Seat Taxi Sydney",
      description: (
        <>
          Families book cars with approved child seats. Young passengers stay
          safe throughout the trip.
        </>
      ),
      image: "/baby-seat.png",
      pathname: "/services/baby-seat-taxi-sydney",
    },

    S004: {
      service_id: "S004",
      title: "Corporate Transport Services",
      description: (
        <>
          Made for meetings and group business travel. On-time pickups help
          busy schedules.
        </>
      ),
      image: "/corporate.png",
      pathname: "/services/corporate-transport-services",
    },

    S005: {
      service_id: "S005",
      title: "Cruise Terminal Transfer",
      description: (
        <>
          Enjoy easy trips between Miranda and cruise terminals. Plenty of
          space handles passengers and luggage together.
        </>
      ),
      image: "/ship.png",
      pathname: "/services/cruise-terminal-transfer",
    },

    S006: {
      service_id: "S006",
      title: "Event Transfer",
      description: (
        <>
          Use our service for concerts, parties, and social gatherings. Arrive
          on time. Avoid parking problems.
        </>
      ),
      image: "/event.png",
      pathname: "/services/event-transfer",
    },

    S007: {
      service_id: "S007",
      title: "Maxi Taxi Service",
      description: (
        <>
          Ideal for larger groups in Miranda. Roomy seating and luggage space
          keep everyone together.
        </>
      ),
      image: "/users.png",
      pathname: "/services/maxi-taxi-service",
    },

    S008: {
      service_id: "S008",
      title: "Corporate Trips",
      description: (
        <>
          Safe, well-organised transfers from Miranda to Sydney Airport or
          business locations. Your team travels without worry.
        </>
      ),
      image: "/briefcase.png",
      pathname: "/services/corporate-tips",
    },

    S009: {
      service_id: "S009",
      title: "Reliable Airport Transfers",
      description: (
        <>
          Reliable 24/7 option across Miranda for everyday trips,
          appointments, and leisure activities.
        </>
      ),
      image: "/airport.png",
      pathname: "/services/taxi-sydney-service",
    },

    S010: {
      service_id: "S010",
      title: "Emergency Taxi",
      description: (
        <>
          Urgent need? Our Emergency Taxi in Miranda responds fast. We put
          your safety and speed first.
        </>
      ),
      image: "/emergency.png",
      pathname: "/book-a-taxi",
    },
  },

  fleetSectionTitle: "Premium Fleet for Your Miranda Transfer",
  fleetSectionSubTitle: (
    <>
      Choose from different vehicles matching your group size and comfort
      needs.
      <Link
        to={`/services/maxi-taxi-service`}
        className="underline font-semibold px-1"
      >
        Our fleet
      </Link>{" "}
      focuses on safety, space, and smooth rides. Solo travellers find good
      matches. Full groups get suitable options too.
    </>
  ),

  fleetSectionVehicles: {
    1: {
      id: 1,
      name: "Easy Sedan",
      passengerCapacity: 4,
      bagsCapacity: 2,
      description: (
        <>
          Perfect for single riders or couples wanting quiet, comfortable trips
          with our reliable Door-to-Door Taxi Service throughout Miranda.
        </>
      ),
      image: "/campbelltown-easy-sedan.png",
    },

    2: {
      id: 2,
      name: "Luxury Vehicle",
      passengerCapacity: 4,
      bagsCapacity: 2,
      description: (
        <>
          Great for VIPs and business guests who value privacy, quality leather
          seats, and smart presentation on every trip.
        </>
      ),
      image: "/campbelltown-luxury-vehicle.png",
    },

    3: {
      id: 3,
      name: "Suv or Wagon",
      passengerCapacity: 7,
      bagsCapacity: 5,
      description: (
        <>
          Extra room for passengers and luggage. Good choice for families or
          small groups heading to Sydney Airport with comfort.
        </>
      ),
      image: "/campbelltown-suv-wagon.png",
    },

    4: {
      id: 4,
      name: "Kia Carnival",
      passengerCapacity: 7,
      bagsCapacity: 8,
      description: (
        <>
          Fits 6–7 passengers comfortably. Large luggage capacity suits group
          transfers, family holidays, and longer trips.
        </>
      ),
      image: "/campbelltown-kia-carnival.png",
    },

    5: {
      id: 5,
      name: "Maxi Taxi",
      passengerCapacity: 11,
      bagsCapacity: 8,
      description: (
        <>
          Built for bigger groups or large families wanting spacious, clean
          interiors and a fully relaxed travel experience together.
        </>
      ),
      image: "/campbelltown-maxi-taxi.png",
    },

    6: {
      id: 6,
      name: "Wheelchair Taxi Service",
      passengerCapacity: 7,
      bagsCapacity: 8,
      description: (
        <>
          Provides accessible transport with properly trained drivers and the
          right safety features for all mobility needs and comfort.
        </>
      ),
      image: "/campbelltown-maxi-taxi.png",
    },
  },

  faqSectionTitle:
    "Frequently Asked Questions About Taxi Service in Miranda",
  faqs: [
    {
      question: "Which coastal spots near Miranda do you cover?",
      answer: (
        <>
          We service Miranda Beach, Freshwater, and Dee Why. Surf trips
          welcome. Boards fit in <Link
        to={`https://en.wikipedia.org/wiki/Maxi_taxi`}
        className="underline font-semibold px-1"
        target="_blank"
      >Maxi
      </Link> cabs. Beach transport sorted.
        </>
      ),
    },
    {
      question: "How do I arrange transport from Miranda to Manly Wharf?",
      answer: (
        <>
          Ring 1300 450 428. Short trips our specialty. Ferry connections are
          timed. Quick, reliable service every time.
        </>
      ),
    },
    {
      question: "Can I book a maxi cab for Miranda surf club functions?",
      answer: (
        <>
          Yes. We carry surfboards, gear, and teams. Nippers' events covered.
          Beach transport expertise guaranteed.
        </>
      ),
    },
    {
      question: "Do your drivers know ways around Pittwater Road congestion?",
      answer: (
        <>
          Absolutely. Northern Beaches locals. Traffic hotspots avoided. Back
          streets mastered. You get smart navigators.
        </>
      ),
    },
    {
      question: "What if I need a taxi for the Miranda dawn patrol surfing?",
      answer: (
        <>
          Early surf trips welcome. 4 AM pickups arranged. Wetsuit-friendly
          vehicles. Your wave chase is supported.
        </>
      ),
    },
    {
      question: "Can I ask for the same driver for regular Miranda trips?",
      answer: (
        <>
          Request when booking. Preferences noted. Same driver when possible.
          Relationship builds over time.
        </>
      ),
    },
    {
      question: "How do I organise wheelchair transport to Miranda Beach?",
      answer: (
        <>
          State needs when calling. Beach access vehicles are available. Help
          provided. Inclusion matters to us.
        </>
      ),
    },
    {
      question: "Are your Miranda taxis pet-friendly for vet visits?",
      answer: (
        <>
          Small pets in carriers are accepted. Harbord Vet trips are common.
          Service animals are always welcome. Mention when booking.
        </>
      ),
    },
    {
      question: "Can I set up account billing for Miranda business travel?",
      answer: (
        <>
          Corporate accounts available. Monthly statements. Priority bookings.
          Expense management simplified.
        </>
      ),
    },
    {
      question: "What sets you apart from rideshare apps in Miranda?",
      answer: (
        <>
          Phone bookings. Fixed rates. Local knowledge. No surge pricing.
          Personal service every trip.
        </>
      ),
    },
    {
      question: "Do you provide Miranda to Miranda direct trips?",
      answer: (
        <>
          Yes. Northern Beaches peninsula runs. Scenic coastal route. Fixed
          prices available. Comfortable journey.
        </>
      ),
    },
    {
      question: "How early should I book wedding cars for Miranda ceremonies?",
      answer: (
        <>
          Secure months ahead. Beach weddings are popular. Multiple vehicles
          coordinated. Your special day is perfected.
        </>
      ),
    },
    {
      question: "Can I pay with CabCharge for Miranda airport transfers?",
      answer: (
        <>
          CabCharge welcome. Corporate cards accepted. Cash and EFTPOS too.
          Flexible payment options.
        </>
      ),
    },
    {
      question: "What happens if my flight arrives early at Sydney Airport?",
      answer: (
        <>
          Live tracking is active. The driver adjusts the pickup. No waiting
          fees. Seamless collection guaranteed.
        </>
      ),
    },
    {
      question: "Do you service all Miranda streets including beachside lanes?",
      answer: (
        <>
          Yes. Every address found. Narrow lanes navigated. Beachfront pickups
          arranged. No confusion.
        </>
      ),
    },
  ],
},
"caringbah-nsw": {
  mapUrl:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d26451.339893397253!2d151.10504690000002!3d-34.033160399999986!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12c7f6b253e00d%3A0x5017d681632afc0!2sCaringbah%20NSW%202229%2C%20Australia!5e0!3m2!1sen!2sbd!4v1774724343275!5m2!1sen!2sbd",
  pageTitle:
    "Taxi & Maxi Cabs Services in Caringbah, NSW - Family & Local Travel Experts",
  metaDescription:
    "Book Taxi & Maxi Cabs Services in Caringbah for family travel, local trips & cruise transfers. Trusted drivers, baby seat options & fixed pricing available. Book now!",
  heroTitle:
    "24/7 Taxi & Maxi Cabs Services in Caringbah for Fast & Safe Travel",
  heroDescription: (
    <>
      Need dependable rides around Caringbah? Our
      <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
        Taxi & Maxi Cabs Services
      </Link>
      in Caringbah deliver quick pickups every time you call. We handle your
      local trips with sharp timing that never fails. Our vehicles fit single
      travellers and large groups equally well. You get plenty of cabin space
      for people and luggage together. No one gets left out or squeezed inside.
      We run day and night without stopping. Your flight might land at 2 AM.
      Your shift could end at sunrise. Either way, we show up fast. Choose our
      luxury option for extra comfort. We manage smooth Caringbah pick up and
      drop off to keep your schedule on track. You avoid delays. You skip
      stress.
      <Link to={`/`} className="underline font-semibold px-1">
        Campbelltown Taxi Cabs
      </Link>{" "}
      puts your timetable first always.
    </>
  ),
  bookingFormTitle: "Book Baby Taxi in Caringbah NSW",
  locationSectionTitle: "Reliable Taxi Service in Caringbah for Groups",
  locationSectionDescription: (
    <>
      Taking family or friends somewhere nice? Our Caringbah Taxi Service suits
      small and large groups perfectly. Everyone travels together in one car.
      You miss the hassle of splitting into different vehicles. You avoid
      confusing planning. Through our dedicated
      <Link
        to={`/services/maxi-taxi-service`}
        className="underline font-semibold px-1"
      >
        Maxi Cab Services in Caringbah,
      </Link>
      each person enjoys safe, comfortable travel. Maybe you leave Caringbah
      for Sydney Airport. Maybe you head home after long trips. We keep our
      promises on timing. Our drivers know the best routes. They avoid traffic
      jams. They cut the waiting time. You can trust our Group Transport Curl
      Curl options when you need space, reliability, and clean cars. Booking
      takes seconds through our online system. You get confirmation quickly.
      You travel with confidence.
    </>
  ),
  locationSection2Title:
    "Affordable Taxi Service in Caringbah with Maxi Cabs: safe and 24/7 transport",
  locationSection2Desctiption: (
    <>
      We believe cheap should never mean uncomfortable. Our
      <Link
        to={`/book-a-taxi`}
        className="underline font-semibold px-1"
      >
        Local Taxi Service
      </Link>
      in Caringbah offers fair prices with full clarity. You see the cost
      before booking. You plan your budget with assurance. This helps when
      travelling with others. You can book a
      <Link
        to={`/services/maxi-taxi-service`}
        className="underline font-semibold px-1"
      >
        Maxi Cab for Group Travel
      </Link>{" "}
      that carries many passengers plus bags. Want something better? Upgrade to
      our premium service for nicer travel. Families can ask for
      <Link
        to={`/services/baby-seat-taxi-sydney`}
        className="underline font-semibold px-1"
      >
        Baby Seat Taxi
      </Link>{" "}
      options. Your children ride in approved, properly fitted seats. Our
      drivers have experience and manners. They help with special needs. They
      assist with luggage. From early flights to late arrivals, our 24/7 Taxi
      Caringbah keeps you moving. Campbelltown{" "}
      <Link
        to={`/book-a-taxi`}
        className="underline font-semibold px-1"
      >
        Taxi & Maxi Cabs
      </Link>{" "}
      promises safe, reliable, stress-free transport for every customer.
    </>
  ),
  locationSection3Title:
    "Comfortable Corporate & Baby Seat Taxi Booking in Caringbah",
  locationSection3Description: (
    <>
      Our
      <Link
        to={`/book-a-taxi`}
        className="underline font-semibold px-1"
      >
        Taxi Service in Caringbah
      </Link>{" "}
      gives you lots of legroom. You get plenty of luggage space. You relax
      even when the car is full. You avoid tight seating. You miss awkward bag
      packing. Your trip becomes pleasant. Choosing our Taxi & Maxi Cabs
      Services in Caringbah lets your group focus on the journey. We specialise
      in group transfers for families, sports teams, and work groups. Everyone
      arrives together. Booking is fast through our Caringbah Cab Booking page.
      You arrange transport early. Business travellers can use our
      <Link
        to={`/services/corporate-tips`}
        className="underline font-semibold px-1"
      >
        Corporate Taxi Service
      </Link>{" "}
      for on-time, professional rides to meetings. Families add Baby Seat Taxi
      options for safer trips with young children. When style matters, our
      premium service gives extra comfort. Every car gets cleaned regularly. We
      keep high standards. You enjoy smooth, safe travel without traffic
      worries.
    </>
  ),
  locationSection4Title:
    "Reliable Caringbah Taxi & Maxi Cab: Premium Solutions for All Your Travel Needs",
  locationSection4Desctiption: (
    <>
      Find professional transport made for Caringbah residents and visitors.
      Our full range gives you exactly what you need, whether catching early
      flights or arranging
      <Link
        to={`/services/wedding-transfer`}
        className="underline font-semibold px-1"
      >
        wedding transport
      </Link>{" "}
      for many guests. We provide
      <Link
        to={`/services/book-taxi-sydney-airport`}
        className="underline font-semibold px-1"
      >
        Airport Transfers in Caringbah
      </Link>{" "}
      with live flight tracking, Maxi Cab Services fitting up to eleven
      passengers,
      <Link
        to={`/services/baby-seat-taxi-sydney`}
        className="underline font-semibold px-1"
      >
        Baby Seat Taxi
      </Link>{" "}
      options with certified restraints, and Local Taxi Service for daily
      tasks. Business people rely on our Corporate Taxi Service, while those
      wanting luxury choose our Premium Service. We specialise in Wedding
      Transport,
      <Link
        to={`/services/event-transfer`}
        className="underline font-semibold px-1"
      >
        Event Transport,
      </Link>{" "}
      Cruise Transfers, Group Transport for large parties, and
      <Link
        to={`/services/wheelchair-accessible-taxi`}
        className="underline font-semibold px-1"
      >
        Wheelchair Accessible Taxi
      </Link>{" "}
      services. Every trip includes clear upfront pricing, real 24/7
      availability, and experienced local drivers who know Caringbah well. From
      Door-to-Door Taxi Service to complex plans, Campbelltown Taxi & Maxi Cabs
      combines deep local knowledge with steady reliability—because your
      destination matters, and getting there should feel easy.
    </>
  ),
  locationSectionImg: corporateTripsImg,
  serviceTitle: "Taxi and Maxi Cab Solutions, Caringbah for Every Occasion",
  serviceSubtitle: (
    <>
      We adjust transport to match your needs. Our
      <Link to={`/`} className="underline font-semibold px-1">
        Taxi & Maxi Cabs Services
      </Link>{" "}
      in Caringbah support family holidays, group outings, and business travel.
      Safety and punctuality guide everything we do. Every vehicle looks neat.
      Every driver trains well. You depend on us for airport trips, special
      events, and work journeys. Each ride stays simple and relaxed.
    </>
  ),

  cabChargeSectionTitle: "CabCharge Taxi Near Caringbah",
  cabChargeSectionDesctiption: (
    <>
      Need flexible payment for work or personal trips? Our
      <Link
        to={`/cabcharge-taxi`}
        className="underline font-semibold px-1"
      >
        CabCharge Taxi Service in Caringbah
      </Link>
      makes every journey simple and trackable. We accept secure CabCharge
      Payments, including the handy CabCharge Card, perfect for company
      travellers and approved users. Enjoy cashless payments, clear trip
      records, and easy billing every time. Dependable transport backed by
      trusted Cabcharge payment options.
    </>
  ),

  locationServices: {
    S001: {
      service_id: "S001",
      title: "Wedding Transfer",
      description: (
        <>
          Travel in roomy vehicles. Bridal parties, relatives, and guests enjoy
          nice, comfortable rides to and from venues.
        </>
      ),
      image: "/car.png",
      pathname: "/services/wedding-transfer",
    },

    S002: {
      service_id: "S002",
      title: "Luxury Transfer",
      description: (
        <>
          Pick our luxury option for VIP transfers, executive travel, and
          clients wanting more privacy and comfort.
        </>
      ),
      image: "/vehicle.png",
      pathname: "/services/luxury-transfer",
    },

    S003: {
      service_id: "S003",
      title: "Baby Seat Taxi Sydney",
      description: (
        <>
          Families book cars with approved child seats. Young passengers stay
          safe throughout the trip.
        </>
      ),
      image: "/baby-seat.png",
      pathname: "/services/baby-seat-taxi-sydney",
    },

    S004: {
      service_id: "S004",
      title: "Corporate Transport Services",
      description: (
        <>
          Made for meetings and group business travel. On-time pickups help
          busy schedules.
        </>
      ),
      image: "/corporate.png",
      pathname: "/services/corporate-transport-services",
    },

    S005: {
      service_id: "S005",
      title: "Cruise Terminal Transfer",
      description: (
        <>
          Enjoy easy trips between Caringbah and cruise terminals. Plenty of
          space handles passengers and luggage together.
        </>
      ),
      image: "/ship.png",
      pathname: "/services/cruise-terminal-transfer",
    },

    S006: {
      service_id: "S006",
      title: "Event Transfer",
      description: (
        <>
          Use our service for concerts, parties, and social gatherings. Arrive
          on time. Avoid parking problems.
        </>
      ),
      image: "/event.png",
      pathname: "/services/event-transfer",
    },

    S007: {
      service_id: "S007",
      title: "Maxi Taxi Service",
      description: (
        <>
          Ideal for larger groups in Caringbah. Roomy seating and luggage space
          keep everyone together.
        </>
      ),
      image: "/users.png",
      pathname: "/services/maxi-taxi-service",
    },

    S008: {
      service_id: "S008",
      title: "Corporate Trips",
      description: (
        <>
          Safe, well-organised transfers from Caringbah to Sydney Airport or
          business locations. Your team travels without worry.
        </>
      ),
      image: "/briefcase.png",
      pathname: "/services/corporate-tips",
    },

    S009: {
      service_id: "S009",
      title: "Reliable Airport Transfers",
      description: (
        <>
          Reliable 24/7 option across Caringbah for everyday trips,
          appointments, and leisure activities.
        </>
      ),
      image: "/airport.png",
      pathname: "/services/taxi-sydney-service",
    },

    S010: {
      service_id: "S010",
      title: "Emergency Taxi",
      description: (
        <>
          Urgent need? Our Emergency Taxi in Caringbah responds fast. We put
          your safety and speed first.
        </>
      ),
      image: "/emergency.png",
      pathname: "/book-a-taxi",
    },
  },

  fleetSectionTitle: "Premium Fleet for Your Caringbah Transfer",
  fleetSectionSubTitle: (
    <>
      Choose from different vehicles matching your group size and comfort
      needs.
      <Link
        to={`/services/maxi-taxi-service`}
        className="underline font-semibold px-1"
      >
        Our fleet
      </Link>{" "}
      focuses on safety, space, and smooth rides. Solo travellers find good
      matches. Full groups get suitable options too.
    </>
  ),

  fleetSectionVehicles: {
    1: {
      id: 1,
      name: "Easy Sedan",
      passengerCapacity: 4,
      bagsCapacity: 2,
      description: (
        <>
          Perfect for single riders or couples wanting quiet, comfortable trips
          with our reliable Door-to-Door Taxi Service throughout Caringbah.
        </>
      ),
      image: "/campbelltown-easy-sedan.png",
    },

    2: {
      id: 2,
      name: "Luxury Vehicle",
      passengerCapacity: 4,
      bagsCapacity: 2,
      description: (
        <>
          Great for VIPs and business guests who value privacy, quality leather
          seats, and smart presentation on every trip.
        </>
      ),
      image: "/campbelltown-luxury-vehicle.png",
    },

    3: {
      id: 3,
      name: "Suv or Wagon",
      passengerCapacity: 7,
      bagsCapacity: 5,
      description: (
        <>
          Extra room for passengers and luggage. Good choice for families or
          small groups heading to Sydney Airport with comfort.
        </>
      ),
      image: "/campbelltown-suv-wagon.png",
    },

    4: {
      id: 4,
      name: "Kia Carnival",
      passengerCapacity: 7,
      bagsCapacity: 8,
      description: (
        <>
          Fits 6–7 passengers comfortably. Large luggage capacity suits group
          transfers, family holidays, and longer trips.
        </>
      ),
      image: "/campbelltown-kia-carnival.png",
    },

    5: {
      id: 5,
      name: "Maxi Taxi",
      passengerCapacity: 11,
      bagsCapacity: 8,
      description: (
        <>
          Built for bigger groups or large families wanting spacious, clean
          interiors and a fully relaxed travel experience together.
        </>
      ),
      image: "/campbelltown-maxi-taxi.png",
    },

    6: {
      id: 6,
      name: "Wheelchair Taxi Service",
      passengerCapacity: 7,
      bagsCapacity: 8,
      description: (
        <>
          Provides accessible transport with properly trained drivers and the
          right safety features for all mobility needs and comfort.
        </>
      ),
      image: "/campbelltown-maxi-taxi.png",
    },
  },

  faqSectionTitle:
    "Frequently Asked Questions About Taxi Service in Caringbah",
  faqs: [
    {
      question: "Which coastal spots near Caringbah do you cover?",
      answer: (
        <>
          We service Caringbah Beach, Freshwater, and Dee Why. Surf trips
          welcome. Boards fit in <Link
        to={`https://en.wikipedia.org/wiki/Maxi_taxi`}
        className="underline font-semibold px-1"
        target="_blank"
      >Maxi
      </Link> cabs. Beach transport sorted.
        </>
      ),
    },
    {
      question: "How do I arrange transport from Caringbah to Manly Wharf?",
      answer: (
        <>
          Ring 1300 450 428. Short trips our specialty. Ferry connections are
          timed. Quick, reliable service every time.
        </>
      ),
    },
    {
      question: "Can I book a maxi cab for Caringbah surf club functions?",
      answer: (
        <>
          Yes. We carry surfboards, gear, and teams. Nippers' events covered.
          Beach transport expertise guaranteed.
        </>
      ),
    },
    {
      question: "Do your drivers know ways around Pittwater Road congestion?",
      answer: (
        <>
          Absolutely. Northern Beaches locals. Traffic hotspots avoided. Back
          streets mastered. You get smart navigators.
        </>
      ),
    },
    {
      question: "What if I need a taxi for the Caringbah dawn patrol surfing?",
      answer: (
        <>
          Early surf trips welcome. 4 AM pickups arranged. Wetsuit-friendly
          vehicles. Your wave chase is supported.
        </>
      ),
    },
    {
      question: "Can I ask for the same driver for regular Caringbah trips?",
      answer: (
        <>
          Request when booking. Preferences noted. Same driver when possible.
          Relationship builds over time.
        </>
      ),
    },
    {
      question: "How do I organise wheelchair transport to Caringbah Beach?",
      answer: (
        <>
          State needs when calling. Beach access vehicles are available. Help
          provided. Inclusion matters to us.
        </>
      ),
    },
    {
      question: "Are your Caringbah taxis pet-friendly for vet visits?",
      answer: (
        <>
          Small pets in carriers are accepted. Harbord Vet trips are common.
          Service animals are always welcome. Mention when booking.
        </>
      ),
    },
    {
      question: "Can I set up account billing for Caringbah business travel?",
      answer: (
        <>
          Corporate accounts available. Monthly statements. Priority bookings.
          Expense management simplified.
        </>
      ),
    },
    {
      question: "What sets you apart from rideshare apps in Caringbah?",
      answer: (
        <>
          Phone bookings. Fixed rates. Local knowledge. No surge pricing.
          Personal service every trip.
        </>
      ),
    },
    {
      question: "Do you provide Miranda to Caringbah direct trips?",
      answer: (
        <>
          Yes. Northern Beaches peninsula runs. Scenic coastal route. Fixed
          prices available. Comfortable journey.
        </>
      ),
    },
    {
      question: "How early should I book wedding cars for Caringbah ceremonies?",
      answer: (
        <>
          Secure months ahead. Beach weddings are popular. Multiple vehicles
          coordinated. Your special day is perfected.
        </>
      ),
    },
    {
      question: "Can I pay with CabCharge for Caringbah airport transfers?",
      answer: (
        <>
          CabCharge welcome. Corporate cards accepted. Cash and EFTPOS too.
          Flexible payment options.
        </>
      ),
    },
    {
      question: "What happens if my flight arrives early at Sydney Airport?",
      answer: (
        <>
          Live tracking is active. The driver adjusts the pickup. No waiting
          fees. Seamless collection guaranteed.
        </>
      ),
    },
    {
      question: "Do you service all Caringbah streets including beachside lanes?",
      answer: (
        <>
          Yes. Every address found. Narrow lanes navigated. Beachfront pickups
          arranged. No confusion.
        </>
      ),
    },
  ],
},
"cronulla-nsw": {
  mapUrl:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d26450.55911294866!2d151.128717!3d-34.03566454999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12c81235d88f33%3A0x5017d681632b360!2sCronulla%20NSW%202230%2C%20Australia!5e0!3m2!1sen!2sbd!4v1774724448243!5m2!1sen!2sbd",
  pageTitle:
    "Taxi & Maxi Cabs Services in Cronulla, NSW - Family & Local Travel Experts",
  metaDescription:
    "Book Taxi & Maxi Cabs Services in Cronulla for family travel, local trips & cruise transfers. Trusted drivers, baby seat options & fixed pricing available. Book now!",
  heroTitle:
    "24/7 Taxi & Maxi Cabs Services in Cronulla for Fast & Safe Travel",
  heroDescription: (
    <>
      Need dependable rides around Cronulla? Our
      <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
        Taxi & Maxi Cabs Services
      </Link>
      in Cronulla deliver quick pickups every time you call. We handle your
      local trips with sharp timing that never fails. Our vehicles fit single
      travellers and large groups equally well. You get plenty of cabin space
      for people and luggage together. No one gets left out or squeezed inside.
      We run day and night without stopping. Your flight might land at 2 AM.
      Your shift could end at sunrise. Either way, we show up fast. Choose our
      luxury option for extra comfort. We manage smooth Cronulla pick up and
      drop off to keep your schedule on track. You avoid delays. You skip
      stress.
      <Link to={`/`} className="underline font-semibold px-1">
        Campbelltown Taxi Cabs
      </Link>{" "}
      puts your timetable first always.
    </>
  ),
  bookingFormTitle: "Book Baby Taxi in Cronulla NSW",
  locationSectionTitle: "Reliable Taxi Service in Cronulla for Groups",
  locationSectionDescription: (
    <>
      Taking family or friends somewhere nice? Our Cronulla Taxi Service suits
      small and large groups perfectly. Everyone travels together in one car.
      You miss the hassle of splitting into different vehicles. You avoid
      confusing planning. Through our dedicated
      <Link
        to={`/services/maxi-taxi-service`}
        className="underline font-semibold px-1"
      >
        Maxi Cab Services in Cronulla,
      </Link>
      each person enjoys safe, comfortable travel. Maybe you leave Cronulla
      for Sydney Airport. Maybe you head home after long trips. We keep our
      promises on timing. Our drivers know the best routes. They avoid traffic
      jams. They cut the waiting time. You can trust our Group Transport Curl
      Curl options when you need space, reliability, and clean cars. Booking
      takes seconds through our online system. You get confirmation quickly.
      You travel with confidence.
    </>
  ),
  locationSection2Title:
    "Affordable Taxi Service in Cronulla with Maxi Cabs: safe and 24/7 transport",
  locationSection2Desctiption: (
    <>
      We believe cheap should never mean uncomfortable. Our
      <Link
        to={`/book-a-taxi`}
        className="underline font-semibold px-1"
      >
        Local Taxi Service
      </Link>
      in Cronulla offers fair prices with full clarity. You see the cost
      before booking. You plan your budget with assurance. This helps when
      travelling with others. You can book a
      <Link
        to={`/services/maxi-taxi-service`}
        className="underline font-semibold px-1"
      >
        Maxi Cab for Group Travel
      </Link>{" "}
      that carries many passengers plus bags. Want something better? Upgrade to
      our premium service for nicer travel. Families can ask for
      <Link
        to={`/services/baby-seat-taxi-sydney`}
        className="underline font-semibold px-1"
      >
        Baby Seat Taxi
      </Link>{" "}
      options. Your children ride in approved, properly fitted seats. Our
      drivers have experience and manners. They help with special needs. They
      assist with luggage. From early flights to late arrivals, our 24/7 Taxi
      Cronulla keeps you moving. Campbelltown{" "}
      <Link
        to={`/book-a-taxi`}
        className="underline font-semibold px-1"
      >
        Taxi & Maxi Cabs
      </Link>{" "}
      promises safe, reliable, stress-free transport for every customer.
    </>
  ),
  locationSection3Title:
    "Comfortable Corporate & Baby Seat Taxi Booking in Cronulla",
  locationSection3Description: (
    <>
      Our
      <Link
        to={`/book-a-taxi`}
        className="underline font-semibold px-1"
      >
        Taxi Service in Cronulla
      </Link>{" "}
      gives you lots of legroom. You get plenty of luggage space. You relax
      even when the car is full. You avoid tight seating. You miss awkward bag
      packing. Your trip becomes pleasant. Choosing our Taxi & Maxi Cabs
      Services in Cronulla lets your group focus on the journey. We specialise
      in group transfers for families, sports teams, and work groups. Everyone
      arrives together. Booking is fast through our Cronulla Cab Booking page.
      You arrange transport early. Business travellers can use our
      <Link
        to={`/services/corporate-tips`}
        className="underline font-semibold px-1"
      >
        Corporate Taxi Service
      </Link>{" "}
      for on-time, professional rides to meetings. Families add Baby Seat Taxi
      options for safer trips with young children. When style matters, our
      premium service gives extra comfort. Every car gets cleaned regularly. We
      keep high standards. You enjoy smooth, safe travel without traffic
      worries.
    </>
  ),
  locationSection4Title:
    "Reliable Cronulla Taxi & Maxi Cab: Premium Solutions for All Your Travel Needs",
  locationSection4Desctiption: (
    <>
      Find professional transport made for Cronulla residents and visitors.
      Our full range gives you exactly what you need, whether catching early
      flights or arranging
      <Link
        to={`/services/wedding-transfer`}
        className="underline font-semibold px-1"
      >
        wedding transport
      </Link>{" "}
      for many guests. We provide
      <Link
        to={`/services/book-taxi-sydney-airport`}
        className="underline font-semibold px-1"
      >
        Airport Transfers in Cronulla
      </Link>{" "}
      with live flight tracking, Maxi Cab Services fitting up to eleven
      passengers,
      <Link
        to={`/services/baby-seat-taxi-sydney`}
        className="underline font-semibold px-1"
      >
        Baby Seat Taxi
      </Link>{" "}
      options with certified restraints, and Local Taxi Service for daily
      tasks. Business people rely on our Corporate Taxi Service, while those
      wanting luxury choose our Premium Service. We specialise in Wedding
      Transport,
      <Link
        to={`/services/event-transfer`}
        className="underline font-semibold px-1"
      >
        Event Transport,
      </Link>{" "}
      Cruise Transfers, Group Transport for large parties, and
      <Link
        to={`/services/wheelchair-accessible-taxi`}
        className="underline font-semibold px-1"
      >
        Wheelchair Accessible Taxi
      </Link>{" "}
      services. Every trip includes clear upfront pricing, real 24/7
      availability, and experienced local drivers who know Cronulla well. From
      Door-to-Door Taxi Service to complex plans, Campbelltown Taxi & Maxi Cabs
      combines deep local knowledge with steady reliability—because your
      destination matters, and getting there should feel easy.
    </>
  ),
  locationSectionImg: corporateTripsImg,
  serviceTitle: "Taxi and Maxi Cab Solutions, Cronulla for Every Occasion",
  serviceSubtitle: (
    <>
      We adjust transport to match your needs. Our
      <Link to={`/`} className="underline font-semibold px-1">
        Taxi & Maxi Cabs Services
      </Link>{" "}
      in Cronulla support family holidays, group outings, and business travel.
      Safety and punctuality guide everything we do. Every vehicle looks neat.
      Every driver trains well. You depend on us for airport trips, special
      events, and work journeys. Each ride stays simple and relaxed.
    </>
  ),

  cabChargeSectionTitle: "CabCharge Taxi Near Cronulla",
  cabChargeSectionDesctiption: (
    <>
      Need flexible payment for work or personal trips? Our
      <Link
        to={`/cabcharge-taxi`}
        className="underline font-semibold px-1"
      >
        CabCharge Taxi Service in Cronulla
      </Link>
      makes every journey simple and trackable. We accept secure CabCharge
      Payments, including the handy CabCharge Card, perfect for company
      travellers and approved users. Enjoy cashless payments, clear trip
      records, and easy billing every time. Dependable transport backed by
      trusted Cabcharge payment options.
    </>
  ),

  locationServices: {
    S001: {
      service_id: "S001",
      title: "Wedding Transfer",
      description: (
        <>
          Travel in roomy vehicles. Bridal parties, relatives, and guests enjoy
          nice, comfortable rides to and from venues.
        </>
      ),
      image: "/car.png",
      pathname: "/services/wedding-transfer",
    },

    S002: {
      service_id: "S002",
      title: "Luxury Transfer",
      description: (
        <>
          Pick our luxury option for VIP transfers, executive travel, and
          clients wanting more privacy and comfort.
        </>
      ),
      image: "/vehicle.png",
      pathname: "/services/luxury-transfer",
    },

    S003: {
      service_id: "S003",
      title: "Baby Seat Taxi Sydney",
      description: (
        <>
          Families book cars with approved child seats. Young passengers stay
          safe throughout the trip.
        </>
      ),
      image: "/baby-seat.png",
      pathname: "/services/baby-seat-taxi-sydney",
    },

    S004: {
      service_id: "S004",
      title: "Corporate Transport Services",
      description: (
        <>
          Made for meetings and group business travel. On-time pickups help
          busy schedules.
        </>
      ),
      image: "/corporate.png",
      pathname: "/services/corporate-transport-services",
    },

    S005: {
      service_id: "S005",
      title: "Cruise Terminal Transfer",
      description: (
        <>
          Enjoy easy trips between Cronulla and cruise terminals. Plenty of
          space handles passengers and luggage together.
        </>
      ),
      image: "/ship.png",
      pathname: "/services/cruise-terminal-transfer",
    },

    S006: {
      service_id: "S006",
      title: "Event Transfer",
      description: (
        <>
          Use our service for concerts, parties, and social gatherings. Arrive
          on time. Avoid parking problems.
        </>
      ),
      image: "/event.png",
      pathname: "/services/event-transfer",
    },

    S007: {
      service_id: "S007",
      title: "Maxi Taxi Service",
      description: (
        <>
          Ideal for larger groups in Cronulla. Roomy seating and luggage space
          keep everyone together.
        </>
      ),
      image: "/users.png",
      pathname: "/services/maxi-taxi-service",
    },

    S008: {
      service_id: "S008",
      title: "Corporate Trips",
      description: (
        <>
          Safe, well-organised transfers from Cronulla to Sydney Airport or
          business locations. Your team travels without worry.
        </>
      ),
      image: "/briefcase.png",
      pathname: "/services/corporate-tips",
    },

    S009: {
      service_id: "S009",
      title: "Reliable Airport Transfers",
      description: (
        <>
          Reliable 24/7 option across Cronulla for everyday trips,
          appointments, and leisure activities.
        </>
      ),
      image: "/airport.png",
      pathname: "/services/taxi-sydney-service",
    },

    S010: {
      service_id: "S010",
      title: "Emergency Taxi",
      description: (
        <>
          Urgent need? Our Emergency Taxi in Cronulla responds fast. We put
          your safety and speed first.
        </>
      ),
      image: "/emergency.png",
      pathname: "/book-a-taxi",
    },
  },

  fleetSectionTitle: "Premium Fleet for Your Cronulla Transfer",
  fleetSectionSubTitle: (
    <>
      Choose from different vehicles matching your group size and comfort
      needs.
      <Link
        to={`/services/maxi-taxi-service`}
        className="underline font-semibold px-1"
      >
        Our fleet
      </Link>{" "}
      focuses on safety, space, and smooth rides. Solo travellers find good
      matches. Full groups get suitable options too.
    </>
  ),

  fleetSectionVehicles: {
    1: {
      id: 1,
      name: "Easy Sedan",
      passengerCapacity: 4,
      bagsCapacity: 2,
      description: (
        <>
          Perfect for single riders or couples wanting quiet, comfortable trips
          with our reliable Door-to-Door Taxi Service throughout Cronulla.
        </>
      ),
      image: "/campbelltown-easy-sedan.png",
    },

    2: {
      id: 2,
      name: "Luxury Vehicle",
      passengerCapacity: 4,
      bagsCapacity: 2,
      description: (
        <>
          Great for VIPs and business guests who value privacy, quality leather
          seats, and smart presentation on every trip.
        </>
      ),
      image: "/campbelltown-luxury-vehicle.png",
    },

    3: {
      id: 3,
      name: "Suv or Wagon",
      passengerCapacity: 7,
      bagsCapacity: 5,
      description: (
        <>
          Extra room for passengers and luggage. Good choice for families or
          small groups heading to Sydney Airport with comfort.
        </>
      ),
      image: "/campbelltown-suv-wagon.png",
    },

    4: {
      id: 4,
      name: "Kia Carnival",
      passengerCapacity: 7,
      bagsCapacity: 8,
      description: (
        <>
          Fits 6–7 passengers comfortably. Large luggage capacity suits group
          transfers, family holidays, and longer trips.
        </>
      ),
      image: "/campbelltown-kia-carnival.png",
    },

    5: {
      id: 5,
      name: "Maxi Taxi",
      passengerCapacity: 11,
      bagsCapacity: 8,
      description: (
        <>
          Built for bigger groups or large families wanting spacious, clean
          interiors and a fully relaxed travel experience together.
        </>
      ),
      image: "/campbelltown-maxi-taxi.png",
    },

    6: {
      id: 6,
      name: "Wheelchair Taxi Service",
      passengerCapacity: 7,
      bagsCapacity: 8,
      description: (
        <>
          Provides accessible transport with properly trained drivers and the
          right safety features for all mobility needs and comfort.
        </>
      ),
      image: "/campbelltown-maxi-taxi.png",
    },
  },

  faqSectionTitle:
    "Frequently Asked Questions About Taxi Service in Cronulla",
  faqs: [
    {
      question: "Which coastal spots near Cronulla do you cover?",
      answer: (
        <>
          We service Cronulla Beach, Freshwater, and Dee Why. Surf trips
          welcome. Boards fit in <Link
        to={`https://en.wikipedia.org/wiki/Maxi_taxi`}
        className="underline font-semibold px-1"
        target="_blank"
      >Maxi
      </Link> cabs. Beach transport sorted.
        </>
      ),
    },
    {
      question: "How do I arrange transport from Cronulla to Manly Wharf?",
      answer: (
        <>
          Ring 1300 450 428. Short trips our specialty. Ferry connections are
          timed. Quick, reliable service every time.
        </>
      ),
    },
    {
      question: "Can I book a maxi cab for Cronulla surf club functions?",
      answer: (
        <>
          Yes. We carry surfboards, gear, and teams. Nippers' events covered.
          Beach transport expertise guaranteed.
        </>
      ),
    },
    {
      question: "Do your drivers know ways around Pittwater Road congestion?",
      answer: (
        <>
          Absolutely. Northern Beaches locals. Traffic hotspots avoided. Back
          streets mastered. You get smart navigators.
        </>
      ),
    },
    {
      question: "What if I need a taxi for the Cronulla dawn patrol surfing?",
      answer: (
        <>
          Early surf trips welcome. 4 AM pickups arranged. Wetsuit-friendly
          vehicles. Your wave chase is supported.
        </>
      ),
    },
    {
      question: "Can I ask for the same driver for regular Cronulla trips?",
      answer: (
        <>
          Request when booking. Preferences noted. Same driver when possible.
          Relationship builds over time.
        </>
      ),
    },
    {
      question: "How do I organise wheelchair transport to Cronulla Beach?",
      answer: (
        <>
          State needs when calling. Beach access vehicles are available. Help
          provided. Inclusion matters to us.
        </>
      ),
    },
    {
      question: "Are your Cronulla taxis pet-friendly for vet visits?",
      answer: (
        <>
          Small pets in carriers are accepted. Harbord Vet trips are common.
          Service animals are always welcome. Mention when booking.
        </>
      ),
    },
    {
      question: "Can I set up account billing for Cronulla business travel?",
      answer: (
        <>
          Corporate accounts available. Monthly statements. Priority bookings.
          Expense management simplified.
        </>
      ),
    },
    {
      question: "What sets you apart from rideshare apps in Cronulla?",
      answer: (
        <>
          Phone bookings. Fixed rates. Local knowledge. No surge pricing.
          Personal service every trip.
        </>
      ),
    },
    {
      question: "Do you provide Miranda to Cronulla direct trips?",
      answer: (
        <>
          Yes. Northern Beaches peninsula runs. Scenic coastal route. Fixed
          prices available. Comfortable journey.
        </>
      ),
    },
    {
      question: "How early should I book wedding cars for Cronulla ceremonies?",
      answer: (
        <>
          Secure months ahead. Beach weddings are popular. Multiple vehicles
          coordinated. Your special day is perfected.
        </>
      ),
    },
    {
      question: "Can I pay with CabCharge for Cronulla airport transfers?",
      answer: (
        <>
          CabCharge welcome. Corporate cards accepted. Cash and EFTPOS too.
          Flexible payment options.
        </>
      ),
    },
    {
      question: "What happens if my flight arrives early at Sydney Airport?",
      answer: (
        <>
          Live tracking is active. The driver adjusts the pickup. No waiting
          fees. Seamless collection guaranteed.
        </>
      ),
    },
    {
      question: "Do you service all Cronulla streets including beachside lanes?",
      answer: (
        <>
          Yes. Every address found. Narrow lanes navigated. Beachfront pickups
          arranged. No confusion.
        </>
      ),
    },
  ],
},
"woolooware-nsw": {
  mapUrl:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d26443.490177525993!2d151.15419935!3d-34.058328949999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12c7fd2d6664c5%3A0x5017d681632d0f0!2sWoolooware%20NSW%202230%2C%20Australia!5e0!3m2!1sen!2sbd!4v1774724498738!5m2!1sen!2sbd",
  pageTitle:
    "Taxi & Maxi Cabs Services in Woolooware, NSW - Family & Local Travel Experts",
  metaDescription:
    "Book Taxi & Maxi Cabs Services in Woolooware for family travel, local trips & cruise transfers. Trusted drivers, baby seat options & fixed pricing available. Book now!",
  heroTitle:
    "24/7 Taxi & Maxi Cabs Services in Woolooware for Fast & Safe Travel",
  heroDescription: (
    <>
      Need dependable rides around Woolooware? Our
      <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
        Taxi & Maxi Cabs Services
      </Link>
      in Woolooware deliver quick pickups every time you call. We handle your
      local trips with sharp timing that never fails. Our vehicles fit single
      travellers and large groups equally well. You get plenty of cabin space
      for people and luggage together. No one gets left out or squeezed inside.
      We run day and night without stopping. Your flight might land at 2 AM.
      Your shift could end at sunrise. Either way, we show up fast. Choose our
      luxury option for extra comfort. We manage smooth Woolooware pick up and
      drop off to keep your schedule on track. You avoid delays. You skip
      stress.
      <Link to={`/`} className="underline font-semibold px-1">
        Campbelltown Taxi Cabs
      </Link>{" "}
      puts your timetable first always.
    </>
  ),
  bookingFormTitle: "Book Baby Taxi in Woolooware NSW",
  locationSectionTitle: "Reliable Taxi Service in Woolooware for Groups",
  locationSectionDescription: (
    <>
      Taking family or friends somewhere nice? Our Woolooware Taxi Service suits
      small and large groups perfectly. Everyone travels together in one car.
      You miss the hassle of splitting into different vehicles. You avoid
      confusing planning. Through our dedicated
      <Link
        to={`/services/maxi-taxi-service`}
        className="underline font-semibold px-1"
      >
        Maxi Cab Services in Woolooware,
      </Link>
      each person enjoys safe, comfortable travel. Maybe you leave Woolooware
      for Sydney Airport. Maybe you head home after long trips. We keep our
      promises on timing. Our drivers know the best routes. They avoid traffic
      jams. They cut the waiting time. You can trust our Group Transport Curl
      Curl options when you need space, reliability, and clean cars. Booking
      takes seconds through our online system. You get confirmation quickly.
      You travel with confidence.
    </>
  ),
  locationSection2Title:
    "Affordable Taxi Service in Woolooware with Maxi Cabs: safe and 24/7 transport",
  locationSection2Desctiption: (
    <>
      We believe cheap should never mean uncomfortable. Our
      <Link
        to={`/book-a-taxi`}
        className="underline font-semibold px-1"
      >
        Local Taxi Service
      </Link>
      in Woolooware offers fair prices with full clarity. You see the cost
      before booking. You plan your budget with assurance. This helps when
      travelling with others. You can book a
      <Link
        to={`/services/maxi-taxi-service`}
        className="underline font-semibold px-1"
      >
        Maxi Cab for Group Travel
      </Link>{" "}
      that carries many passengers plus bags. Want something better? Upgrade to
      our premium service for nicer travel. Families can ask for
      <Link
        to={`/services/baby-seat-taxi-sydney`}
        className="underline font-semibold px-1"
      >
        Baby Seat Taxi
      </Link>{" "}
      options. Your children ride in approved, properly fitted seats. Our
      drivers have experience and manners. They help with special needs. They
      assist with luggage. From early flights to late arrivals, our 24/7 Taxi
      Woolooware keeps you moving. Campbelltown{" "}
      <Link
        to={`/book-a-taxi`}
        className="underline font-semibold px-1"
      >
        Taxi & Maxi Cabs
      </Link>{" "}
      promises safe, reliable, stress-free transport for every customer.
    </>
  ),
  locationSection3Title:
    "Comfortable Corporate & Baby Seat Taxi Booking in Woolooware",
  locationSection3Description: (
    <>
      Our
      <Link
        to={`/book-a-taxi`}
        className="underline font-semibold px-1"
      >
        Taxi Service in Woolooware
      </Link>{" "}
      gives you lots of legroom. You get plenty of luggage space. You relax
      even when the car is full. You avoid tight seating. You miss awkward bag
      packing. Your trip becomes pleasant. Choosing our Taxi & Maxi Cabs
      Services in Woolooware lets your group focus on the journey. We specialise
      in group transfers for families, sports teams, and work groups. Everyone
      arrives together. Booking is fast through our Woolooware Cab Booking page.
      You arrange transport early. Business travellers can use our
      <Link
        to={`/services/corporate-tips`}
        className="underline font-semibold px-1"
      >
        Corporate Taxi Service
      </Link>{" "}
      for on-time, professional rides to meetings. Families add Baby Seat Taxi
      options for safer trips with young children. When style matters, our
      premium service gives extra comfort. Every car gets cleaned regularly. We
      keep high standards. You enjoy smooth, safe travel without traffic
      worries.
    </>
  ),
  locationSection4Title:
    "Reliable Woolooware Taxi & Maxi Cab: Premium Solutions for All Your Travel Needs",
  locationSection4Desctiption: (
    <>
      Find professional transport made for Woolooware residents and visitors.
      Our full range gives you exactly what you need, whether catching early
      flights or arranging
      <Link
        to={`/services/wedding-transfer`}
        className="underline font-semibold px-1"
      >
        wedding transport
      </Link>{" "}
      for many guests. We provide
      <Link
        to={`/services/book-taxi-sydney-airport`}
        className="underline font-semibold px-1"
      >
        Airport Transfers in Woolooware
      </Link>{" "}
      with live flight tracking, Maxi Cab Services fitting up to eleven
      passengers,
      <Link
        to={`/services/baby-seat-taxi-sydney`}
        className="underline font-semibold px-1"
      >
        Baby Seat Taxi
      </Link>{" "}
      options with certified restraints, and Local Taxi Service for daily
      tasks. Business people rely on our Corporate Taxi Service, while those
      wanting luxury choose our Premium Service. We specialise in Wedding
      Transport,
      <Link
        to={`/services/event-transfer`}
        className="underline font-semibold px-1"
      >
        Event Transport,
      </Link>{" "}
      Cruise Transfers, Group Transport for large parties, and
      <Link
        to={`/services/wheelchair-accessible-taxi`}
        className="underline font-semibold px-1"
      >
        Wheelchair Accessible Taxi
      </Link>{" "}
      services. Every trip includes clear upfront pricing, real 24/7
      availability, and experienced local drivers who know Woolooware well. From
      Door-to-Door Taxi Service to complex plans, Campbelltown Taxi & Maxi Cabs
      combines deep local knowledge with steady reliability—because your
      destination matters, and getting there should feel easy.
    </>
  ),
  locationSectionImg: corporateTripsImg,
  serviceTitle: "Taxi and Maxi Cab Solutions, Woolooware for Every Occasion",
  serviceSubtitle: (
    <>
      We adjust transport to match your needs. Our
      <Link to={`/`} className="underline font-semibold px-1">
        Taxi & Maxi Cabs Services
      </Link>{" "}
      in Woolooware support family holidays, group outings, and business travel.
      Safety and punctuality guide everything we do. Every vehicle looks neat.
      Every driver trains well. You depend on us for airport trips, special
      events, and work journeys. Each ride stays simple and relaxed.
    </>
  ),

  cabChargeSectionTitle: "CabCharge Taxi Near Woolooware",
  cabChargeSectionDesctiption: (
    <>
      Need flexible payment for work or personal trips? Our
      <Link
        to={`/cabcharge-taxi`}
        className="underline font-semibold px-1"
      >
        CabCharge Taxi Service in Woolooware
      </Link>
      makes every journey simple and trackable. We accept secure CabCharge
      Payments, including the handy CabCharge Card, perfect for company
      travellers and approved users. Enjoy cashless payments, clear trip
      records, and easy billing every time. Dependable transport backed by
      trusted Cabcharge payment options.
    </>
  ),

  locationServices: {
    S001: {
      service_id: "S001",
      title: "Wedding Transfer",
      description: (
        <>
          Travel in roomy vehicles. Bridal parties, relatives, and guests enjoy
          nice, comfortable rides to and from venues.
        </>
      ),
      image: "/car.png",
      pathname: "/services/wedding-transfer",
    },

    S002: {
      service_id: "S002",
      title: "Luxury Transfer",
      description: (
        <>
          Pick our luxury option for VIP transfers, executive travel, and
          clients wanting more privacy and comfort.
        </>
      ),
      image: "/vehicle.png",
      pathname: "/services/luxury-transfer",
    },

    S003: {
      service_id: "S003",
      title: "Baby Seat Taxi Sydney",
      description: (
        <>
          Families book cars with approved child seats. Young passengers stay
          safe throughout the trip.
        </>
      ),
      image: "/baby-seat.png",
      pathname: "/services/baby-seat-taxi-sydney",
    },

    S004: {
      service_id: "S004",
      title: "Corporate Transport Services",
      description: (
        <>
          Made for meetings and group business travel. On-time pickups help
          busy schedules.
        </>
      ),
      image: "/corporate.png",
      pathname: "/services/corporate-transport-services",
    },

    S005: {
      service_id: "S005",
      title: "Cruise Terminal Transfer",
      description: (
        <>
          Enjoy easy trips between Woolooware and cruise terminals. Plenty of
          space handles passengers and luggage together.
        </>
      ),
      image: "/ship.png",
      pathname: "/services/cruise-terminal-transfer",
    },

    S006: {
      service_id: "S006",
      title: "Event Transfer",
      description: (
        <>
          Use our service for concerts, parties, and social gatherings. Arrive
          on time. Avoid parking problems.
        </>
      ),
      image: "/event.png",
      pathname: "/services/event-transfer",
    },

    S007: {
      service_id: "S007",
      title: "Maxi Taxi Service",
      description: (
        <>
          Ideal for larger groups in Woolooware. Roomy seating and luggage space
          keep everyone together.
        </>
      ),
      image: "/users.png",
      pathname: "/services/maxi-taxi-service",
    },

    S008: {
      service_id: "S008",
      title: "Corporate Trips",
      description: (
        <>
          Safe, well-organised transfers from Woolooware to Sydney Airport or
          business locations. Your team travels without worry.
        </>
      ),
      image: "/briefcase.png",
      pathname: "/services/corporate-tips",
    },

    S009: {
      service_id: "S009",
      title: "Reliable Airport Transfers",
      description: (
        <>
          Reliable 24/7 option across Woolooware for everyday trips,
          appointments, and leisure activities.
        </>
      ),
      image: "/airport.png",
      pathname: "/services/taxi-sydney-service",
    },

    S010: {
      service_id: "S010",
      title: "Emergency Taxi",
      description: (
        <>
          Urgent need? Our Emergency Taxi in Woolooware responds fast. We put
          your safety and speed first.
        </>
      ),
      image: "/emergency.png",
      pathname: "/book-a-taxi",
    },
  },

  fleetSectionTitle: "Premium Fleet for Your Woolooware Transfer",
  fleetSectionSubTitle: (
    <>
      Choose from different vehicles matching your group size and comfort
      needs.
      <Link
        to={`/services/maxi-taxi-service`}
        className="underline font-semibold px-1"
      >
        Our fleet
      </Link>{" "}
      focuses on safety, space, and smooth rides. Solo travellers find good
      matches. Full groups get suitable options too.
    </>
  ),

  fleetSectionVehicles: {
    1: {
      id: 1,
      name: "Easy Sedan",
      passengerCapacity: 4,
      bagsCapacity: 2,
      description: (
        <>
          Perfect for single riders or couples wanting quiet, comfortable trips
          with our reliable Door-to-Door Taxi Service throughout Woolooware.
        </>
      ),
      image: "/campbelltown-easy-sedan.png",
    },

    2: {
      id: 2,
      name: "Luxury Vehicle",
      passengerCapacity: 4,
      bagsCapacity: 2,
      description: (
        <>
          Great for VIPs and business guests who value privacy, quality leather
          seats, and smart presentation on every trip.
        </>
      ),
      image: "/campbelltown-luxury-vehicle.png",
    },

    3: {
      id: 3,
      name: "Suv or Wagon",
      passengerCapacity: 7,
      bagsCapacity: 5,
      description: (
        <>
          Extra room for passengers and luggage. Good choice for families or
          small groups heading to Sydney Airport with comfort.
        </>
      ),
      image: "/campbelltown-suv-wagon.png",
    },

    4: {
      id: 4,
      name: "Kia Carnival",
      passengerCapacity: 7,
      bagsCapacity: 8,
      description: (
        <>
          Fits 6–7 passengers comfortably. Large luggage capacity suits group
          transfers, family holidays, and longer trips.
        </>
      ),
      image: "/campbelltown-kia-carnival.png",
    },

    5: {
      id: 5,
      name: "Maxi Taxi",
      passengerCapacity: 11,
      bagsCapacity: 8,
      description: (
        <>
          Built for bigger groups or large families wanting spacious, clean
          interiors and a fully relaxed travel experience together.
        </>
      ),
      image: "/campbelltown-maxi-taxi.png",
    },

    6: {
      id: 6,
      name: "Wheelchair Taxi Service",
      passengerCapacity: 7,
      bagsCapacity: 8,
      description: (
        <>
          Provides accessible transport with properly trained drivers and the
          right safety features for all mobility needs and comfort.
        </>
      ),
      image: "/campbelltown-maxi-taxi.png",
    },
  },

  faqSectionTitle:
    "Frequently Asked Questions About Taxi Service in Woolooware",
  faqs: [
    {
      question: "Which coastal spots near Woolooware do you cover?",
      answer: (
        <>
          We service Woolooware Beach, Freshwater, and Dee Why. Surf trips
          welcome. Boards fit in <Link
        to={`https://en.wikipedia.org/wiki/Maxi_taxi`}
        className="underline font-semibold px-1"
        target="_blank"
      >Maxi
      </Link> cabs. Beach transport sorted.
        </>
      ),
    },
    {
      question: "How do I arrange transport from Woolooware to Manly Wharf?",
      answer: (
        <>
          Ring 1300 450 428. Short trips our specialty. Ferry connections are
          timed. Quick, reliable service every time.
        </>
      ),
    },
    {
      question: "Can I book a maxi cab for Woolooware surf club functions?",
      answer: (
        <>
          Yes. We carry surfboards, gear, and teams. Nippers' events covered.
          Beach transport expertise guaranteed.
        </>
      ),
    },
    {
      question: "Do your drivers know ways around Pittwater Road congestion?",
      answer: (
        <>
          Absolutely. Northern Beaches locals. Traffic hotspots avoided. Back
          streets mastered. You get smart navigators.
        </>
      ),
    },
    {
      question: "What if I need a taxi for the Woolooware dawn patrol surfing?",
      answer: (
        <>
          Early surf trips welcome. 4 AM pickups arranged. Wetsuit-friendly
          vehicles. Your wave chase is supported.
        </>
      ),
    },
    {
      question: "Can I ask for the same driver for regular Woolooware trips?",
      answer: (
        <>
          Request when booking. Preferences noted. Same driver when possible.
          Relationship builds over time.
        </>
      ),
    },
    {
      question: "How do I organise wheelchair transport to Woolooware Beach?",
      answer: (
        <>
          State needs when calling. Beach access vehicles are available. Help
          provided. Inclusion matters to us.
        </>
      ),
    },
    {
      question: "Are your Woolooware taxis pet-friendly for vet visits?",
      answer: (
        <>
          Small pets in carriers are accepted. Harbord Vet trips are common.
          Service animals are always welcome. Mention when booking.
        </>
      ),
    },
    {
      question: "Can I set up account billing for Woolooware business travel?",
      answer: (
        <>
          Corporate accounts available. Monthly statements. Priority bookings.
          Expense management simplified.
        </>
      ),
    },
    {
      question: "What sets you apart from rideshare apps in Woolooware?",
      answer: (
        <>
          Phone bookings. Fixed rates. Local knowledge. No surge pricing.
          Personal service every trip.
        </>
      ),
    },
    {
      question: "Do you provide Miranda to Woolooware direct trips?",
      answer: (
        <>
          Yes. Northern Beaches peninsula runs. Scenic coastal route. Fixed
          prices available. Comfortable journey.
        </>
      ),
    },
    {
      question: "How early should I book wedding cars for Woolooware ceremonies?",
      answer: (
        <>
          Secure months ahead. Beach weddings are popular. Multiple vehicles
          coordinated. Your special day is perfected.
        </>
      ),
    },
    {
      question: "Can I pay with CabCharge for Woolooware airport transfers?",
      answer: (
        <>
          CabCharge welcome. Corporate cards accepted. Cash and EFTPOS too.
          Flexible payment options.
        </>
      ),
    },
    {
      question: "What happens if my flight arrives early at Sydney Airport?",
      answer: (
        <>
          Live tracking is active. The driver adjusts the pickup. No waiting
          fees. Seamless collection guaranteed.
        </>
      ),
    },
    {
      question: "Do you service all Woolooware streets including beachside lanes?",
      answer: (
        <>
          Yes. Every address found. Narrow lanes navigated. Beachfront pickups
          arranged. No confusion.
        </>
      ),
    },
  ],
},
"gymea-nsw": {
  mapUrl:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d13222.95116577238!2d151.08747039999997!3d-34.0505966!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12c7a06be0095f%3A0x5017d681632b960!2sGymea%20Bay%20NSW%202227%2C%20Australia!5e0!3m2!1sen!2sbd!4v1774724577601!5m2!1sen!2sbd",
  pageTitle:
    "Taxi & Maxi Cabs Services in Gymea, NSW - Cruise, Airport Transfers & Local",
  metaDescription:
    "Book Taxi & Maxi Cabs Services in Gymea for cruise transfers, wedding transport & 24/7 emergency taxi. Expert local drivers & transparent pricing. Call now!",
  heroTitle:
    "24/7 Taxi & Maxi Cabs Services in Gymea for Local & Airport Travel",
  heroDescription: (
    <>
      After dependable transport around Gymea? Our
      <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
        Taxi & Maxi Cabs Services
      </Link>
      in Gymea promise a rapid response every time you call. We handle
      your local trips with military precision that never disappoints. Our
      vehicles suit lone commuters and huge crowds equally well. You gain
      generous cabin space for riders and luggage combined. Nobody faces
      exclusion or tight squeezes inside. We operate day and night without
      pause. Your plane might land at midnight. Your function could end at
      dawn. Either way, we show up ready. Select our elite tier for added
      comfort. We execute flawless Gymea pick up and drop off to protect
      your schedule. You avoid delays. You skip stress.
      <Link to={`/`} className="underline font-semibold px-1">
        Campbelltown Taxi Cabs
      </Link>{" "}
      prioritises your timetable always.
    </>
  ),
  bookingFormTitle: "Book Baby Taxi in Gymea NSW",
  locationSectionTitle: "Reliable Taxi Service in Gymea for Groups",
  locationSectionDescription: (
    <>
      Taking family or friends somewhere nice? Our  <Link
        to={`/book-a-taxi`}
        className="underline font-semibold px-1"
      >
        Gymea Taxi Service
      </Link>
      accommodates small and large groups ideally. Everyone rides together in
      one car. You bypass the hassle of splitting into multiple vehicles. You
      eliminate confusing coordination. Through our dedicated
      <Link
        to={`/services/maxi-taxi-service`}
        className="underline font-semibold px-1"
      >
        Maxi Cab Services in Gymea,
      </Link>
      each guest enjoys safe, comfortable travel. Perhaps you depart Gymea
      bound for Sydney Airport. Perhaps you return home after a long trip. We
      stick to our promises. Our drivers know the best routes. They avoid
      traffic jams. They minimise waiting time. You can trust our Group
      Transport Gymea options when needing space, reliability, and clean
      interiors. Booking takes seconds via our online portal. You receive
      confirmation quickly. You travel with confidence.
    </>
  ),
  locationSection2Title:
    "Taxi Service in Gymea with Affordable Maxi Cabs & Local Travel",
  locationSection2Desctiption: (
    <>
      We believe affordable should never mean uncomfortable. Our
      <Link
        to={`/book-a-taxi`}
        className="underline font-semibold px-1"
      >
        Local Taxi Service
      </Link>
      in Gymea offers fair rates with complete transparency. You see the
      price before booking. You plan your budget with assurance. This helps
      when travelling with others. You can book a
      <Link
        to={`/services/maxi-taxi-service`}
        className="underline font-semibold px-1"
      >
        Maxi Cab for Group Travel
      </Link>{" "}
      that handles multiple passengers plus bags. Want something nicer? Upgrade
      to our <Link
        to={`/services/luxury-transfer`}
        className="underline font-semibold px-1"
      >
        luxury service
      </Link> for refined travel. Families can request
      <Link
        to={`/services/baby-seat-taxi-sydney`}
        className="underline font-semibold px-1"
      >
        Baby Seat Taxi
      </Link>{" "}
      options. Your children ride in approved, properly fitted seats. Our
      drivers bring experience and courtesy. They assist with special needs.
      They help with luggage. From early morning flights to late-night
      arrivals, our 24/7 Taxi Gymea keeps you moving. Campbelltown{" "}
      <Link
        to={`/book-a-taxi`}
        className="underline font-semibold px-1"
      >
        Taxi & Maxi Cabs
      </Link>{" "}
      commits to safe, reliable, stress-free transport for every customer.
    </>
  ),
  locationSection3Title:
    "Comfortable Corporate & Baby Seat Taxi Booking in Gymea",
  locationSection3Description: (
    <>
      Our
      <Link
        to={`/book-a-taxi`}
        className="underline font-semibold px-1"
      >
        Taxi Service in Gymea
      </Link>{" "}
      provides ample legroom. You get plenty of luggage space. You relax even
      when the vehicle is full. You avoid cramped seating. You miss awkward bag
      arrangements. Your journey becomes pleasant. Choosing our Taxi & Maxi
      Cabs Services in Gymea lets your group focus on the trip. We
      specialise in group transfers for families, sports teams, and work crews.
      Everyone arrives together. Booking is swift through our Gymea Cab
      Booking page. You organise transport in advance. Business travellers can
      use our
      <Link
        to={`/services/corporate-tips`}
        className="underline font-semibold px-1"
      >
        Corporate Taxi Service
      </Link>{" "}
      for punctual, professional rides to meetings. Families add Baby Seat Taxi
      options for safer trips with young children. When style matters, our
      luxury service delivers extra comfort. Every vehicle receives regular
      cleaning. We maintain high standards. You enjoy smooth, secure travel
      without traffic concerns.
    </>
  ),
  locationSection4Title:
    "Reliable Gymea Taxi & Maxi Cab: Premium Solutions for All Your Travel Needs",
  locationSection4Desctiption: (
    <>
      Discover <Link
        to={`/services/book-taxi-sydney-airport`}
        className="underline font-semibold px-1"
      >
      professional transport
      </Link> designed specifically for Gymea
      residents and visitors. Our comprehensive range delivers exactly what you
      need, whether catching an early flight or arranging
      <Link
        to={`/services/wedding-transfer`}
        className="underline font-semibold px-1"
      >
        wedding transport
      </Link>{" "}
      for many guests. We provide
      <Link
        to={`/services/book-taxi-sydney-airport`}
        className="underline font-semibold px-1"
      >
        Airport Transfers in Gymea
      </Link>{" "}
      with real-time flight monitoring, Maxi Cab Services accommodating up to
      eleven passengers,
      <Link
        to={`/services/baby-seat-taxi-sydney`}
        className="underline font-semibold px-1"
      >
        Baby Seat Taxi
      </Link>{" "}
      options with certified restraints, and Local Taxi Service for daily
      errands. Business professionals rely on our Corporate Taxi Service, while
      luxury seekers choose our Premium Service. We specialise in Wedding
      Transport,
      <Link
        to={`/services/event-transfer`}
        className="underline font-semibold px-1"
      >
        Event Transport,
      </Link>{" "}
      Cruise Transfers, Group Transport for large parties, and
      <Link
        to={`/services/wheelchair-accessible-taxi`}
        className="underline font-semibold px-1"
      >
        Wheelchair Accessible Taxi
      </Link>{" "}
      services. Every trip includes clear upfront pricing, genuine 24/7
      availability, and experienced local drivers who know Gymea
      thoroughly. From Door-to-Door Taxi Service to complex logistics,
      <Link
        to={`/`}
        className="underline font-semibold px-1"
      >
       Campbelltown Taxi & Maxi Cabs
      </Link> combines deep local knowledge with
      consistent reliability—because your destination matters, and arriving
      there should feel effortless.
    </>
  ),
  locationSectionImg: corporateTripsImg,
  serviceTitle: "Taxi and Maxi Cab Solutions Gymea for Every Occasion",
  serviceSubtitle: (
    <>
      We adjust transport to match your specific requirements. Our
      <Link to={`/`} className="underline font-semibold px-1">
        Taxi & Maxi Cabs Services
      </Link>{" "}
      in Gymea support family holidays, group outings, and business
      travel. Safety and punctuality guide our operations. Every vehicle looks
      professional. Every driver trains thoroughly. You depend on us for
      airport transfers, special celebrations, and business trips. Each ride
      remains simple and relaxed.
    </>
  ),

  cabChargeSectionTitle: "CabCharge Taxi Near Gymea",
  cabChargeSectionDesctiption: (
    <>
      Need flexible payment for work or personal travel? Our
      <Link
        to={`/cabcharge-taxi`}
        className="underline font-semibold px-1"
      >
        CabCharge Taxi Service in Gymea
      </Link>
      makes every journey simple and traceable. We accept secure CabCharge
      Payments, including the convenient CabCharge Card, perfect for corporate
      travellers and authorised users. Enjoy cashless transactions, clear trip
      records, and straightforward billing every time. Dependable transport
      backed by trusted Cabcharge payment options.
    </>
  ),

  locationServices: {
    S001: {
      service_id: "S001",
      title: "Wedding Transfer",
      description: (
        <>
          Travel in spacious vehicles. Bridal parties, relatives, and guests
          enjoy elegant, comfortable rides to and from venues.
        </>
      ),
      image: "/car.png",
      pathname: "/services/wedding-transfer",
    },

    S002: {
      service_id: "S002",
      title: "Luxury Transfer",
      description: (
        <>
          Choose our luxury option for VIP transfers, executive travel, and
          clients expecting superior privacy and comfort standards.
        </>
      ),
      image: "/vehicle.png",
      pathname: "/services/luxury-transfer",
    },

    S003: {
      service_id: "S003",
      title: "Baby Seat Taxi Sydney",
      description: (
        <>
          Families reserve vehicles with approved child seats. Young passengers
          remain secure throughout the journey.
        </>
      ),
      image: "/baby-seat.png",
      pathname: "/services/baby-seat-taxi-sydney",
    },

    S004: {
      service_id: "S004",
      title: "Corporate Transport Services",
      description: (
        <>
          Designed for meetings and group business travel. Timely collections
          support demanding schedules.
        </>
      ),
      image: "/corporate.png",
      pathname: "/services/corporate-transport-services",
    },

    S005: {
      service_id: "S005",
      title: "Cruise Terminal Transfer",
      description: (
        <>
          Enjoy smooth journeys between Gymea and the cruise terminals.
          Plenty of space handles passengers and luggage together.
        </>
      ),
      image: "/ship.png",
      pathname: "/services/cruise-terminal-transfer",
    },

    S006: {
      service_id: "S006",
      title: "Event Transfer",
      description: (
        <>
          Use our service for concerts, parties, and social gatherings. Arrive
          punctually. Avoid parking difficulties.
        </>
      ),
      image: "/event.png",
      pathname: "/services/event-transfer",
    },

    S007: {
      service_id: "S007",
      title: "Maxi Taxi Service",
      description: (
        <>
          Ideal for larger groups in Gymea. Generous seating and luggage
          capacity keep everyone together.
        </>
      ),
      image: "/users.png",
      pathname: "/services/maxi-taxi-service",
    },

    S008: {
      service_id: "S008",
      title: "Corporate Trips",
      description: (
        <>
          Safe, well-organised transfers from Gymea to Sydney Airport or
          business locations. Your team travels without worry.
        </>
      ),
      image: "/briefcase.png",
      pathname: "/services/corporate-tips",
    },

    S009: {
      service_id: "S009",
      title: "Reliable Airport Transfers",
      description: (
        <>
          Reliable 24/7 option across Gymea for everyday trips,
          appointments, and leisure activities.
        </>
      ),
      image: "/airport.png",
      pathname: "/services/taxi-sydney-service",
    },

    S010: {
      service_id: "S010",
      title: "Emergency Taxi",
      description: (
        <>
          Urgent situation? Our Emergency Taxi in Gymea responds rapidly.
          We prioritise your safety and speed.
        </>
      ),
      image: "/emergency.png",
      pathname: "/book-a-taxi",
    },
  },

  fleetSectionTitle: "Premium Fleet for Your Gymea Transfer",
  fleetSectionSubTitle: (
    <>
      Choose from varied vehicles matching your group size and comfort
      preferences.{" "}
      <Link
        to={`/services/maxi-taxi-service`}
        className="underline font-semibold px-1"
      >
        Our fleet
      </Link>{" "}
      emphasises safety, space, and smooth journeys. Solo travellers find
      ideal options. Full groups receive suitable choices too.
    </>
  ),

  fleetSectionVehicles: {
    1: {
      id: 1,
      name: "Easy Sedan",
      passengerCapacity: 4,
      bagsCapacity: 2,
      description: (
        <>
          Perfect for individual riders or couples seeking peaceful, comfortable
          trips with our reliable Door-to-Door Taxi Service throughout Manly
          Vale.
        </>
      ),
      image: "/campbelltown-easy-sedan.png",
    },

    2: {
      id: 2,
      name: "Luxury Vehicle",
      passengerCapacity: 4,
      bagsCapacity: 2,
      description: (
        <>
          Ideal for VIPs and business guests who value privacy, quality leather
          seating, and polished presentation on every journey.
        </>
      ),
      image: "/campbelltown-luxury-vehicle.png",
    },

    3: {
      id: 3,
      name: "Suv or Wagon",
      passengerCapacity: 7,
      bagsCapacity: 5,
      description: (
        <>
          Additional room for passengers and luggage. Excellent choice for
          families or small groups heading to Sydney Airport with comfort.
        </>
      ),
      image: "/campbelltown-suv-wagon.png",
    },

    4: {
      id: 4,
      name: "Kia Carnival",
      passengerCapacity: 7,
      bagsCapacity: 8,
      description: (
        <>
          Fits 6–7 passengers comfortably. Substantial luggage capacity suits
          group transfers, family holidays, and longer trips.
        </>
      ),
      image: "/campbelltown-kia-carnival.png",
    },

    5: {
      id: 5,
      name: "Maxi Taxi",
      passengerCapacity: 11,
      bagsCapacity: 8,
      description: (
        <>
          Constructed for larger groups or big families wanting spacious, clean
          interiors and a completely relaxed travel experience together.
        </>
      ),
      image: "/campbelltown-maxi-taxi.png",
    },

    6: {
      id: 6,
      name: "Wheelchair Taxi Service",
      passengerCapacity: 7,
      bagsCapacity: 8,
      description: (
        <>
          Provides accessible transport with professionally trained drivers and
          appropriate safety features for all mobility needs and comfort.
        </>
      ),
      image: "/campbelltown-maxi-taxi.png",
    },
  },

  faqSectionTitle:
    "Frequently Asked Questions About Taxi Service in Gymea",
  faqs: [
    {
      question: "How do I get from Gymea to Sydney Airport quickly?",
      answer: (
        <>
          Book with us. We know the fastest routes. Avoid Spit Bridge delays.
          Flight tracking included. Arrive relaxed.
        </>
      ),
    },
    {
      question: "Can I book a taxi for Gymea beach trips?",
      answer: (
        <>
          Yes. We service nearby beaches. Manly, Freshwater, Curl Curl.
          Surfboards fit in <Link
        to={`https://en.wikipedia.org/wiki/Maxi_taxi`}
        className="underline font-semibold px-1"
        target="_blank"
      >
        maxi
      </Link> cabs. Beach days sorted.
        </>
      ),
    },
    {
      question: "Do your drivers know Balgowlah and Fairlight shortcuts?",
      answer: (
        <>
          Absolutely. Northern Beaches locals. Back streets mapped. Traffic
          avoided. You get savvy route planners.
        </>
      ),
    },
    {
      question: "What if I need a taxi during Gymea's peak hour?",
      answer: (
        <>
          We plan. Alternative routes are ready. Your pickup stays on time.
          Rush hour is handled professionally.
        </>
      ),
    },
    {
      question: "Can I request a female driver for Gymea trips?",
      answer: (
        <>
          Ask when booking. We accommodate when possible. Your comfort drives
          our service. Preferences noted.
        </>
      ),
    },
    {
      question: "Do you offer Gymea to North Sydney direct?",
      answer: (
        <>
          Yes. Direct business district runs. Fixed rates available. Avoid
          parking hassles. Arrive ready for meetings.
        </>
      ),
    },
    {
      question: "How do I arrange wheelchair transport in Gymea?",
      answer: (
        <>
          State needs when calling. Proper vehicle dispatched. Drivers assist
          carefully. Accessibility guaranteed with dignity.
        </>
      ),
    },
    {
      question: "Are your Gymea taxis suitable for elderly passengers?",
      answer: (
        <>
          Yes. Patient assistance. Comfortable seating. Step help provided.
          Regular medical trip bookings are warmly accepted.
        </>
      ),
    },
    {
      question: "Can I set up corporate accounts for Gymea travel?",
      answer: (
        <>
          Business accounts available. Monthly statements. Priority service.
          Expense management simplified. Professional standards maintained.
        </>
      ),
    },
    {
      question: "What makes you different from rideshare in Gymea?",
      answer: (
        <>
          Phone bookings accepted. Fixed pricing. Local knowledge. No surge
          charges. Personalised service every trip.
        </>
      ),
    },
    {
      question: "Do you provide Gymea school transport services?",
      answer: (
        <>
          Yes. Regular student pickups. Safety seats fitted. Punctuality
          assured. Parents trust our reliable service.
        </>
      ),
    },
    {
      question: "How early should I book wedding cars for Gymea?",
      answer: (
        <>
          Secure months ahead for summer. Multiple vehicles coordinated. Your
          celebration transport is perfected.
        </>
      ),
    },
    {
      question: "Can I pay with CabCharge for Gymea airport runs?",
      answer: (
        <>
          CabCharge welcome. Corporate cards accepted. Cash and EFTPOS too.
          Flexible payment options are provided.
        </>
      ),
    },
    {
      question: "What happens if my flight arrives early at Sydney Airport?",
      answer: (
        <>
          Live tracking is active. The driver adjusts the pickup. No waiting
          fees. Seamless collection guaranteed every time.
        </>
      ),
    },
    {
      question:
        "Do you service all Gymea streets including cul-de-sacs?",
      answer: (
        <>
          Yes. Every address found. Narrow streets navigated. Your location is
          reached without confusion or delay.
        </>
      ),
    },
  ],
},
"kirrawee-nsw": {
  mapUrl:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d26451.334140971638!2d151.07257245!3d-34.03317884999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12c76a29af8be3%3A0x5017d681632bce0!2sKirrawee%20NSW%202232%2C%20Australia!5e0!3m2!1sen!2sbd!4v1774724800771!5m2!1sen!2sbd",
  pageTitle:
    "Taxi & Maxi Cabs Services in Kirrawee, NSW - Cruise, Airport Transfers & Local",
  metaDescription:
    "Book Taxi & Maxi Cabs Services in Kirrawee for cruise transfers, wedding transport & 24/7 emergency taxi. Expert local drivers & transparent pricing. Call now!",
  heroTitle:
    "24/7 Taxi & Maxi Cabs Services in Kirrawee for Local & Airport Travel",
  heroDescription: (
    <>
      After dependable transport around Kirrawee? Our
      <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
        Taxi & Maxi Cabs Services
      </Link>
      in Kirrawee promise a rapid response every time you call. We handle
      your local trips with military precision that never disappoints. Our
      vehicles suit lone commuters and huge crowds equally well. You gain
      generous cabin space for riders and luggage combined. Nobody faces
      exclusion or tight squeezes inside. We operate day and night without
      pause. Your plane might land at midnight. Your function could end at
      dawn. Either way, we show up ready. Select our elite tier for added
      comfort. We execute flawless Kirrawee pick up and drop off to protect
      your schedule. You avoid delays. You skip stress.
      <Link to={`/`} className="underline font-semibold px-1">
        Campbelltown Taxi Cabs
      </Link>{" "}
      prioritises your timetable always.
    </>
  ),
  bookingFormTitle: "Book Baby Taxi in Kirrawee NSW",
  locationSectionTitle: "Reliable Taxi Service in Kirrawee for Groups",
  locationSectionDescription: (
    <>
      Taking family or friends somewhere nice? Our  <Link
        to={`/book-a-taxi`}
        className="underline font-semibold px-1"
      >
        Kirrawee Taxi Service
      </Link>
      accommodates small and large groups ideally. Everyone rides together in
      one car. You bypass the hassle of splitting into multiple vehicles. You
      eliminate confusing coordination. Through our dedicated
      <Link
        to={`/services/maxi-taxi-service`}
        className="underline font-semibold px-1"
      >
        Maxi Cab Services in Kirrawee,
      </Link>
      each guest enjoys safe, comfortable travel. Perhaps you depart Kirrawee
      bound for Sydney Airport. Perhaps you return home after a long trip. We
      stick to our promises. Our drivers know the best routes. They avoid
      traffic jams. They minimise waiting time. You can trust our Group
      Transport Kirrawee options when needing space, reliability, and clean
      interiors. Booking takes seconds via our online portal. You receive
      confirmation quickly. You travel with confidence.
    </>
  ),
  locationSection2Title:
    "Taxi Service in Kirrawee with Affordable Maxi Cabs & Local Travel",
  locationSection2Desctiption: (
    <>
      We believe affordable should never mean uncomfortable. Our
      <Link
        to={`/book-a-taxi`}
        className="underline font-semibold px-1"
      >
        Local Taxi Service
      </Link>
      in Kirrawee offers fair rates with complete transparency. You see the
      price before booking. You plan your budget with assurance. This helps
      when travelling with others. You can book a
      <Link
        to={`/services/maxi-taxi-service`}
        className="underline font-semibold px-1"
      >
        Maxi Cab for Group Travel
      </Link>{" "}
      that handles multiple passengers plus bags. Want something nicer? Upgrade
      to our <Link
        to={`/services/luxury-transfer`}
        className="underline font-semibold px-1"
      >
        luxury service
      </Link> for refined travel. Families can request
      <Link
        to={`/services/baby-seat-taxi-sydney`}
        className="underline font-semibold px-1"
      >
        Baby Seat Taxi
      </Link>{" "}
      options. Your children ride in approved, properly fitted seats. Our
      drivers bring experience and courtesy. They assist with special needs.
      They help with luggage. From early morning flights to late-night
      arrivals, our 24/7 Taxi Kirrawee keeps you moving. Campbelltown{" "}
      <Link
        to={`/book-a-taxi`}
        className="underline font-semibold px-1"
      >
        Taxi & Maxi Cabs
      </Link>{" "}
      commits to safe, reliable, stress-free transport for every customer.
    </>
  ),
  locationSection3Title:
    "Comfortable Corporate & Baby Seat Taxi Booking in Kirrawee",
  locationSection3Description: (
    <>
      Our
      <Link
        to={`/book-a-taxi`}
        className="underline font-semibold px-1"
      >
        Taxi Service in Kirrawee
      </Link>{" "}
      provides ample legroom. You get plenty of luggage space. You relax even
      when the vehicle is full. You avoid cramped seating. You miss awkward bag
      arrangements. Your journey becomes pleasant. Choosing our Taxi & Maxi
      Cabs Services in Kirrawee lets your group focus on the trip. We
      specialise in group transfers for families, sports teams, and work crews.
      Everyone arrives together. Booking is swift through our Kirrawee Cab
      Booking page. You organise transport in advance. Business travellers can
      use our
      <Link
        to={`/services/corporate-tips`}
        className="underline font-semibold px-1"
      >
        Corporate Taxi Service
      </Link>{" "}
      for punctual, professional rides to meetings. Families add Baby Seat Taxi
      options for safer trips with young children. When style matters, our
      luxury service delivers extra comfort. Every vehicle receives regular
      cleaning. We maintain high standards. You enjoy smooth, secure travel
      without traffic concerns.
    </>
  ),
  locationSection4Title:
    "Reliable Kirrawee Taxi & Maxi Cab: Premium Solutions for All Your Travel Needs",
  locationSection4Desctiption: (
    <>
      Discover <Link
        to={`/services/book-taxi-sydney-airport`}
        className="underline font-semibold px-1"
      >
      professional transport
      </Link> designed specifically for Kirrawee
      residents and visitors. Our comprehensive range delivers exactly what you
      need, whether catching an early flight or arranging
      <Link
        to={`/services/wedding-transfer`}
        className="underline font-semibold px-1"
      >
        wedding transport
      </Link>{" "}
      for many guests. We provide
      <Link
        to={`/services/book-taxi-sydney-airport`}
        className="underline font-semibold px-1"
      >
        Airport Transfers in Kirrawee
      </Link>{" "}
      with real-time flight monitoring, Maxi Cab Services accommodating up to
      eleven passengers,
      <Link
        to={`/services/baby-seat-taxi-sydney`}
        className="underline font-semibold px-1"
      >
        Baby Seat Taxi
      </Link>{" "}
      options with certified restraints, and Local Taxi Service for daily
      errands. Business professionals rely on our Corporate Taxi Service, while
      luxury seekers choose our Premium Service. We specialise in Wedding
      Transport,
      <Link
        to={`/services/event-transfer`}
        className="underline font-semibold px-1"
      >
        Event Transport,
      </Link>{" "}
      Cruise Transfers, Group Transport for large parties, and
      <Link
        to={`/services/wheelchair-accessible-taxi`}
        className="underline font-semibold px-1"
      >
        Wheelchair Accessible Taxi
      </Link>{" "}
      services. Every trip includes clear upfront pricing, genuine 24/7
      availability, and experienced local drivers who know Kirrawee
      thoroughly. From Door-to-Door Taxi Service to complex logistics,
      <Link
        to={`/`}
        className="underline font-semibold px-1"
      >
       Campbelltown Taxi & Maxi Cabs
      </Link> combines deep local knowledge with
      consistent reliability—because your destination matters, and arriving
      there should feel effortless.
    </>
  ),
  locationSectionImg: corporateTripsImg,
  serviceTitle: "Taxi and Maxi Cab Solutions Kirrawee for Every Occasion",
  serviceSubtitle: (
    <>
      We adjust transport to match your specific requirements. Our
      <Link to={`/`} className="underline font-semibold px-1">
        Taxi & Maxi Cabs Services
      </Link>{" "}
      in Kirrawee support family holidays, group outings, and business
      travel. Safety and punctuality guide our operations. Every vehicle looks
      professional. Every driver trains thoroughly. You depend on us for
      airport transfers, special celebrations, and business trips. Each ride
      remains simple and relaxed.
    </>
  ),

  cabChargeSectionTitle: "CabCharge Taxi Near Kirrawee",
  cabChargeSectionDesctiption: (
    <>
      Need flexible payment for work or personal travel? Our
      <Link
        to={`/cabcharge-taxi`}
        className="underline font-semibold px-1"
      >
        CabCharge Taxi Service in Kirrawee
      </Link>
      makes every journey simple and traceable. We accept secure CabCharge
      Payments, including the convenient CabCharge Card, perfect for corporate
      travellers and authorised users. Enjoy cashless transactions, clear trip
      records, and straightforward billing every time. Dependable transport
      backed by trusted Cabcharge payment options.
    </>
  ),

  locationServices: {
    S001: {
      service_id: "S001",
      title: "Wedding Transfer",
      description: (
        <>
          Travel in spacious vehicles. Bridal parties, relatives, and guests
          enjoy elegant, comfortable rides to and from venues.
        </>
      ),
      image: "/car.png",
      pathname: "/services/wedding-transfer",
    },

    S002: {
      service_id: "S002",
      title: "Luxury Transfer",
      description: (
        <>
          Choose our luxury option for VIP transfers, executive travel, and
          clients expecting superior privacy and comfort standards.
        </>
      ),
      image: "/vehicle.png",
      pathname: "/services/luxury-transfer",
    },

    S003: {
      service_id: "S003",
      title: "Baby Seat Taxi Sydney",
      description: (
        <>
          Families reserve vehicles with approved child seats. Young passengers
          remain secure throughout the journey.
        </>
      ),
      image: "/baby-seat.png",
      pathname: "/services/baby-seat-taxi-sydney",
    },

    S004: {
      service_id: "S004",
      title: "Corporate Transport Services",
      description: (
        <>
          Designed for meetings and group business travel. Timely collections
          support demanding schedules.
        </>
      ),
      image: "/corporate.png",
      pathname: "/services/corporate-transport-services",
    },

    S005: {
      service_id: "S005",
      title: "Cruise Terminal Transfer",
      description: (
        <>
          Enjoy smooth journeys between Kirrawee and the cruise terminals.
          Plenty of space handles passengers and luggage together.
        </>
      ),
      image: "/ship.png",
      pathname: "/services/cruise-terminal-transfer",
    },

    S006: {
      service_id: "S006",
      title: "Event Transfer",
      description: (
        <>
          Use our service for concerts, parties, and social gatherings. Arrive
          punctually. Avoid parking difficulties.
        </>
      ),
      image: "/event.png",
      pathname: "/services/event-transfer",
    },

    S007: {
      service_id: "S007",
      title: "Maxi Taxi Service",
      description: (
        <>
          Ideal for larger groups in Kirrawee. Generous seating and luggage
          capacity keep everyone together.
        </>
      ),
      image: "/users.png",
      pathname: "/services/maxi-taxi-service",
    },

    S008: {
      service_id: "S008",
      title: "Corporate Trips",
      description: (
        <>
          Safe, well-organised transfers from Kirrawee to Sydney Airport or
          business locations. Your team travels without worry.
        </>
      ),
      image: "/briefcase.png",
      pathname: "/services/corporate-tips",
    },

    S009: {
      service_id: "S009",
      title: "Reliable Airport Transfers",
      description: (
        <>
          Reliable 24/7 option across Kirrawee for everyday trips,
          appointments, and leisure activities.
        </>
      ),
      image: "/airport.png",
      pathname: "/services/taxi-sydney-service",
    },

    S010: {
      service_id: "S010",
      title: "Emergency Taxi",
      description: (
        <>
          Urgent situation? Our Emergency Taxi in Kirrawee responds rapidly.
          We prioritise your safety and speed.
        </>
      ),
      image: "/emergency.png",
      pathname: "/book-a-taxi",
    },
  },

  fleetSectionTitle: "Premium Fleet for Your Kirrawee Transfer",
  fleetSectionSubTitle: (
    <>
      Choose from varied vehicles matching your group size and comfort
      preferences.{" "}
      <Link
        to={`/services/maxi-taxi-service`}
        className="underline font-semibold px-1"
      >
        Our fleet
      </Link>{" "}
      emphasises safety, space, and smooth journeys. Solo travellers find
      ideal options. Full groups receive suitable choices too.
    </>
  ),

  fleetSectionVehicles: {
    1: {
      id: 1,
      name: "Easy Sedan",
      passengerCapacity: 4,
      bagsCapacity: 2,
      description: (
        <>
          Perfect for individual riders or couples seeking peaceful, comfortable
          trips with our reliable Door-to-Door Taxi Service throughout Manly
          Vale.
        </>
      ),
      image: "/campbelltown-easy-sedan.png",
    },

    2: {
      id: 2,
      name: "Luxury Vehicle",
      passengerCapacity: 4,
      bagsCapacity: 2,
      description: (
        <>
          Ideal for VIPs and business guests who value privacy, quality leather
          seating, and polished presentation on every journey.
        </>
      ),
      image: "/campbelltown-luxury-vehicle.png",
    },

    3: {
      id: 3,
      name: "Suv or Wagon",
      passengerCapacity: 7,
      bagsCapacity: 5,
      description: (
        <>
          Additional room for passengers and luggage. Excellent choice for
          families or small groups heading to Sydney Airport with comfort.
        </>
      ),
      image: "/campbelltown-suv-wagon.png",
    },

    4: {
      id: 4,
      name: "Kia Carnival",
      passengerCapacity: 7,
      bagsCapacity: 8,
      description: (
        <>
          Fits 6–7 passengers comfortably. Substantial luggage capacity suits
          group transfers, family holidays, and longer trips.
        </>
      ),
      image: "/campbelltown-kia-carnival.png",
    },

    5: {
      id: 5,
      name: "Maxi Taxi",
      passengerCapacity: 11,
      bagsCapacity: 8,
      description: (
        <>
          Constructed for larger groups or big families wanting spacious, clean
          interiors and a completely relaxed travel experience together.
        </>
      ),
      image: "/campbelltown-maxi-taxi.png",
    },

    6: {
      id: 6,
      name: "Wheelchair Taxi Service",
      passengerCapacity: 7,
      bagsCapacity: 8,
      description: (
        <>
          Provides accessible transport with professionally trained drivers and
          appropriate safety features for all mobility needs and comfort.
        </>
      ),
      image: "/campbelltown-maxi-taxi.png",
    },
  },

  faqSectionTitle:
    "Frequently Asked Questions About Taxi Service in Kirrawee",
  faqs: [
    {
      question: "How do I get from Kirrawee to Sydney Airport quickly?",
      answer: (
        <>
          Book with us. We know the fastest routes. Avoid Spit Bridge delays.
          Flight tracking included. Arrive relaxed.
        </>
      ),
    },
    {
      question: "Can I book a taxi for Kirrawee beach trips?",
      answer: (
        <>
          Yes. We service nearby beaches. Manly, Freshwater, Curl Curl.
          Surfboards fit in <Link
        to={`https://en.wikipedia.org/wiki/Maxi_taxi`}
        className="underline font-semibold px-1"
        target="_blank"
      >
        maxi
      </Link> cabs. Beach days sorted.
        </>
      ),
    },
    {
      question: "Do your drivers know Balgowlah and Fairlight shortcuts?",
      answer: (
        <>
          Absolutely. Northern Beaches locals. Back streets mapped. Traffic
          avoided. You get savvy route planners.
        </>
      ),
    },
    {
      question: "What if I need a taxi during Kirrawee's peak hour?",
      answer: (
        <>
          We plan. Alternative routes are ready. Your pickup stays on time.
          Rush hour is handled professionally.
        </>
      ),
    },
    {
      question: "Can I request a female driver for Kirrawee trips?",
      answer: (
        <>
          Ask when booking. We accommodate when possible. Your comfort drives
          our service. Preferences noted.
        </>
      ),
    },
    {
      question: "Do you offer Kirrawee to North Sydney direct?",
      answer: (
        <>
          Yes. Direct business district runs. Fixed rates available. Avoid
          parking hassles. Arrive ready for meetings.
        </>
      ),
    },
    {
      question: "How do I arrange wheelchair transport in Kirrawee?",
      answer: (
        <>
          State needs when calling. Proper vehicle dispatched. Drivers assist
          carefully. Accessibility guaranteed with dignity.
        </>
      ),
    },
    {
      question: "Are your Kirrawee taxis suitable for elderly passengers?",
      answer: (
        <>
          Yes. Patient assistance. Comfortable seating. Step help provided.
          Regular medical trip bookings are warmly accepted.
        </>
      ),
    },
    {
      question: "Can I set up corporate accounts for Kirrawee travel?",
      answer: (
        <>
          Business accounts available. Monthly statements. Priority service.
          Expense management simplified. Professional standards maintained.
        </>
      ),
    },
    {
      question: "What makes you different from rideshare in Kirrawee?",
      answer: (
        <>
          Phone bookings accepted. Fixed pricing. Local knowledge. No surge
          charges. Personalised service every trip.
        </>
      ),
    },
    {
      question: "Do you provide Kirrawee school transport services?",
      answer: (
        <>
          Yes. Regular student pickups. Safety seats fitted. Punctuality
          assured. Parents trust our reliable service.
        </>
      ),
    },
    {
      question: "How early should I book wedding cars for Kirrawee?",
      answer: (
        <>
          Secure months ahead for summer. Multiple vehicles coordinated. Your
          celebration transport is perfected.
        </>
      ),
    },
    {
      question: "Can I pay with CabCharge for Kirrawee airport runs?",
      answer: (
        <>
          CabCharge welcome. Corporate cards accepted. Cash and EFTPOS too.
          Flexible payment options are provided.
        </>
      ),
    },
    {
      question: "What happens if my flight arrives early at Sydney Airport?",
      answer: (
        <>
          Live tracking is active. The driver adjusts the pickup. No waiting
          fees. Seamless collection guaranteed every time.
        </>
      ),
    },
    {
      question:
        "Do you service all Kirrawee streets including cul-de-sacs?",
      answer: (
        <>
          Yes. Every address found. Narrow streets navigated. Your location is
          reached without confusion or delay.
        </>
      ),
    },
  ],
},
"jannali-nsw": {
  mapUrl:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d26451.334140971638!2d151.07257245!3d-34.03317884999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12c7590e4c8343%3A0x5017d681632bbc0!2sJannali%20NSW%202226%2C%20Australia!5e0!3m2!1sen!2sbd!4v1774724854726!5m2!1sen!2sbd",
  pageTitle:
    "Taxi & Maxi Cabs Services in Jannali, NSW - Cruise, Airport Transfers & Local",
  metaDescription:
    "Book Taxi & Maxi Cabs Services in Jannali for cruise transfers, wedding transport & 24/7 emergency taxi. Expert local drivers & transparent pricing. Call now!",
  heroTitle:
    "24/7 Taxi & Maxi Cabs Services in Jannali for Local & Airport Travel",
  heroDescription: (
    <>
      After dependable transport around Jannali? Our
      <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
        Taxi & Maxi Cabs Services
      </Link>
      in Jannali promise a rapid response every time you call. We handle
      your local trips with military precision that never disappoints. Our
      vehicles suit lone commuters and huge crowds equally well. You gain
      generous cabin space for riders and luggage combined. Nobody faces
      exclusion or tight squeezes inside. We operate day and night without
      pause. Your plane might land at midnight. Your function could end at
      dawn. Either way, we show up ready. Select our elite tier for added
      comfort. We execute flawless Jannali pick up and drop off to protect
      your schedule. You avoid delays. You skip stress.
      <Link to={`/`} className="underline font-semibold px-1">
        Campbelltown Taxi Cabs
      </Link>{" "}
      prioritises your timetable always.
    </>
  ),
  bookingFormTitle: "Book Baby Taxi in Jannali NSW",
  locationSectionTitle: "Reliable Taxi Service in Jannali for Groups",
  locationSectionDescription: (
    <>
      Taking family or friends somewhere nice? Our  <Link
        to={`/book-a-taxi`}
        className="underline font-semibold px-1"
      >
        Jannali Taxi Service
      </Link>
      accommodates small and large groups ideally. Everyone rides together in
      one car. You bypass the hassle of splitting into multiple vehicles. You
      eliminate confusing coordination. Through our dedicated
      <Link
        to={`/services/maxi-taxi-service`}
        className="underline font-semibold px-1"
      >
        Maxi Cab Services in Jannali,
      </Link>
      each guest enjoys safe, comfortable travel. Perhaps you depart Jannali
      bound for Sydney Airport. Perhaps you return home after a long trip. We
      stick to our promises. Our drivers know the best routes. They avoid
      traffic jams. They minimise waiting time. You can trust our Group
      Transport Jannali options when needing space, reliability, and clean
      interiors. Booking takes seconds via our online portal. You receive
      confirmation quickly. You travel with confidence.
    </>
  ),
  locationSection2Title:
    "Taxi Service in Jannali with Affordable Maxi Cabs & Local Travel",
  locationSection2Desctiption: (
    <>
      We believe affordable should never mean uncomfortable. Our
      <Link
        to={`/book-a-taxi`}
        className="underline font-semibold px-1"
      >
        Local Taxi Service
      </Link>
      in Jannali offers fair rates with complete transparency. You see the
      price before booking. You plan your budget with assurance. This helps
      when travelling with others. You can book a
      <Link
        to={`/services/maxi-taxi-service`}
        className="underline font-semibold px-1"
      >
        Maxi Cab for Group Travel
      </Link>{" "}
      that handles multiple passengers plus bags. Want something nicer? Upgrade
      to our <Link
        to={`/services/luxury-transfer`}
        className="underline font-semibold px-1"
      >
        luxury service
      </Link> for refined travel. Families can request
      <Link
        to={`/services/baby-seat-taxi-sydney`}
        className="underline font-semibold px-1"
      >
        Baby Seat Taxi
      </Link>{" "}
      options. Your children ride in approved, properly fitted seats. Our
      drivers bring experience and courtesy. They assist with special needs.
      They help with luggage. From early morning flights to late-night
      arrivals, our 24/7 Taxi Jannali keeps you moving. Campbelltown{" "}
      <Link
        to={`/book-a-taxi`}
        className="underline font-semibold px-1"
      >
        Taxi & Maxi Cabs
      </Link>{" "}
      commits to safe, reliable, stress-free transport for every customer.
    </>
  ),
  locationSection3Title:
    "Comfortable Corporate & Baby Seat Taxi Booking in Jannali",
  locationSection3Description: (
    <>
      Our
      <Link
        to={`/book-a-taxi`}
        className="underline font-semibold px-1"
      >
        Taxi Service in Jannali
      </Link>{" "}
      provides ample legroom. You get plenty of luggage space. You relax even
      when the vehicle is full. You avoid cramped seating. You miss awkward bag
      arrangements. Your journey becomes pleasant. Choosing our Taxi & Maxi
      Cabs Services in Jannali lets your group focus on the trip. We
      specialise in group transfers for families, sports teams, and work crews.
      Everyone arrives together. Booking is swift through our Jannali Cab
      Booking page. You organise transport in advance. Business travellers can
      use our
      <Link
        to={`/services/corporate-tips`}
        className="underline font-semibold px-1"
      >
        Corporate Taxi Service
      </Link>{" "}
      for punctual, professional rides to meetings. Families add Baby Seat Taxi
      options for safer trips with young children. When style matters, our
      luxury service delivers extra comfort. Every vehicle receives regular
      cleaning. We maintain high standards. You enjoy smooth, secure travel
      without traffic concerns.
    </>
  ),
  locationSection4Title:
    "Reliable Jannali Taxi & Maxi Cab: Premium Solutions for All Your Travel Needs",
  locationSection4Desctiption: (
    <>
      Discover <Link
        to={`/services/book-taxi-sydney-airport`}
        className="underline font-semibold px-1"
      >
      professional transport
      </Link> designed specifically for Jannali
      residents and visitors. Our comprehensive range delivers exactly what you
      need, whether catching an early flight or arranging
      <Link
        to={`/services/wedding-transfer`}
        className="underline font-semibold px-1"
      >
        wedding transport
      </Link>{" "}
      for many guests. We provide
      <Link
        to={`/services/book-taxi-sydney-airport`}
        className="underline font-semibold px-1"
      >
        Airport Transfers in Jannali
      </Link>{" "}
      with real-time flight monitoring, Maxi Cab Services accommodating up to
      eleven passengers,
      <Link
        to={`/services/baby-seat-taxi-sydney`}
        className="underline font-semibold px-1"
      >
        Baby Seat Taxi
      </Link>{" "}
      options with certified restraints, and Local Taxi Service for daily
      errands. Business professionals rely on our Corporate Taxi Service, while
      luxury seekers choose our Premium Service. We specialise in Wedding
      Transport,
      <Link
        to={`/services/event-transfer`}
        className="underline font-semibold px-1"
      >
        Event Transport,
      </Link>{" "}
      Cruise Transfers, Group Transport for large parties, and
      <Link
        to={`/services/wheelchair-accessible-taxi`}
        className="underline font-semibold px-1"
      >
        Wheelchair Accessible Taxi
      </Link>{" "}
      services. Every trip includes clear upfront pricing, genuine 24/7
      availability, and experienced local drivers who know Jannali
      thoroughly. From Door-to-Door Taxi Service to complex logistics,
      <Link
        to={`/`}
        className="underline font-semibold px-1"
      >
       Campbelltown Taxi & Maxi Cabs
      </Link> combines deep local knowledge with
      consistent reliability—because your destination matters, and arriving
      there should feel effortless.
    </>
  ),
  locationSectionImg: corporateTripsImg,
  serviceTitle: "Taxi and Maxi Cab Solutions Jannali for Every Occasion",
  serviceSubtitle: (
    <>
      We adjust transport to match your specific requirements. Our
      <Link to={`/`} className="underline font-semibold px-1">
        Taxi & Maxi Cabs Services
      </Link>{" "}
      in Jannali support family holidays, group outings, and business
      travel. Safety and punctuality guide our operations. Every vehicle looks
      professional. Every driver trains thoroughly. You depend on us for
      airport transfers, special celebrations, and business trips. Each ride
      remains simple and relaxed.
    </>
  ),

  cabChargeSectionTitle: "CabCharge Taxi Near Jannali",
  cabChargeSectionDesctiption: (
    <>
      Need flexible payment for work or personal travel? Our
      <Link
        to={`/cabcharge-taxi`}
        className="underline font-semibold px-1"
      >
        CabCharge Taxi Service in Jannali
      </Link>
      makes every journey simple and traceable. We accept secure CabCharge
      Payments, including the convenient CabCharge Card, perfect for corporate
      travellers and authorised users. Enjoy cashless transactions, clear trip
      records, and straightforward billing every time. Dependable transport
      backed by trusted Cabcharge payment options.
    </>
  ),

  locationServices: {
    S001: {
      service_id: "S001",
      title: "Wedding Transfer",
      description: (
        <>
          Travel in spacious vehicles. Bridal parties, relatives, and guests
          enjoy elegant, comfortable rides to and from venues.
        </>
      ),
      image: "/car.png",
      pathname: "/services/wedding-transfer",
    },

    S002: {
      service_id: "S002",
      title: "Luxury Transfer",
      description: (
        <>
          Choose our luxury option for VIP transfers, executive travel, and
          clients expecting superior privacy and comfort standards.
        </>
      ),
      image: "/vehicle.png",
      pathname: "/services/luxury-transfer",
    },

    S003: {
      service_id: "S003",
      title: "Baby Seat Taxi Sydney",
      description: (
        <>
          Families reserve vehicles with approved child seats. Young passengers
          remain secure throughout the journey.
        </>
      ),
      image: "/baby-seat.png",
      pathname: "/services/baby-seat-taxi-sydney",
    },

    S004: {
      service_id: "S004",
      title: "Corporate Transport Services",
      description: (
        <>
          Designed for meetings and group business travel. Timely collections
          support demanding schedules.
        </>
      ),
      image: "/corporate.png",
      pathname: "/services/corporate-transport-services",
    },

    S005: {
      service_id: "S005",
      title: "Cruise Terminal Transfer",
      description: (
        <>
          Enjoy smooth journeys between Jannali and the cruise terminals.
          Plenty of space handles passengers and luggage together.
        </>
      ),
      image: "/ship.png",
      pathname: "/services/cruise-terminal-transfer",
    },

    S006: {
      service_id: "S006",
      title: "Event Transfer",
      description: (
        <>
          Use our service for concerts, parties, and social gatherings. Arrive
          punctually. Avoid parking difficulties.
        </>
      ),
      image: "/event.png",
      pathname: "/services/event-transfer",
    },

    S007: {
      service_id: "S007",
      title: "Maxi Taxi Service",
      description: (
        <>
          Ideal for larger groups in Jannali. Generous seating and luggage
          capacity keep everyone together.
        </>
      ),
      image: "/users.png",
      pathname: "/services/maxi-taxi-service",
    },

    S008: {
      service_id: "S008",
      title: "Corporate Trips",
      description: (
        <>
          Safe, well-organised transfers from Jannali to Sydney Airport or
          business locations. Your team travels without worry.
        </>
      ),
      image: "/briefcase.png",
      pathname: "/services/corporate-tips",
    },

    S009: {
      service_id: "S009",
      title: "Reliable Airport Transfers",
      description: (
        <>
          Reliable 24/7 option across Jannali for everyday trips,
          appointments, and leisure activities.
        </>
      ),
      image: "/airport.png",
      pathname: "/services/taxi-sydney-service",
    },

    S010: {
      service_id: "S010",
      title: "Emergency Taxi",
      description: (
        <>
          Urgent situation? Our Emergency Taxi in Jannali responds rapidly.
          We prioritise your safety and speed.
        </>
      ),
      image: "/emergency.png",
      pathname: "/book-a-taxi",
    },
  },

  fleetSectionTitle: "Premium Fleet for Your Jannali Transfer",
  fleetSectionSubTitle: (
    <>
      Choose from varied vehicles matching your group size and comfort
      preferences.{" "}
      <Link
        to={`/services/maxi-taxi-service`}
        className="underline font-semibold px-1"
      >
        Our fleet
      </Link>{" "}
      emphasises safety, space, and smooth journeys. Solo travellers find
      ideal options. Full groups receive suitable choices too.
    </>
  ),

  fleetSectionVehicles: {
    1: {
      id: 1,
      name: "Easy Sedan",
      passengerCapacity: 4,
      bagsCapacity: 2,
      description: (
        <>
          Perfect for individual riders or couples seeking peaceful, comfortable
          trips with our reliable Door-to-Door Taxi Service throughout Manly
          Vale.
        </>
      ),
      image: "/campbelltown-easy-sedan.png",
    },

    2: {
      id: 2,
      name: "Luxury Vehicle",
      passengerCapacity: 4,
      bagsCapacity: 2,
      description: (
        <>
          Ideal for VIPs and business guests who value privacy, quality leather
          seating, and polished presentation on every journey.
        </>
      ),
      image: "/campbelltown-luxury-vehicle.png",
    },

    3: {
      id: 3,
      name: "Suv or Wagon",
      passengerCapacity: 7,
      bagsCapacity: 5,
      description: (
        <>
          Additional room for passengers and luggage. Excellent choice for
          families or small groups heading to Sydney Airport with comfort.
        </>
      ),
      image: "/campbelltown-suv-wagon.png",
    },

    4: {
      id: 4,
      name: "Kia Carnival",
      passengerCapacity: 7,
      bagsCapacity: 8,
      description: (
        <>
          Fits 6–7 passengers comfortably. Substantial luggage capacity suits
          group transfers, family holidays, and longer trips.
        </>
      ),
      image: "/campbelltown-kia-carnival.png",
    },

    5: {
      id: 5,
      name: "Maxi Taxi",
      passengerCapacity: 11,
      bagsCapacity: 8,
      description: (
        <>
          Constructed for larger groups or big families wanting spacious, clean
          interiors and a completely relaxed travel experience together.
        </>
      ),
      image: "/campbelltown-maxi-taxi.png",
    },

    6: {
      id: 6,
      name: "Wheelchair Taxi Service",
      passengerCapacity: 7,
      bagsCapacity: 8,
      description: (
        <>
          Provides accessible transport with professionally trained drivers and
          appropriate safety features for all mobility needs and comfort.
        </>
      ),
      image: "/campbelltown-maxi-taxi.png",
    },
  },

  faqSectionTitle:
    "Frequently Asked Questions About Taxi Service in Jannali",
  faqs: [
    {
      question: "How do I get from Jannali to Sydney Airport quickly?",
      answer: (
        <>
          Book with us. We know the fastest routes. Avoid Spit Bridge delays.
          Flight tracking included. Arrive relaxed.
        </>
      ),
    },
    {
      question: "Can I book a taxi for Jannali beach trips?",
      answer: (
        <>
          Yes. We service nearby beaches. Manly, Freshwater, Curl Curl.
          Surfboards fit in <Link
        to={`https://en.wikipedia.org/wiki/Maxi_taxi`}
        className="underline font-semibold px-1"
        target="_blank"
      >
        maxi
      </Link> cabs. Beach days sorted.
        </>
      ),
    },
    {
      question: "Do your drivers know Balgowlah and Fairlight shortcuts?",
      answer: (
        <>
          Absolutely. Northern Beaches locals. Back streets mapped. Traffic
          avoided. You get savvy route planners.
        </>
      ),
    },
    {
      question: "What if I need a taxi during Jannali's peak hour?",
      answer: (
        <>
          We plan. Alternative routes are ready. Your pickup stays on time.
          Rush hour is handled professionally.
        </>
      ),
    },
    {
      question: "Can I request a female driver for Jannali trips?",
      answer: (
        <>
          Ask when booking. We accommodate when possible. Your comfort drives
          our service. Preferences noted.
        </>
      ),
    },
    {
      question: "Do you offer Jannali to North Sydney direct?",
      answer: (
        <>
          Yes. Direct business district runs. Fixed rates available. Avoid
          parking hassles. Arrive ready for meetings.
        </>
      ),
    },
    {
      question: "How do I arrange wheelchair transport in Jannali?",
      answer: (
        <>
          State needs when calling. Proper vehicle dispatched. Drivers assist
          carefully. Accessibility guaranteed with dignity.
        </>
      ),
    },
    {
      question: "Are your Jannali taxis suitable for elderly passengers?",
      answer: (
        <>
          Yes. Patient assistance. Comfortable seating. Step help provided.
          Regular medical trip bookings are warmly accepted.
        </>
      ),
    },
    {
      question: "Can I set up corporate accounts for Jannali travel?",
      answer: (
        <>
          Business accounts available. Monthly statements. Priority service.
          Expense management simplified. Professional standards maintained.
        </>
      ),
    },
    {
      question: "What makes you different from rideshare in Jannali?",
      answer: (
        <>
          Phone bookings accepted. Fixed pricing. Local knowledge. No surge
          charges. Personalised service every trip.
        </>
      ),
    },
    {
      question: "Do you provide Jannali school transport services?",
      answer: (
        <>
          Yes. Regular student pickups. Safety seats fitted. Punctuality
          assured. Parents trust our reliable service.
        </>
      ),
    },
    {
      question: "How early should I book wedding cars for Jannali?",
      answer: (
        <>
          Secure months ahead for summer. Multiple vehicles coordinated. Your
          celebration transport is perfected.
        </>
      ),
    },
    {
      question: "Can I pay with CabCharge for Jannali airport runs?",
      answer: (
        <>
          CabCharge welcome. Corporate cards accepted. Cash and EFTPOS too.
          Flexible payment options are provided.
        </>
      ),
    },
    {
      question: "What happens if my flight arrives early at Sydney Airport?",
      answer: (
        <>
          Live tracking is active. The driver adjusts the pickup. No waiting
          fees. Seamless collection guaranteed every time.
        </>
      ),
    },
    {
      question:
        "Do you service all Jannali streets including cul-de-sacs?",
      answer: (
        <>
          Yes. Every address found. Narrow streets navigated. Your location is
          reached without confusion or delay.
        </>
      ),
    },
  ],
},
"como-nsw": {
  mapUrl:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d13228.382236008098!2d151.0641304!3d-34.015758!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12b8967dcbd49d%3A0x5017d681632b280!2sComo%20NSW%202226%2C%20Australia!5e0!3m2!1sen!2sbd!4v1774724898784!5m2!1sen!2sbd",
  pageTitle:
    "Taxi & Maxi Cabs Services in Como, NSW - Cruise, Airport Transfers & Local",
  metaDescription:
    "Book Taxi & Maxi Cabs Services in Como for cruise transfers, wedding transport & 24/7 emergency taxi. Expert local drivers & transparent pricing. Call now!",
  heroTitle:
    "24/7 Taxi & Maxi Cabs Services in Como for Local & Airport Travel",
  heroDescription: (
    <>
      After dependable transport around Como? Our
      <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
        Taxi & Maxi Cabs Services
      </Link>
      in Como promise a rapid response every time you call. We handle
      your local trips with military precision that never disappoints. Our
      vehicles suit lone commuters and huge crowds equally well. You gain
      generous cabin space for riders and luggage combined. Nobody faces
      exclusion or tight squeezes inside. We operate day and night without
      pause. Your plane might land at midnight. Your function could end at
      dawn. Either way, we show up ready. Select our elite tier for added
      comfort. We execute flawless Como pick up and drop off to protect
      your schedule. You avoid delays. You skip stress.
      <Link to={`/`} className="underline font-semibold px-1">
        Campbelltown Taxi Cabs
      </Link>{" "}
      prioritises your timetable always.
    </>
  ),
  bookingFormTitle: "Book Baby Taxi in Como NSW",
  locationSectionTitle: "Reliable Taxi Service in Como for Groups",
  locationSectionDescription: (
    <>
      Taking family or friends somewhere nice? Our  <Link
        to={`/book-a-taxi`}
        className="underline font-semibold px-1"
      >
        Como Taxi Service
      </Link>
      accommodates small and large groups ideally. Everyone rides together in
      one car. You bypass the hassle of splitting into multiple vehicles. You
      eliminate confusing coordination. Through our dedicated
      <Link
        to={`/services/maxi-taxi-service`}
        className="underline font-semibold px-1"
      >
        Maxi Cab Services in Como,
      </Link>
      each guest enjoys safe, comfortable travel. Perhaps you depart Como
      bound for Sydney Airport. Perhaps you return home after a long trip. We
      stick to our promises. Our drivers know the best routes. They avoid
      traffic jams. They minimise waiting time. You can trust our Group
      Transport Como options when needing space, reliability, and clean
      interiors. Booking takes seconds via our online portal. You receive
      confirmation quickly. You travel with confidence.
    </>
  ),
  locationSection2Title:
    "Taxi Service in Como with Affordable Maxi Cabs & Local Travel",
  locationSection2Desctiption: (
    <>
      We believe affordable should never mean uncomfortable. Our
      <Link
        to={`/book-a-taxi`}
        className="underline font-semibold px-1"
      >
        Local Taxi Service
      </Link>
      in Como offers fair rates with complete transparency. You see the
      price before booking. You plan your budget with assurance. This helps
      when travelling with others. You can book a
      <Link
        to={`/services/maxi-taxi-service`}
        className="underline font-semibold px-1"
      >
        Maxi Cab for Group Travel
      </Link>{" "}
      that handles multiple passengers plus bags. Want something nicer? Upgrade
      to our <Link
        to={`/services/luxury-transfer`}
        className="underline font-semibold px-1"
      >
        luxury service
      </Link> for refined travel. Families can request
      <Link
        to={`/services/baby-seat-taxi-sydney`}
        className="underline font-semibold px-1"
      >
        Baby Seat Taxi
      </Link>{" "}
      options. Your children ride in approved, properly fitted seats. Our
      drivers bring experience and courtesy. They assist with special needs.
      They help with luggage. From early morning flights to late-night
      arrivals, our 24/7 Taxi Como keeps you moving. Campbelltown{" "}
      <Link
        to={`/book-a-taxi`}
        className="underline font-semibold px-1"
      >
        Taxi & Maxi Cabs
      </Link>{" "}
      commits to safe, reliable, stress-free transport for every customer.
    </>
  ),
  locationSection3Title:
    "Comfortable Corporate & Baby Seat Taxi Booking in Como",
  locationSection3Description: (
    <>
      Our
      <Link
        to={`/book-a-taxi`}
        className="underline font-semibold px-1"
      >
        Taxi Service in Como
      </Link>{" "}
      provides ample legroom. You get plenty of luggage space. You relax even
      when the vehicle is full. You avoid cramped seating. You miss awkward bag
      arrangements. Your journey becomes pleasant. Choosing our Taxi & Maxi
      Cabs Services in Como lets your group focus on the trip. We
      specialise in group transfers for families, sports teams, and work crews.
      Everyone arrives together. Booking is swift through our Como Cab
      Booking page. You organise transport in advance. Business travellers can
      use our
      <Link
        to={`/services/corporate-tips`}
        className="underline font-semibold px-1"
      >
        Corporate Taxi Service
      </Link>{" "}
      for punctual, professional rides to meetings. Families add Baby Seat Taxi
      options for safer trips with young children. When style matters, our
      luxury service delivers extra comfort. Every vehicle receives regular
      cleaning. We maintain high standards. You enjoy smooth, secure travel
      without traffic concerns.
    </>
  ),
  locationSection4Title:
    "Reliable Como Taxi & Maxi Cab: Premium Solutions for All Your Travel Needs",
  locationSection4Desctiption: (
    <>
      Discover <Link
        to={`/services/book-taxi-sydney-airport`}
        className="underline font-semibold px-1"
      >
      professional transport
      </Link> designed specifically for Como
      residents and visitors. Our comprehensive range delivers exactly what you
      need, whether catching an early flight or arranging
      <Link
        to={`/services/wedding-transfer`}
        className="underline font-semibold px-1"
      >
        wedding transport
      </Link>{" "}
      for many guests. We provide
      <Link
        to={`/services/book-taxi-sydney-airport`}
        className="underline font-semibold px-1"
      >
        Airport Transfers in Como
      </Link>{" "}
      with real-time flight monitoring, Maxi Cab Services accommodating up to
      eleven passengers,
      <Link
        to={`/services/baby-seat-taxi-sydney`}
        className="underline font-semibold px-1"
      >
        Baby Seat Taxi
      </Link>{" "}
      options with certified restraints, and Local Taxi Service for daily
      errands. Business professionals rely on our Corporate Taxi Service, while
      luxury seekers choose our Premium Service. We specialise in Wedding
      Transport,
      <Link
        to={`/services/event-transfer`}
        className="underline font-semibold px-1"
      >
        Event Transport,
      </Link>{" "}
      Cruise Transfers, Group Transport for large parties, and
      <Link
        to={`/services/wheelchair-accessible-taxi`}
        className="underline font-semibold px-1"
      >
        Wheelchair Accessible Taxi
      </Link>{" "}
      services. Every trip includes clear upfront pricing, genuine 24/7
      availability, and experienced local drivers who know Como
      thoroughly. From Door-to-Door Taxi Service to complex logistics,
      <Link
        to={`/`}
        className="underline font-semibold px-1"
      >
       Campbelltown Taxi & Maxi Cabs
      </Link> combines deep local knowledge with
      consistent reliability—because your destination matters, and arriving
      there should feel effortless.
    </>
  ),
  locationSectionImg: corporateTripsImg,
  serviceTitle: "Taxi and Maxi Cab Solutions Como for Every Occasion",
  serviceSubtitle: (
    <>
      We adjust transport to match your specific requirements. Our
      <Link to={`/`} className="underline font-semibold px-1">
        Taxi & Maxi Cabs Services
      </Link>{" "}
      in Como support family holidays, group outings, and business
      travel. Safety and punctuality guide our operations. Every vehicle looks
      professional. Every driver trains thoroughly. You depend on us for
      airport transfers, special celebrations, and business trips. Each ride
      remains simple and relaxed.
    </>
  ),

  cabChargeSectionTitle: "CabCharge Taxi Near Como",
  cabChargeSectionDesctiption: (
    <>
      Need flexible payment for work or personal travel? Our
      <Link
        to={`/cabcharge-taxi`}
        className="underline font-semibold px-1"
      >
        CabCharge Taxi Service in Como
      </Link>
      makes every journey simple and traceable. We accept secure CabCharge
      Payments, including the convenient CabCharge Card, perfect for corporate
      travellers and authorised users. Enjoy cashless transactions, clear trip
      records, and straightforward billing every time. Dependable transport
      backed by trusted Cabcharge payment options.
    </>
  ),

  locationServices: {
    S001: {
      service_id: "S001",
      title: "Wedding Transfer",
      description: (
        <>
          Travel in spacious vehicles. Bridal parties, relatives, and guests
          enjoy elegant, comfortable rides to and from venues.
        </>
      ),
      image: "/car.png",
      pathname: "/services/wedding-transfer",
    },

    S002: {
      service_id: "S002",
      title: "Luxury Transfer",
      description: (
        <>
          Choose our luxury option for VIP transfers, executive travel, and
          clients expecting superior privacy and comfort standards.
        </>
      ),
      image: "/vehicle.png",
      pathname: "/services/luxury-transfer",
    },

    S003: {
      service_id: "S003",
      title: "Baby Seat Taxi Sydney",
      description: (
        <>
          Families reserve vehicles with approved child seats. Young passengers
          remain secure throughout the journey.
        </>
      ),
      image: "/baby-seat.png",
      pathname: "/services/baby-seat-taxi-sydney",
    },

    S004: {
      service_id: "S004",
      title: "Corporate Transport Services",
      description: (
        <>
          Designed for meetings and group business travel. Timely collections
          support demanding schedules.
        </>
      ),
      image: "/corporate.png",
      pathname: "/services/corporate-transport-services",
    },

    S005: {
      service_id: "S005",
      title: "Cruise Terminal Transfer",
      description: (
        <>
          Enjoy smooth journeys between Como and the cruise terminals.
          Plenty of space handles passengers and luggage together.
        </>
      ),
      image: "/ship.png",
      pathname: "/services/cruise-terminal-transfer",
    },

    S006: {
      service_id: "S006",
      title: "Event Transfer",
      description: (
        <>
          Use our service for concerts, parties, and social gatherings. Arrive
          punctually. Avoid parking difficulties.
        </>
      ),
      image: "/event.png",
      pathname: "/services/event-transfer",
    },

    S007: {
      service_id: "S007",
      title: "Maxi Taxi Service",
      description: (
        <>
          Ideal for larger groups in Como. Generous seating and luggage
          capacity keep everyone together.
        </>
      ),
      image: "/users.png",
      pathname: "/services/maxi-taxi-service",
    },

    S008: {
      service_id: "S008",
      title: "Corporate Trips",
      description: (
        <>
          Safe, well-organised transfers from Como to Sydney Airport or
          business locations. Your team travels without worry.
        </>
      ),
      image: "/briefcase.png",
      pathname: "/services/corporate-tips",
    },

    S009: {
      service_id: "S009",
      title: "Reliable Airport Transfers",
      description: (
        <>
          Reliable 24/7 option across Como for everyday trips,
          appointments, and leisure activities.
        </>
      ),
      image: "/airport.png",
      pathname: "/services/taxi-sydney-service",
    },

    S010: {
      service_id: "S010",
      title: "Emergency Taxi",
      description: (
        <>
          Urgent situation? Our Emergency Taxi in Como responds rapidly.
          We prioritise your safety and speed.
        </>
      ),
      image: "/emergency.png",
      pathname: "/book-a-taxi",
    },
  },

  fleetSectionTitle: "Premium Fleet for Your Como Transfer",
  fleetSectionSubTitle: (
    <>
      Choose from varied vehicles matching your group size and comfort
      preferences.{" "}
      <Link
        to={`/services/maxi-taxi-service`}
        className="underline font-semibold px-1"
      >
        Our fleet
      </Link>{" "}
      emphasises safety, space, and smooth journeys. Solo travellers find
      ideal options. Full groups receive suitable choices too.
    </>
  ),

  fleetSectionVehicles: {
    1: {
      id: 1,
      name: "Easy Sedan",
      passengerCapacity: 4,
      bagsCapacity: 2,
      description: (
        <>
          Perfect for individual riders or couples seeking peaceful, comfortable
          trips with our reliable Door-to-Door Taxi Service throughout Manly
          Vale.
        </>
      ),
      image: "/campbelltown-easy-sedan.png",
    },

    2: {
      id: 2,
      name: "Luxury Vehicle",
      passengerCapacity: 4,
      bagsCapacity: 2,
      description: (
        <>
          Ideal for VIPs and business guests who value privacy, quality leather
          seating, and polished presentation on every journey.
        </>
      ),
      image: "/campbelltown-luxury-vehicle.png",
    },

    3: {
      id: 3,
      name: "Suv or Wagon",
      passengerCapacity: 7,
      bagsCapacity: 5,
      description: (
        <>
          Additional room for passengers and luggage. Excellent choice for
          families or small groups heading to Sydney Airport with comfort.
        </>
      ),
      image: "/campbelltown-suv-wagon.png",
    },

    4: {
      id: 4,
      name: "Kia Carnival",
      passengerCapacity: 7,
      bagsCapacity: 8,
      description: (
        <>
          Fits 6–7 passengers comfortably. Substantial luggage capacity suits
          group transfers, family holidays, and longer trips.
        </>
      ),
      image: "/campbelltown-kia-carnival.png",
    },

    5: {
      id: 5,
      name: "Maxi Taxi",
      passengerCapacity: 11,
      bagsCapacity: 8,
      description: (
        <>
          Constructed for larger groups or big families wanting spacious, clean
          interiors and a completely relaxed travel experience together.
        </>
      ),
      image: "/campbelltown-maxi-taxi.png",
    },

    6: {
      id: 6,
      name: "Wheelchair Taxi Service",
      passengerCapacity: 7,
      bagsCapacity: 8,
      description: (
        <>
          Provides accessible transport with professionally trained drivers and
          appropriate safety features for all mobility needs and comfort.
        </>
      ),
      image: "/campbelltown-maxi-taxi.png",
    },
  },

  faqSectionTitle:
    "Frequently Asked Questions About Taxi Service in Como",
  faqs: [
    {
      question: "How do I get from Como to Sydney Airport quickly?",
      answer: (
        <>
          Book with us. We know the fastest routes. Avoid Spit Bridge delays.
          Flight tracking included. Arrive relaxed.
        </>
      ),
    },
    {
      question: "Can I book a taxi for Como beach trips?",
      answer: (
        <>
          Yes. We service nearby beaches. Manly, Freshwater, Curl Curl.
          Surfboards fit in <Link
        to={`https://en.wikipedia.org/wiki/Maxi_taxi`}
        className="underline font-semibold px-1"
        target="_blank"
      >
        maxi
      </Link> cabs. Beach days sorted.
        </>
      ),
    },
    {
      question: "Do your drivers know Balgowlah and Fairlight shortcuts?",
      answer: (
        <>
          Absolutely. Northern Beaches locals. Back streets mapped. Traffic
          avoided. You get savvy route planners.
        </>
      ),
    },
    {
      question: "What if I need a taxi during Como's peak hour?",
      answer: (
        <>
          We plan. Alternative routes are ready. Your pickup stays on time.
          Rush hour is handled professionally.
        </>
      ),
    },
    {
      question: "Can I request a female driver for Como trips?",
      answer: (
        <>
          Ask when booking. We accommodate when possible. Your comfort drives
          our service. Preferences noted.
        </>
      ),
    },
    {
      question: "Do you offer Como to North Sydney direct?",
      answer: (
        <>
          Yes. Direct business district runs. Fixed rates available. Avoid
          parking hassles. Arrive ready for meetings.
        </>
      ),
    },
    {
      question: "How do I arrange wheelchair transport in Como?",
      answer: (
        <>
          State needs when calling. Proper vehicle dispatched. Drivers assist
          carefully. Accessibility guaranteed with dignity.
        </>
      ),
    },
    {
      question: "Are your Como taxis suitable for elderly passengers?",
      answer: (
        <>
          Yes. Patient assistance. Comfortable seating. Step help provided.
          Regular medical trip bookings are warmly accepted.
        </>
      ),
    },
    {
      question: "Can I set up corporate accounts for Como travel?",
      answer: (
        <>
          Business accounts available. Monthly statements. Priority service.
          Expense management simplified. Professional standards maintained.
        </>
      ),
    },
    {
      question: "What makes you different from rideshare in Como?",
      answer: (
        <>
          Phone bookings accepted. Fixed pricing. Local knowledge. No surge
          charges. Personalised service every trip.
        </>
      ),
    },
    {
      question: "Do you provide Como school transport services?",
      answer: (
        <>
          Yes. Regular student pickups. Safety seats fitted. Punctuality
          assured. Parents trust our reliable service.
        </>
      ),
    },
    {
      question: "How early should I book wedding cars for Como?",
      answer: (
        <>
          Secure months ahead for summer. Multiple vehicles coordinated. Your
          celebration transport is perfected.
        </>
      ),
    },
    {
      question: "Can I pay with CabCharge for Como airport runs?",
      answer: (
        <>
          CabCharge welcome. Corporate cards accepted. Cash and EFTPOS too.
          Flexible payment options are provided.
        </>
      ),
    },
    {
      question: "What happens if my flight arrives early at Sydney Airport?",
      answer: (
        <>
          Live tracking is active. The driver adjusts the pickup. No waiting
          fees. Seamless collection guaranteed every time.
        </>
      ),
    },
    {
      question:
        "Do you service all Como streets including cul-de-sacs?",
      answer: (
        <>
          Yes. Every address found. Narrow streets navigated. Your location is
          reached without confusion or delay.
        </>
      ),
    },
  ],
},
 "engadine-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d13230.603483928577!2d151.06404824999998!3d-34.00150035!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12c1112c138bc7%3A0x5017d681632b670!2sEngadine%20NSW%202233%2C%20Australia!5e0!3m2!1sen!2sbd!4v1774724962257!5m2!1sen!2sbd",
    pageTitle:
      "Taxi & Maxi Cabs Services in Engadine, NSW - Family & Local Travel Experts",
    metaDescription:
      "Book Taxi & Maxi Cabs Services in Engadine for family travel, local trips & cruise transfers. Trusted drivers, baby seat options & fixed pricing available. Book now!",
    heroTitle:
      "24/7 Taxi & Maxi Cabs Services in Engadine for Fast & Safe Travel",
    heroDescription: (
      <>
        Need dependable rides around Engadine? Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs Services
        </Link>
        in Engadine deliver quick pickups every time you call. We handle your
        local trips with sharp timing that never fails. Our vehicles fit single
        travellers and large groups equally well. You get plenty of cabin space
        for people and luggage together. No one gets left out or squeezed inside.
        We run day and night without stopping. Your flight might land at 2 AM.
        Your shift could end at sunrise. Either way, we show up fast. Choose our
        luxury option for extra comfort. We manage smooth Engadine pick up and
        drop off to keep your schedule on track. You avoid delays. You skip
        stress.
        <Link to={`/`} className="underline font-semibold px-1">
          Campbelltown Taxi Cabs
        </Link>{" "}
        puts your timetable first always.
      </>
    ),
    bookingFormTitle: "Book Baby Taxi in Engadine NSW",
    locationSectionTitle: "Reliable Taxi Service in Engadine for Groups",
    locationSectionDescription: (
      <>
        Taking family or friends somewhere nice? Our Engadine Taxi Service suits
        small and large groups perfectly. Everyone travels together in one car.
        You miss the hassle of splitting into different vehicles. You avoid
        confusing planning. Through our dedicated
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab Services in Engadine,
        </Link>
        each person enjoys safe, comfortable travel. Maybe you leave Engadine
        for Sydney Airport. Maybe you head home after long trips. We keep our
        promises on timing. Our drivers know the best routes. They avoid traffic
        jams. They cut the waiting time. You can trust our Group Transport Curl
        Curl options when you need space, reliability, and clean cars. Booking
        takes seconds through our online system. You get confirmation quickly.
        You travel with confidence.
      </>
    ),
    locationSection2Title:
      "Affordable Taxi Service in Engadine with Maxi Cabs: safe and 24/7 transport",
    locationSection2Desctiption: (
      <>
        We believe cheap should never mean uncomfortable. Our
        <Link
          to={`/book-a-taxi`}
          className="underline font-semibold px-1"
        >
          Local Taxi Service
        </Link>
        in Engadine offers fair prices with full clarity. You see the cost
        before booking. You plan your budget with assurance. This helps when
        travelling with others. You can book a
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab for Group Travel
        </Link>{" "}
        that carries many passengers plus bags. Want something better? Upgrade to
        our premium service for nicer travel. Families can ask for
        <Link
          to={`/services/baby-seat-taxi-sydney`}
          className="underline font-semibold px-1"
        >
          Baby Seat Taxi
        </Link>{" "}
        options. Your children ride in approved, properly fitted seats. Our
        drivers have experience and manners. They help with special needs. They
        assist with luggage. From early flights to late arrivals, our 24/7 Taxi
        Engadine keeps you moving. Campbelltown{" "}
        <Link
          to={`/book-a-taxi`}
          className="underline font-semibold px-1"
        >
          Taxi & Maxi Cabs
        </Link>{" "}
        promises safe, reliable, stress-free transport for every customer.
      </>
    ),
    locationSection3Title:
      "Comfortable Corporate & Baby Seat Taxi Booking in Engadine",
    locationSection3Description: (
      <>
        Our
        <Link
          to={`/book-a-taxi`}
          className="underline font-semibold px-1"
        >
          Taxi Service in Engadine
        </Link>{" "}
        gives you lots of legroom. You get plenty of luggage space. You relax
        even when the car is full. You avoid tight seating. You miss awkward bag
        packing. Your trip becomes pleasant. Choosing our Taxi & Maxi Cabs
        Services in Engadine lets your group focus on the journey. We specialise
        in group transfers for families, sports teams, and work groups. Everyone
        arrives together. Booking is fast through our Engadine Cab Booking page.
        You arrange transport early. Business travellers can use our
        <Link
          to={`/services/corporate-tips`}
          className="underline font-semibold px-1"
        >
          Corporate Taxi Service
        </Link>{" "}
        for on-time, professional rides to meetings. Families add Baby Seat Taxi
        options for safer trips with young children. When style matters, our
        premium service gives extra comfort. Every car gets cleaned regularly. We
        keep high standards. You enjoy smooth, safe travel without traffic
        worries.
      </>
    ),
    locationSection4Title:
      "Reliable Engadine Taxi & Maxi Cab: Premium Solutions for All Your Travel Needs",
    locationSection4Desctiption: (
      <>
        Find professional transport made for Engadine residents and visitors.
        Our full range gives you exactly what you need, whether catching early
        flights or arranging
        <Link
          to={`/services/wedding-transfer`}
          className="underline font-semibold px-1"
        >
          wedding transport
        </Link>{" "}
        for many guests. We provide
        <Link
          to={`/services/book-taxi-sydney-airport`}
          className="underline font-semibold px-1"
        >
          Airport Transfers in Engadine
        </Link>{" "}
        with live flight tracking, Maxi Cab Services fitting up to eleven
        passengers,
        <Link
          to={`/services/baby-seat-taxi-sydney`}
          className="underline font-semibold px-1"
        >
          Baby Seat Taxi
        </Link>{" "}
        options with certified restraints, and Local Taxi Service for daily
        tasks. Business people rely on our Corporate Taxi Service, while those
        wanting luxury choose our Premium Service. We specialise in Wedding
        Transport,
        <Link
          to={`/services/event-transfer`}
          className="underline font-semibold px-1"
        >
          Event Transport,
        </Link>{" "}
        Cruise Transfers, Group Transport for large parties, and
        <Link
          to={`/services/wheelchair-accessible-taxi`}
          className="underline font-semibold px-1"
        >
          Wheelchair Accessible Taxi
        </Link>{" "}
        services. Every trip includes clear upfront pricing, real 24/7
        availability, and experienced local drivers who know Engadine well. From
        Door-to-Door Taxi Service to complex plans, Campbelltown Taxi & Maxi Cabs
        combines deep local knowledge with steady reliability—because your
        destination matters, and getting there should feel easy.
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle: "Taxi and Maxi Cab Solutions, Engadine for Every Occasion",
    serviceSubtitle: (
      <>
        We adjust transport to match your needs. Our
        <Link to={`/`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs Services
        </Link>{" "}
        in Engadine support family holidays, group outings, and business travel.
        Safety and punctuality guide everything we do. Every vehicle looks neat.
        Every driver trains well. You depend on us for airport trips, special
        events, and work journeys. Each ride stays simple and relaxed.
      </>
    ),
  
    cabChargeSectionTitle: "CabCharge Taxi Near Engadine",
    cabChargeSectionDesctiption: (
      <>
        Need flexible payment for work or personal trips? Our
        <Link
          to={`/cabcharge-taxi`}
          className="underline font-semibold px-1"
        >
          CabCharge Taxi Service in Engadine
        </Link>
        makes every journey simple and trackable. We accept secure CabCharge
        Payments, including the handy CabCharge Card, perfect for company
        travellers and approved users. Enjoy cashless payments, clear trip
        records, and easy billing every time. Dependable transport backed by
        trusted Cabcharge payment options.
      </>
    ),
  
    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            Travel in roomy vehicles. Bridal parties, relatives, and guests enjoy
            nice, comfortable rides to and from venues.
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },
  
      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            Pick our luxury option for VIP transfers, executive travel, and
            clients wanting more privacy and comfort.
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },
  
      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Families book cars with approved child seats. Young passengers stay
            safe throughout the trip.
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },
  
      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            Made for meetings and group business travel. On-time pickups help
            busy schedules.
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },
  
      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Enjoy easy trips between Engadine and cruise terminals. Plenty of
            space handles passengers and luggage together.
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },
  
      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            Use our service for concerts, parties, and social gatherings. Arrive
            on time. Avoid parking problems.
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },
  
      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            Ideal for larger groups in Engadine. Roomy seating and luggage space
            keep everyone together.
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },
  
      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            Safe, well-organised transfers from Engadine to Sydney Airport or
            business locations. Your team travels without worry.
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },
  
      S009: {
        service_id: "S009",
        title: "Reliable Airport Transfers",
        description: (
          <>
            Reliable 24/7 option across Engadine for everyday trips,
            appointments, and leisure activities.
          </>
        ),
        image: "/airport.png",
        pathname: "/services/taxi-sydney-service",
      },
  
      S010: {
        service_id: "S010",
        title: "Emergency Taxi",
        description: (
          <>
            Urgent need? Our Emergency Taxi in Engadine responds fast. We put
            your safety and speed first.
          </>
        ),
        image: "/emergency.png",
        pathname: "/book-a-taxi",
      },
    },
  
    fleetSectionTitle: "Premium Fleet for Your Engadine Transfer",
    fleetSectionSubTitle: (
      <>
        Choose from different vehicles matching your group size and comfort
        needs.
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Our fleet
        </Link>{" "}
        focuses on safety, space, and smooth rides. Solo travellers find good
        matches. Full groups get suitable options too.
      </>
    ),
  
    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Perfect for single riders or couples wanting quiet, comfortable trips
            with our reliable Door-to-Door Taxi Service throughout Engadine.
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },
  
      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Great for VIPs and business guests who value privacy, quality leather
            seats, and smart presentation on every trip.
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },
  
      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            Extra room for passengers and luggage. Good choice for families or
            small groups heading to Sydney Airport with comfort.
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },
  
      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Fits 6–7 passengers comfortably. Large luggage capacity suits group
            transfers, family holidays, and longer trips.
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },
  
      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Built for bigger groups or large families wanting spacious, clean
            interiors and a fully relaxed travel experience together.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
  
      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Provides accessible transport with properly trained drivers and the
            right safety features for all mobility needs and comfort.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },
  
    faqSectionTitle:
      "Frequently Asked Questions About Taxi Service in Engadine",
    faqs: [
      {
        question: "Which coastal spots near Engadine do you cover?",
        answer: (
          <>
            We service Engadine Beach, Freshwater, and Dee Why. Surf trips
            welcome. Boards fit in <Link
          to={`https://en.wikipedia.org/wiki/Maxi_taxi`}
          className="underline font-semibold px-1"
          target="_blank"
        >Maxi
        </Link> cabs. Beach transport sorted.
          </>
        ),
      },
      {
        question: "How do I arrange transport from Engadine to Manly Wharf?",
        answer: (
          <>
            Ring 1300 450 428. Short trips our specialty. Ferry connections are
            timed. Quick, reliable service every time.
          </>
        ),
      },
      {
        question: "Can I book a maxi cab for Engadine surf club functions?",
        answer: (
          <>
            Yes. We carry surfboards, gear, and teams. Nippers' events covered.
            Beach transport expertise guaranteed.
          </>
        ),
      },
      {
        question: "Do your drivers know ways around Pittwater Road congestion?",
        answer: (
          <>
            Absolutely. Northern Beaches locals. Traffic hotspots avoided. Back
            streets mastered. You get smart navigators.
          </>
        ),
      },
      {
        question: "What if I need a taxi for the Engadine dawn patrol surfing?",
        answer: (
          <>
            Early surf trips welcome. 4 AM pickups arranged. Wetsuit-friendly
            vehicles. Your wave chase is supported.
          </>
        ),
      },
      {
        question: "Can I ask for the same driver for regular Engadine trips?",
        answer: (
          <>
            Request when booking. Preferences noted. Same driver when possible.
            Relationship builds over time.
          </>
        ),
      },
      {
        question: "How do I organise wheelchair transport to Engadine Beach?",
        answer: (
          <>
            State needs when calling. Beach access vehicles are available. Help
            provided. Inclusion matters to us.
          </>
        ),
      },
      {
        question: "Are your Engadine taxis pet-friendly for vet visits?",
        answer: (
          <>
            Small pets in carriers are accepted. Harbord Vet trips are common.
            Service animals are always welcome. Mention when booking.
          </>
        ),
      },
      {
        question: "Can I set up account billing for Engadine business travel?",
        answer: (
          <>
            Corporate accounts available. Monthly statements. Priority bookings.
            Expense management simplified.
          </>
        ),
      },
      {
        question: "What sets you apart from rideshare apps in Engadine?",
        answer: (
          <>
            Phone bookings. Fixed rates. Local knowledge. No surge pricing.
            Personal service every trip.
          </>
        ),
      },
     
      {
        question: "How early should I book wedding cars for Engadine ceremonies?",
        answer: (
          <>
            Secure months ahead. Beach weddings are popular. Multiple vehicles
            coordinated. Your special day is perfected.
          </>
        ),
      },
      {
        question: "Can I pay with CabCharge for Engadine airport transfers?",
        answer: (
          <>
            CabCharge welcome. Corporate cards accepted. Cash and EFTPOS too.
            Flexible payment options.
          </>
        ),
      },
      {
        question: "What happens if my flight arrives early at Sydney Airport?",
        answer: (
          <>
            Live tracking is active. The driver adjusts the pickup. No waiting
            fees. Seamless collection guaranteed.
          </>
        ),
      },
      {
        question: "Do you service all Engadine streets including beachside lanes?",
        answer: (
          <>
            Yes. Every address found. Narrow lanes navigated. Beachfront pickups
            arranged. No confusion.
          </>
        ),
      },
    ],
  },
 "loftus-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d26443.65932024513!2d151.01793115!3d-34.0577868!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12c12159a0f437%3A0x5017d681632bec0!2sLoftus%20NSW%202232%2C%20Australia!5e0!3m2!1sen!2sbd!4v1774725023475!5m2!1sen!2sbd",
    pageTitle:
      "Taxi & Maxi Cabs Services in Loftus, NSW - Family & Local Travel Experts",
    metaDescription:
      "Book Taxi & Maxi Cabs Services in Loftus for family travel, local trips & cruise transfers. Trusted drivers, baby seat options & fixed pricing available. Book now!",
    heroTitle:
      "24/7 Taxi & Maxi Cabs Services in Loftus for Fast & Safe Travel",
    heroDescription: (
      <>
        Need dependable rides around Loftus? Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs Services
        </Link>
        in Loftus deliver quick pickups every time you call. We handle your
        local trips with sharp timing that never fails. Our vehicles fit single
        travellers and large groups equally well. You get plenty of cabin space
        for people and luggage together. No one gets left out or squeezed inside.
        We run day and night without stopping. Your flight might land at 2 AM.
        Your shift could end at sunrise. Either way, we show up fast. Choose our
        luxury option for extra comfort. We manage smooth Loftus pick up and
        drop off to keep your schedule on track. You avoid delays. You skip
        stress.
        <Link to={`/`} className="underline font-semibold px-1">
          Campbelltown Taxi Cabs
        </Link>{" "}
        puts your timetable first always.
      </>
    ),
    bookingFormTitle: "Book Baby Taxi in Loftus NSW",
    locationSectionTitle: "Reliable Taxi Service in Loftus for Groups",
    locationSectionDescription: (
      <>
        Taking family or friends somewhere nice? Our Loftus Taxi Service suits
        small and large groups perfectly. Everyone travels together in one car.
        You miss the hassle of splitting into different vehicles. You avoid
        confusing planning. Through our dedicated
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab Services in Loftus,
        </Link>
        each person enjoys safe, comfortable travel. Maybe you leave Loftus
        for Sydney Airport. Maybe you head home after long trips. We keep our
        promises on timing. Our drivers know the best routes. They avoid traffic
        jams. They cut the waiting time. You can trust our Group Transport Curl
        Curl options when you need space, reliability, and clean cars. Booking
        takes seconds through our online system. You get confirmation quickly.
        You travel with confidence.
      </>
    ),
    locationSection2Title:
      "Affordable Taxi Service in Loftus with Maxi Cabs: safe and 24/7 transport",
    locationSection2Desctiption: (
      <>
        We believe cheap should never mean uncomfortable. Our
        <Link
          to={`/book-a-taxi`}
          className="underline font-semibold px-1"
        >
          Local Taxi Service
        </Link>
        in Loftus offers fair prices with full clarity. You see the cost
        before booking. You plan your budget with assurance. This helps when
        travelling with others. You can book a
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab for Group Travel
        </Link>{" "}
        that carries many passengers plus bags. Want something better? Upgrade to
        our premium service for nicer travel. Families can ask for
        <Link
          to={`/services/baby-seat-taxi-sydney`}
          className="underline font-semibold px-1"
        >
          Baby Seat Taxi
        </Link>{" "}
        options. Your children ride in approved, properly fitted seats. Our
        drivers have experience and manners. They help with special needs. They
        assist with luggage. From early flights to late arrivals, our 24/7 Taxi
        Loftus keeps you moving. Campbelltown{" "}
        <Link
          to={`/book-a-taxi`}
          className="underline font-semibold px-1"
        >
          Taxi & Maxi Cabs
        </Link>{" "}
        promises safe, reliable, stress-free transport for every customer.
      </>
    ),
    locationSection3Title:
      "Comfortable Corporate & Baby Seat Taxi Booking in Loftus",
    locationSection3Description: (
      <>
        Our
        <Link
          to={`/book-a-taxi`}
          className="underline font-semibold px-1"
        >
          Taxi Service in Loftus
        </Link>{" "}
        gives you lots of legroom. You get plenty of luggage space. You relax
        even when the car is full. You avoid tight seating. You miss awkward bag
        packing. Your trip becomes pleasant. Choosing our Taxi & Maxi Cabs
        Services in Loftus lets your group focus on the journey. We specialise
        in group transfers for families, sports teams, and work groups. Everyone
        arrives together. Booking is fast through our Loftus Cab Booking page.
        You arrange transport early. Business travellers can use our
        <Link
          to={`/services/corporate-tips`}
          className="underline font-semibold px-1"
        >
          Corporate Taxi Service
        </Link>{" "}
        for on-time, professional rides to meetings. Families add Baby Seat Taxi
        options for safer trips with young children. When style matters, our
        premium service gives extra comfort. Every car gets cleaned regularly. We
        keep high standards. You enjoy smooth, safe travel without traffic
        worries.
      </>
    ),
    locationSection4Title:
      "Reliable Loftus Taxi & Maxi Cab: Premium Solutions for All Your Travel Needs",
    locationSection4Desctiption: (
      <>
        Find professional transport made for Loftus residents and visitors.
        Our full range gives you exactly what you need, whether catching early
        flights or arranging
        <Link
          to={`/services/wedding-transfer`}
          className="underline font-semibold px-1"
        >
          wedding transport
        </Link>{" "}
        for many guests. We provide
        <Link
          to={`/services/book-taxi-sydney-airport`}
          className="underline font-semibold px-1"
        >
          Airport Transfers in Loftus
        </Link>{" "}
        with live flight tracking, Maxi Cab Services fitting up to eleven
        passengers,
        <Link
          to={`/services/baby-seat-taxi-sydney`}
          className="underline font-semibold px-1"
        >
          Baby Seat Taxi
        </Link>{" "}
        options with certified restraints, and Local Taxi Service for daily
        tasks. Business people rely on our Corporate Taxi Service, while those
        wanting luxury choose our Premium Service. We specialise in Wedding
        Transport,
        <Link
          to={`/services/event-transfer`}
          className="underline font-semibold px-1"
        >
          Event Transport,
        </Link>{" "}
        Cruise Transfers, Group Transport for large parties, and
        <Link
          to={`/services/wheelchair-accessible-taxi`}
          className="underline font-semibold px-1"
        >
          Wheelchair Accessible Taxi
        </Link>{" "}
        services. Every trip includes clear upfront pricing, real 24/7
        availability, and experienced local drivers who know Loftus well. From
        Door-to-Door Taxi Service to complex plans, Campbelltown Taxi & Maxi Cabs
        combines deep local knowledge with steady reliability—because your
        destination matters, and getting there should feel easy.
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle: "Taxi and Maxi Cab Solutions, Loftus for Every Occasion",
    serviceSubtitle: (
      <>
        We adjust transport to match your needs. Our
        <Link to={`/`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs Services
        </Link>{" "}
        in Loftus support family holidays, group outings, and business travel.
        Safety and punctuality guide everything we do. Every vehicle looks neat.
        Every driver trains well. You depend on us for airport trips, special
        events, and work journeys. Each ride stays simple and relaxed.
      </>
    ),
  
    cabChargeSectionTitle: "CabCharge Taxi Near Loftus",
    cabChargeSectionDesctiption: (
      <>
        Need flexible payment for work or personal trips? Our
        <Link
          to={`/cabcharge-taxi`}
          className="underline font-semibold px-1"
        >
          CabCharge Taxi Service in Loftus
        </Link>
        makes every journey simple and trackable. We accept secure CabCharge
        Payments, including the handy CabCharge Card, perfect for company
        travellers and approved users. Enjoy cashless payments, clear trip
        records, and easy billing every time. Dependable transport backed by
        trusted Cabcharge payment options.
      </>
    ),
  
    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            Travel in roomy vehicles. Bridal parties, relatives, and guests enjoy
            nice, comfortable rides to and from venues.
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },
  
      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            Pick our luxury option for VIP transfers, executive travel, and
            clients wanting more privacy and comfort.
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },
  
      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Families book cars with approved child seats. Young passengers stay
            safe throughout the trip.
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },
  
      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            Made for meetings and group business travel. On-time pickups help
            busy schedules.
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },
  
      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Enjoy easy trips between Loftus and cruise terminals. Plenty of
            space handles passengers and luggage together.
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },
  
      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            Use our service for concerts, parties, and social gatherings. Arrive
            on time. Avoid parking problems.
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },
  
      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            Ideal for larger groups in Loftus. Roomy seating and luggage space
            keep everyone together.
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },
  
      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            Safe, well-organised transfers from Loftus to Sydney Airport or
            business locations. Your team travels without worry.
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },
  
      S009: {
        service_id: "S009",
        title: "Reliable Airport Transfers",
        description: (
          <>
            Reliable 24/7 option across Loftus for everyday trips,
            appointments, and leisure activities.
          </>
        ),
        image: "/airport.png",
        pathname: "/services/taxi-sydney-service",
      },
  
      S010: {
        service_id: "S010",
        title: "Emergency Taxi",
        description: (
          <>
            Urgent need? Our Emergency Taxi in Loftus responds fast. We put
            your safety and speed first.
          </>
        ),
        image: "/emergency.png",
        pathname: "/book-a-taxi",
      },
    },
  
    fleetSectionTitle: "Premium Fleet for Your Loftus Transfer",
    fleetSectionSubTitle: (
      <>
        Choose from different vehicles matching your group size and comfort
        needs.
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Our fleet
        </Link>{" "}
        focuses on safety, space, and smooth rides. Solo travellers find good
        matches. Full groups get suitable options too.
      </>
    ),
  
    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Perfect for single riders or couples wanting quiet, comfortable trips
            with our reliable Door-to-Door Taxi Service throughout Loftus.
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },
  
      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Great for VIPs and business guests who value privacy, quality leather
            seats, and smart presentation on every trip.
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },
  
      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            Extra room for passengers and luggage. Good choice for families or
            small groups heading to Sydney Airport with comfort.
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },
  
      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Fits 6–7 passengers comfortably. Large luggage capacity suits group
            transfers, family holidays, and longer trips.
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },
  
      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Built for bigger groups or large families wanting spacious, clean
            interiors and a fully relaxed travel experience together.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
  
      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Provides accessible transport with properly trained drivers and the
            right safety features for all mobility needs and comfort.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },
  
    faqSectionTitle:
      "Frequently Asked Questions About Taxi Service in Loftus",
    faqs: [
      {
        question: "Which coastal spots near Loftus do you cover?",
        answer: (
          <>
            We service Loftus Beach, Freshwater, and Dee Why. Surf trips
            welcome. Boards fit in <Link
          to={`https://en.wikipedia.org/wiki/Maxi_taxi`}
          className="underline font-semibold px-1"
          target="_blank"
        >Maxi
        </Link> cabs. Beach transport sorted.
          </>
        ),
      },
      {
        question: "How do I arrange transport from Loftus to Manly Wharf?",
        answer: (
          <>
            Ring 1300 450 428. Short trips our specialty. Ferry connections are
            timed. Quick, reliable service every time.
          </>
        ),
      },
      {
        question: "Can I book a maxi cab for Loftus surf club functions?",
        answer: (
          <>
            Yes. We carry surfboards, gear, and teams. Nippers' events covered.
            Beach transport expertise guaranteed.
          </>
        ),
      },
      {
        question: "Do your drivers know ways around Pittwater Road congestion?",
        answer: (
          <>
            Absolutely. Northern Beaches locals. Traffic hotspots avoided. Back
            streets mastered. You get smart navigators.
          </>
        ),
      },
      {
        question: "What if I need a taxi for the Loftus dawn patrol surfing?",
        answer: (
          <>
            Early surf trips welcome. 4 AM pickups arranged. Wetsuit-friendly
            vehicles. Your wave chase is supported.
          </>
        ),
      },
      {
        question: "Can I ask for the same driver for regular Loftus trips?",
        answer: (
          <>
            Request when booking. Preferences noted. Same driver when possible.
            Relationship builds over time.
          </>
        ),
      },
      {
        question: "How do I organise wheelchair transport to Loftus Beach?",
        answer: (
          <>
            State needs when calling. Beach access vehicles are available. Help
            provided. Inclusion matters to us.
          </>
        ),
      },
      {
        question: "Are your Loftus taxis pet-friendly for vet visits?",
        answer: (
          <>
            Small pets in carriers are accepted. Harbord Vet trips are common.
            Service animals are always welcome. Mention when booking.
          </>
        ),
      },
      {
        question: "Can I set up account billing for Loftus business travel?",
        answer: (
          <>
            Corporate accounts available. Monthly statements. Priority bookings.
            Expense management simplified.
          </>
        ),
      },
      {
        question: "What sets you apart from rideshare apps in Loftus?",
        answer: (
          <>
            Phone bookings. Fixed rates. Local knowledge. No surge pricing.
            Personal service every trip.
          </>
        ),
      },
     
      {
        question: "How early should I book wedding cars for Loftus ceremonies?",
        answer: (
          <>
            Secure months ahead. Beach weddings are popular. Multiple vehicles
            coordinated. Your special day is perfected.
          </>
        ),
      },
      {
        question: "Can I pay with CabCharge for Loftus airport transfers?",
        answer: (
          <>
            CabCharge welcome. Corporate cards accepted. Cash and EFTPOS too.
            Flexible payment options.
          </>
        ),
      },
      {
        question: "What happens if my flight arrives early at Sydney Airport?",
        answer: (
          <>
            Live tracking is active. The driver adjusts the pickup. No waiting
            fees. Seamless collection guaranteed.
          </>
        ),
      },
      {
        question: "Do you service all Loftus streets including beachside lanes?",
        answer: (
          <>
            Yes. Every address found. Narrow lanes navigated. Beachfront pickups
            arranged. No confusion.
          </>
        ),
      },
    ],
  },
 "heathcote-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d13223.501056693429!2d151.0435723!3d-34.04707065!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12c17e79770ff1%3A0x5017d681632b9f0!2sHeathcote%20NSW%202233%2C%20Australia!5e0!3m2!1sen!2sbd!4v1774725072686!5m2!1sen!2sbd",
    pageTitle:
      "Taxi & Maxi Cabs Services in Heathcote, NSW - Family & Local Travel Experts",
    metaDescription:
      "Book Taxi & Maxi Cabs Services in Heathcote for family travel, local trips & cruise transfers. Trusted drivers, baby seat options & fixed pricing available. Book now!",
    heroTitle:
      "24/7 Taxi & Maxi Cabs Services in Heathcote for Fast & Safe Travel",
    heroDescription: (
      <>
        Need dependable rides around Heathcote? Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs Services
        </Link>
        in Heathcote deliver quick pickups every time you call. We handle your
        local trips with sharp timing that never fails. Our vehicles fit single
        travellers and large groups equally well. You get plenty of cabin space
        for people and luggage together. No one gets left out or squeezed inside.
        We run day and night without stopping. Your flight might land at 2 AM.
        Your shift could end at sunrise. Either way, we show up fast. Choose our
        luxury option for extra comfort. We manage smooth Heathcote pick up and
        drop off to keep your schedule on track. You avoid delays. You skip
        stress.
        <Link to={`/`} className="underline font-semibold px-1">
          Campbelltown Taxi Cabs
        </Link>{" "}
        puts your timetable first always.
      </>
    ),
    bookingFormTitle: "Book Baby Taxi in Heathcote NSW",
    locationSectionTitle: "Reliable Taxi Service in Heathcote for Groups",
    locationSectionDescription: (
      <>
        Taking family or friends somewhere nice? Our Heathcote Taxi Service suits
        small and large groups perfectly. Everyone travels together in one car.
        You miss the hassle of splitting into different vehicles. You avoid
        confusing planning. Through our dedicated
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab Services in Heathcote,
        </Link>
        each person enjoys safe, comfortable travel. Maybe you leave Heathcote
        for Sydney Airport. Maybe you head home after long trips. We keep our
        promises on timing. Our drivers know the best routes. They avoid traffic
        jams. They cut the waiting time. You can trust our Group Transport Curl
        Curl options when you need space, reliability, and clean cars. Booking
        takes seconds through our online system. You get confirmation quickly.
        You travel with confidence.
      </>
    ),
    locationSection2Title:
      "Affordable Taxi Service in Heathcote with Maxi Cabs: safe and 24/7 transport",
    locationSection2Desctiption: (
      <>
        We believe cheap should never mean uncomfortable. Our
        <Link
          to={`/book-a-taxi`}
          className="underline font-semibold px-1"
        >
          Local Taxi Service
        </Link>
        in Heathcote offers fair prices with full clarity. You see the cost
        before booking. You plan your budget with assurance. This helps when
        travelling with others. You can book a
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab for Group Travel
        </Link>{" "}
        that carries many passengers plus bags. Want something better? Upgrade to
        our premium service for nicer travel. Families can ask for
        <Link
          to={`/services/baby-seat-taxi-sydney`}
          className="underline font-semibold px-1"
        >
          Baby Seat Taxi
        </Link>{" "}
        options. Your children ride in approved, properly fitted seats. Our
        drivers have experience and manners. They help with special needs. They
        assist with luggage. From early flights to late arrivals, our 24/7 Taxi
        Heathcote keeps you moving. Campbelltown{" "}
        <Link
          to={`/book-a-taxi`}
          className="underline font-semibold px-1"
        >
          Taxi & Maxi Cabs
        </Link>{" "}
        promises safe, reliable, stress-free transport for every customer.
      </>
    ),
    locationSection3Title:
      "Comfortable Corporate & Baby Seat Taxi Booking in Heathcote",
    locationSection3Description: (
      <>
        Our
        <Link
          to={`/book-a-taxi`}
          className="underline font-semibold px-1"
        >
          Taxi Service in Heathcote
        </Link>{" "}
        gives you lots of legroom. You get plenty of luggage space. You relax
        even when the car is full. You avoid tight seating. You miss awkward bag
        packing. Your trip becomes pleasant. Choosing our Taxi & Maxi Cabs
        Services in Heathcote lets your group focus on the journey. We specialise
        in group transfers for families, sports teams, and work groups. Everyone
        arrives together. Booking is fast through our Heathcote Cab Booking page.
        You arrange transport early. Business travellers can use our
        <Link
          to={`/services/corporate-tips`}
          className="underline font-semibold px-1"
        >
          Corporate Taxi Service
        </Link>{" "}
        for on-time, professional rides to meetings. Families add Baby Seat Taxi
        options for safer trips with young children. When style matters, our
        premium service gives extra comfort. Every car gets cleaned regularly. We
        keep high standards. You enjoy smooth, safe travel without traffic
        worries.
      </>
    ),
    locationSection4Title:
      "Reliable Heathcote Taxi & Maxi Cab: Premium Solutions for All Your Travel Needs",
    locationSection4Desctiption: (
      <>
        Find professional transport made for Heathcote residents and visitors.
        Our full range gives you exactly what you need, whether catching early
        flights or arranging
        <Link
          to={`/services/wedding-transfer`}
          className="underline font-semibold px-1"
        >
          wedding transport
        </Link>{" "}
        for many guests. We provide
        <Link
          to={`/services/book-taxi-sydney-airport`}
          className="underline font-semibold px-1"
        >
          Airport Transfers in Heathcote
        </Link>{" "}
        with live flight tracking, Maxi Cab Services fitting up to eleven
        passengers,
        <Link
          to={`/services/baby-seat-taxi-sydney`}
          className="underline font-semibold px-1"
        >
          Baby Seat Taxi
        </Link>{" "}
        options with certified restraints, and Local Taxi Service for daily
        tasks. Business people rely on our Corporate Taxi Service, while those
        wanting luxury choose our Premium Service. We specialise in Wedding
        Transport,
        <Link
          to={`/services/event-transfer`}
          className="underline font-semibold px-1"
        >
          Event Transport,
        </Link>{" "}
        Cruise Transfers, Group Transport for large parties, and
        <Link
          to={`/services/wheelchair-accessible-taxi`}
          className="underline font-semibold px-1"
        >
          Wheelchair Accessible Taxi
        </Link>{" "}
        services. Every trip includes clear upfront pricing, real 24/7
        availability, and experienced local drivers who know Heathcote well. From
        Door-to-Door Taxi Service to complex plans, Campbelltown Taxi & Maxi Cabs
        combines deep local knowledge with steady reliability—because your
        destination matters, and getting there should feel easy.
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle: "Taxi and Maxi Cab Solutions, Heathcote for Every Occasion",
    serviceSubtitle: (
      <>
        We adjust transport to match your needs. Our
        <Link to={`/`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs Services
        </Link>{" "}
        in Heathcote support family holidays, group outings, and business travel.
        Safety and punctuality guide everything we do. Every vehicle looks neat.
        Every driver trains well. You depend on us for airport trips, special
        events, and work journeys. Each ride stays simple and relaxed.
      </>
    ),
  
    cabChargeSectionTitle: "CabCharge Taxi Near Heathcote",
    cabChargeSectionDesctiption: (
      <>
        Need flexible payment for work or personal trips? Our
        <Link
          to={`/cabcharge-taxi`}
          className="underline font-semibold px-1"
        >
          CabCharge Taxi Service in Heathcote
        </Link>
        makes every journey simple and trackable. We accept secure CabCharge
        Payments, including the handy CabCharge Card, perfect for company
        travellers and approved users. Enjoy cashless payments, clear trip
        records, and easy billing every time. Dependable transport backed by
        trusted Cabcharge payment options.
      </>
    ),
  
    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            Travel in roomy vehicles. Bridal parties, relatives, and guests enjoy
            nice, comfortable rides to and from venues.
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },
  
      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            Pick our luxury option for VIP transfers, executive travel, and
            clients wanting more privacy and comfort.
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },
  
      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Families book cars with approved child seats. Young passengers stay
            safe throughout the trip.
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },
  
      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            Made for meetings and group business travel. On-time pickups help
            busy schedules.
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },
  
      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Enjoy easy trips between Heathcote and cruise terminals. Plenty of
            space handles passengers and luggage together.
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },
  
      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            Use our service for concerts, parties, and social gatherings. Arrive
            on time. Avoid parking problems.
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },
  
      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            Ideal for larger groups in Heathcote. Roomy seating and luggage space
            keep everyone together.
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },
  
      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            Safe, well-organised transfers from Heathcote to Sydney Airport or
            business locations. Your team travels without worry.
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },
  
      S009: {
        service_id: "S009",
        title: "Reliable Airport Transfers",
        description: (
          <>
            Reliable 24/7 option across Heathcote for everyday trips,
            appointments, and leisure activities.
          </>
        ),
        image: "/airport.png",
        pathname: "/services/taxi-sydney-service",
      },
  
      S010: {
        service_id: "S010",
        title: "Emergency Taxi",
        description: (
          <>
            Urgent need? Our Emergency Taxi in Heathcote responds fast. We put
            your safety and speed first.
          </>
        ),
        image: "/emergency.png",
        pathname: "/book-a-taxi",
      },
    },
  
    fleetSectionTitle: "Premium Fleet for Your Heathcote Transfer",
    fleetSectionSubTitle: (
      <>
        Choose from different vehicles matching your group size and comfort
        needs.
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Our fleet
        </Link>{" "}
        focuses on safety, space, and smooth rides. Solo travellers find good
        matches. Full groups get suitable options too.
      </>
    ),
  
    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Perfect for single riders or couples wanting quiet, comfortable trips
            with our reliable Door-to-Door Taxi Service throughout Heathcote.
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },
  
      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Great for VIPs and business guests who value privacy, quality leather
            seats, and smart presentation on every trip.
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },
  
      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            Extra room for passengers and luggage. Good choice for families or
            small groups heading to Sydney Airport with comfort.
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },
  
      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Fits 6–7 passengers comfortably. Large luggage capacity suits group
            transfers, family holidays, and longer trips.
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },
  
      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Built for bigger groups or large families wanting spacious, clean
            interiors and a fully relaxed travel experience together.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
  
      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Provides accessible transport with properly trained drivers and the
            right safety features for all mobility needs and comfort.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },
  
    faqSectionTitle:
      "Frequently Asked Questions About Taxi Service in Heathcote",
    faqs: [
      {
        question: "Which coastal spots near Heathcote do you cover?",
        answer: (
          <>
            We service Heathcote Beach, Freshwater, and Dee Why. Surf trips
            welcome. Boards fit in <Link
          to={`https://en.wikipedia.org/wiki/Maxi_taxi`}
          className="underline font-semibold px-1"
          target="_blank"
        >Maxi
        </Link> cabs. Beach transport sorted.
          </>
        ),
      },
      {
        question: "How do I arrange transport from Heathcote to Manly Wharf?",
        answer: (
          <>
            Ring 1300 450 428. Short trips our specialty. Ferry connections are
            timed. Quick, reliable service every time.
          </>
        ),
      },
      {
        question: "Can I book a maxi cab for Heathcote surf club functions?",
        answer: (
          <>
            Yes. We carry surfboards, gear, and teams. Nippers' events covered.
            Beach transport expertise guaranteed.
          </>
        ),
      },
      {
        question: "Do your drivers know ways around Pittwater Road congestion?",
        answer: (
          <>
            Absolutely. Northern Beaches locals. Traffic hotspots avoided. Back
            streets mastered. You get smart navigators.
          </>
        ),
      },
      {
        question: "What if I need a taxi for the Heathcote dawn patrol surfing?",
        answer: (
          <>
            Early surf trips welcome. 4 AM pickups arranged. Wetsuit-friendly
            vehicles. Your wave chase is supported.
          </>
        ),
      },
      {
        question: "Can I ask for the same driver for regular Heathcote trips?",
        answer: (
          <>
            Request when booking. Preferences noted. Same driver when possible.
            Relationship builds over time.
          </>
        ),
      },
      {
        question: "How do I organise wheelchair transport to Heathcote Beach?",
        answer: (
          <>
            State needs when calling. Beach access vehicles are available. Help
            provided. Inclusion matters to us.
          </>
        ),
      },
      {
        question: "Are your Heathcote taxis pet-friendly for vet visits?",
        answer: (
          <>
            Small pets in carriers are accepted. Harbord Vet trips are common.
            Service animals are always welcome. Mention when booking.
          </>
        ),
      },
      {
        question: "Can I set up account billing for Heathcote business travel?",
        answer: (
          <>
            Corporate accounts available. Monthly statements. Priority bookings.
            Expense management simplified.
          </>
        ),
      },
      {
        question: "What sets you apart from rideshare apps in Heathcote?",
        answer: (
          <>
            Phone bookings. Fixed rates. Local knowledge. No surge pricing.
            Personal service every trip.
          </>
        ),
      },
     
      {
        question: "How early should I book wedding cars for Heathcote ceremonies?",
        answer: (
          <>
            Secure months ahead. Beach weddings are popular. Multiple vehicles
            coordinated. Your special day is perfected.
          </>
        ),
      },
      {
        question: "Can I pay with CabCharge for Heathcote airport transfers?",
        answer: (
          <>
            CabCharge welcome. Corporate cards accepted. Cash and EFTPOS too.
            Flexible payment options.
          </>
        ),
      },
      {
        question: "What happens if my flight arrives early at Sydney Airport?",
        answer: (
          <>
            Live tracking is active. The driver adjusts the pickup. No waiting
            fees. Seamless collection guaranteed.
          </>
        ),
      },
      {
        question: "Do you service all Heathcote streets including beachside lanes?",
        answer: (
          <>
            Yes. Every address found. Narrow lanes navigated. Beachfront pickups
            arranged. No confusion.
          </>
        ),
      },
    ],
  },
 "menai-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d52860.345600534856!2d150.97877725!3d-34.100991099999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12becfd63d1d9b%3A0x5017d681632c0b0!2sMenai%20NSW%202234%2C%20Australia!5e0!3m2!1sen!2sbd!4v1774725120947!5m2!1sen!2sbd",
    pageTitle:
      "Taxi & Maxi Cabs Services in Menai, NSW - Family & Local Travel Experts",
    metaDescription:
      "Book Taxi & Maxi Cabs Services in Menai for family travel, local trips & cruise transfers. Trusted drivers, baby seat options & fixed pricing available. Book now!",
    heroTitle:
      "24/7 Taxi & Maxi Cabs Services in Menai for Fast & Safe Travel",
    heroDescription: (
      <>
        Need dependable rides around Menai? Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs Services
        </Link>
        in Menai deliver quick pickups every time you call. We handle your
        local trips with sharp timing that never fails. Our vehicles fit single
        travellers and large groups equally well. You get plenty of cabin space
        for people and luggage together. No one gets left out or squeezed inside.
        We run day and night without stopping. Your flight might land at 2 AM.
        Your shift could end at sunrise. Either way, we show up fast. Choose our
        luxury option for extra comfort. We manage smooth Menai pick up and
        drop off to keep your schedule on track. You avoid delays. You skip
        stress.
        <Link to={`/`} className="underline font-semibold px-1">
          Campbelltown Taxi Cabs
        </Link>{" "}
        puts your timetable first always.
      </>
    ),
    bookingFormTitle: "Book Baby Taxi in Menai NSW",
    locationSectionTitle: "Reliable Taxi Service in Menai for Groups",
    locationSectionDescription: (
      <>
        Taking family or friends somewhere nice? Our Menai Taxi Service suits
        small and large groups perfectly. Everyone travels together in one car.
        You miss the hassle of splitting into different vehicles. You avoid
        confusing planning. Through our dedicated
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab Services in Menai,
        </Link>
        each person enjoys safe, comfortable travel. Maybe you leave Menai
        for Sydney Airport. Maybe you head home after long trips. We keep our
        promises on timing. Our drivers know the best routes. They avoid traffic
        jams. They cut the waiting time. You can trust our Group Transport Curl
        Curl options when you need space, reliability, and clean cars. Booking
        takes seconds through our online system. You get confirmation quickly.
        You travel with confidence.
      </>
    ),
    locationSection2Title:
      "Affordable Taxi Service in Menai with Maxi Cabs: safe and 24/7 transport",
    locationSection2Desctiption: (
      <>
        We believe cheap should never mean uncomfortable. Our
        <Link
          to={`/book-a-taxi`}
          className="underline font-semibold px-1"
        >
          Local Taxi Service
        </Link>
        in Menai offers fair prices with full clarity. You see the cost
        before booking. You plan your budget with assurance. This helps when
        travelling with others. You can book a
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab for Group Travel
        </Link>{" "}
        that carries many passengers plus bags. Want something better? Upgrade to
        our premium service for nicer travel. Families can ask for
        <Link
          to={`/services/baby-seat-taxi-sydney`}
          className="underline font-semibold px-1"
        >
          Baby Seat Taxi
        </Link>{" "}
        options. Your children ride in approved, properly fitted seats. Our
        drivers have experience and manners. They help with special needs. They
        assist with luggage. From early flights to late arrivals, our 24/7 Taxi
        Menai keeps you moving. Campbelltown{" "}
        <Link
          to={`/book-a-taxi`}
          className="underline font-semibold px-1"
        >
          Taxi & Maxi Cabs
        </Link>{" "}
        promises safe, reliable, stress-free transport for every customer.
      </>
    ),
    locationSection3Title:
      "Comfortable Corporate & Baby Seat Taxi Booking in Menai",
    locationSection3Description: (
      <>
        Our
        <Link
          to={`/book-a-taxi`}
          className="underline font-semibold px-1"
        >
          Taxi Service in Menai
        </Link>{" "}
        gives you lots of legroom. You get plenty of luggage space. You relax
        even when the car is full. You avoid tight seating. You miss awkward bag
        packing. Your trip becomes pleasant. Choosing our Taxi & Maxi Cabs
        Services in Menai lets your group focus on the journey. We specialise
        in group transfers for families, sports teams, and work groups. Everyone
        arrives together. Booking is fast through our Menai Cab Booking page.
        You arrange transport early. Business travellers can use our
        <Link
          to={`/services/corporate-tips`}
          className="underline font-semibold px-1"
        >
          Corporate Taxi Service
        </Link>{" "}
        for on-time, professional rides to meetings. Families add Baby Seat Taxi
        options for safer trips with young children. When style matters, our
        premium service gives extra comfort. Every car gets cleaned regularly. We
        keep high standards. You enjoy smooth, safe travel without traffic
        worries.
      </>
    ),
    locationSection4Title:
      "Reliable Menai Taxi & Maxi Cab: Premium Solutions for All Your Travel Needs",
    locationSection4Desctiption: (
      <>
        Find professional transport made for Menai residents and visitors.
        Our full range gives you exactly what you need, whether catching early
        flights or arranging
        <Link
          to={`/services/wedding-transfer`}
          className="underline font-semibold px-1"
        >
          wedding transport
        </Link>{" "}
        for many guests. We provide
        <Link
          to={`/services/book-taxi-sydney-airport`}
          className="underline font-semibold px-1"
        >
          Airport Transfers in Menai
        </Link>{" "}
        with live flight tracking, Maxi Cab Services fitting up to eleven
        passengers,
        <Link
          to={`/services/baby-seat-taxi-sydney`}
          className="underline font-semibold px-1"
        >
          Baby Seat Taxi
        </Link>{" "}
        options with certified restraints, and Local Taxi Service for daily
        tasks. Business people rely on our Corporate Taxi Service, while those
        wanting luxury choose our Premium Service. We specialise in Wedding
        Transport,
        <Link
          to={`/services/event-transfer`}
          className="underline font-semibold px-1"
        >
          Event Transport,
        </Link>{" "}
        Cruise Transfers, Group Transport for large parties, and
        <Link
          to={`/services/wheelchair-accessible-taxi`}
          className="underline font-semibold px-1"
        >
          Wheelchair Accessible Taxi
        </Link>{" "}
        services. Every trip includes clear upfront pricing, real 24/7
        availability, and experienced local drivers who know Menai well. From
        Door-to-Door Taxi Service to complex plans, Campbelltown Taxi & Maxi Cabs
        combines deep local knowledge with steady reliability—because your
        destination matters, and getting there should feel easy.
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle: "Taxi and Maxi Cab Solutions, Menai for Every Occasion",
    serviceSubtitle: (
      <>
        We adjust transport to match your needs. Our
        <Link to={`/`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs Services
        </Link>{" "}
        in Menai support family holidays, group outings, and business travel.
        Safety and punctuality guide everything we do. Every vehicle looks neat.
        Every driver trains well. You depend on us for airport trips, special
        events, and work journeys. Each ride stays simple and relaxed.
      </>
    ),
  
    cabChargeSectionTitle: "CabCharge Taxi Near Menai",
    cabChargeSectionDesctiption: (
      <>
        Need flexible payment for work or personal trips? Our
        <Link
          to={`/cabcharge-taxi`}
          className="underline font-semibold px-1"
        >
          CabCharge Taxi Service in Menai
        </Link>
        makes every journey simple and trackable. We accept secure CabCharge
        Payments, including the handy CabCharge Card, perfect for company
        travellers and approved users. Enjoy cashless payments, clear trip
        records, and easy billing every time. Dependable transport backed by
        trusted Cabcharge payment options.
      </>
    ),
  
    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            Travel in roomy vehicles. Bridal parties, relatives, and guests enjoy
            nice, comfortable rides to and from venues.
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },
  
      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            Pick our luxury option for VIP transfers, executive travel, and
            clients wanting more privacy and comfort.
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },
  
      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Families book cars with approved child seats. Young passengers stay
            safe throughout the trip.
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },
  
      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            Made for meetings and group business travel. On-time pickups help
            busy schedules.
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },
  
      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Enjoy easy trips between Menai and cruise terminals. Plenty of
            space handles passengers and luggage together.
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },
  
      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            Use our service for concerts, parties, and social gatherings. Arrive
            on time. Avoid parking problems.
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },
  
      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            Ideal for larger groups in Menai. Roomy seating and luggage space
            keep everyone together.
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },
  
      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            Safe, well-organised transfers from Menai to Sydney Airport or
            business locations. Your team travels without worry.
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },
  
      S009: {
        service_id: "S009",
        title: "Reliable Airport Transfers",
        description: (
          <>
            Reliable 24/7 option across Menai for everyday trips,
            appointments, and leisure activities.
          </>
        ),
        image: "/airport.png",
        pathname: "/services/taxi-sydney-service",
      },
  
      S010: {
        service_id: "S010",
        title: "Emergency Taxi",
        description: (
          <>
            Urgent need? Our Emergency Taxi in Menai responds fast. We put
            your safety and speed first.
          </>
        ),
        image: "/emergency.png",
        pathname: "/book-a-taxi",
      },
    },
  
    fleetSectionTitle: "Premium Fleet for Your Menai Transfer",
    fleetSectionSubTitle: (
      <>
        Choose from different vehicles matching your group size and comfort
        needs.
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Our fleet
        </Link>{" "}
        focuses on safety, space, and smooth rides. Solo travellers find good
        matches. Full groups get suitable options too.
      </>
    ),
  
    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Perfect for single riders or couples wanting quiet, comfortable trips
            with our reliable Door-to-Door Taxi Service throughout Menai.
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },
  
      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Great for VIPs and business guests who value privacy, quality leather
            seats, and smart presentation on every trip.
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },
  
      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            Extra room for passengers and luggage. Good choice for families or
            small groups heading to Sydney Airport with comfort.
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },
  
      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Fits 6–7 passengers comfortably. Large luggage capacity suits group
            transfers, family holidays, and longer trips.
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },
  
      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Built for bigger groups or large families wanting spacious, clean
            interiors and a fully relaxed travel experience together.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
  
      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Provides accessible transport with properly trained drivers and the
            right safety features for all mobility needs and comfort.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },
  
    faqSectionTitle:
      "Frequently Asked Questions About Taxi Service in Menai",
    faqs: [
      {
        question: "Which coastal spots near Menai do you cover?",
        answer: (
          <>
            We service Menai Beach, Freshwater, and Dee Why. Surf trips
            welcome. Boards fit in <Link
          to={`https://en.wikipedia.org/wiki/Maxi_taxi`}
          className="underline font-semibold px-1"
          target="_blank"
        >Maxi
        </Link> cabs. Beach transport sorted.
          </>
        ),
      },
      {
        question: "How do I arrange transport from Menai to Manly Wharf?",
        answer: (
          <>
            Ring 1300 450 428. Short trips our specialty. Ferry connections are
            timed. Quick, reliable service every time.
          </>
        ),
      },
      {
        question: "Can I book a maxi cab for Menai surf club functions?",
        answer: (
          <>
            Yes. We carry surfboards, gear, and teams. Nippers' events covered.
            Beach transport expertise guaranteed.
          </>
        ),
      },
      {
        question: "Do your drivers know ways around Pittwater Road congestion?",
        answer: (
          <>
            Absolutely. Northern Beaches locals. Traffic hotspots avoided. Back
            streets mastered. You get smart navigators.
          </>
        ),
      },
      {
        question: "What if I need a taxi for the Menai dawn patrol surfing?",
        answer: (
          <>
            Early surf trips welcome. 4 AM pickups arranged. Wetsuit-friendly
            vehicles. Your wave chase is supported.
          </>
        ),
      },
      {
        question: "Can I ask for the same driver for regular Menai trips?",
        answer: (
          <>
            Request when booking. Preferences noted. Same driver when possible.
            Relationship builds over time.
          </>
        ),
      },
      {
        question: "How do I organise wheelchair transport to Menai Beach?",
        answer: (
          <>
            State needs when calling. Beach access vehicles are available. Help
            provided. Inclusion matters to us.
          </>
        ),
      },
      {
        question: "Are your Menai taxis pet-friendly for vet visits?",
        answer: (
          <>
            Small pets in carriers are accepted. Harbord Vet trips are common.
            Service animals are always welcome. Mention when booking.
          </>
        ),
      },
      {
        question: "Can I set up account billing for Menai business travel?",
        answer: (
          <>
            Corporate accounts available. Monthly statements. Priority bookings.
            Expense management simplified.
          </>
        ),
      },
      {
        question: "What sets you apart from rideshare apps in Menai?",
        answer: (
          <>
            Phone bookings. Fixed rates. Local knowledge. No surge pricing.
            Personal service every trip.
          </>
        ),
      },
     
      {
        question: "How early should I book wedding cars for Menai ceremonies?",
        answer: (
          <>
            Secure months ahead. Beach weddings are popular. Multiple vehicles
            coordinated. Your special day is perfected.
          </>
        ),
      },
      {
        question: "Can I pay with CabCharge for Menai airport transfers?",
        answer: (
          <>
            CabCharge welcome. Corporate cards accepted. Cash and EFTPOS too.
            Flexible payment options.
          </>
        ),
      },
      {
        question: "What happens if my flight arrives early at Sydney Airport?",
        answer: (
          <>
            Live tracking is active. The driver adjusts the pickup. No waiting
            fees. Seamless collection guaranteed.
          </>
        ),
      },
      {
        question: "Do you service all Menai streets including beachside lanes?",
        answer: (
          <>
            Yes. Every address found. Narrow lanes navigated. Beachfront pickups
            arranged. No confusion.
          </>
        ),
      },
    ],
  },
 "bangor-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d52920.10797843635!2d151.00224475000002!3d-34.005201199999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12c0a59efab523%3A0x5017d681632acd0!2sBangor%20NSW%202234%2C%20Australia!5e0!3m2!1sen!2sbd!4v1774725176230!5m2!1sen!2sbd",
    pageTitle:
      "Taxi & Maxi Cabs Services in Bangor, NSW - Family & Local Travel Experts",
    metaDescription:
      "Book Taxi & Maxi Cabs Services in Bangor for family travel, local trips & cruise transfers. Trusted drivers, baby seat options & fixed pricing available. Book now!",
    heroTitle:
      "24/7 Taxi & Maxi Cabs Services in Bangor for Fast & Safe Travel",
    heroDescription: (
      <>
        Need dependable rides around Bangor? Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs Services
        </Link>
        in Bangor deliver quick pickups every time you call. We handle your
        local trips with sharp timing that never fails. Our vehicles fit single
        travellers and large groups equally well. You get plenty of cabin space
        for people and luggage together. No one gets left out or squeezed inside.
        We run day and night without stopping. Your flight might land at 2 AM.
        Your shift could end at sunrise. Either way, we show up fast. Choose our
        luxury option for extra comfort. We manage smooth Bangor pick up and
        drop off to keep your schedule on track. You avoid delays. You skip
        stress.
        <Link to={`/`} className="underline font-semibold px-1">
          Campbelltown Taxi Cabs
        </Link>{" "}
        puts your timetable first always.
      </>
    ),
    bookingFormTitle: "Book Baby Taxi in Bangor NSW",
    locationSectionTitle: "Reliable Taxi Service in Bangor for Groups",
    locationSectionDescription: (
      <>
        Taking family or friends somewhere nice? Our Bangor Taxi Service suits
        small and large groups perfectly. Everyone travels together in one car.
        You miss the hassle of splitting into different vehicles. You avoid
        confusing planning. Through our dedicated
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab Services in Bangor,
        </Link>
        each person enjoys safe, comfortable travel. Maybe you leave Bangor
        for Sydney Airport. Maybe you head home after long trips. We keep our
        promises on timing. Our drivers know the best routes. They avoid traffic
        jams. They cut the waiting time. You can trust our Group Transport Curl
        Curl options when you need space, reliability, and clean cars. Booking
        takes seconds through our online system. You get confirmation quickly.
        You travel with confidence.
      </>
    ),
    locationSection2Title:
      "Affordable Taxi Service in Bangor with Maxi Cabs: safe and 24/7 transport",
    locationSection2Desctiption: (
      <>
        We believe cheap should never mean uncomfortable. Our
        <Link
          to={`/book-a-taxi`}
          className="underline font-semibold px-1"
        >
          Local Taxi Service
        </Link>
        in Bangor offers fair prices with full clarity. You see the cost
        before booking. You plan your budget with assurance. This helps when
        travelling with others. You can book a
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab for Group Travel
        </Link>{" "}
        that carries many passengers plus bags. Want something better? Upgrade to
        our premium service for nicer travel. Families can ask for
        <Link
          to={`/services/baby-seat-taxi-sydney`}
          className="underline font-semibold px-1"
        >
          Baby Seat Taxi
        </Link>{" "}
        options. Your children ride in approved, properly fitted seats. Our
        drivers have experience and manners. They help with special needs. They
        assist with luggage. From early flights to late arrivals, our 24/7 Taxi
        Bangor keeps you moving. Campbelltown{" "}
        <Link
          to={`/book-a-taxi`}
          className="underline font-semibold px-1"
        >
          Taxi & Maxi Cabs
        </Link>{" "}
        promises safe, reliable, stress-free transport for every customer.
      </>
    ),
    locationSection3Title:
      "Comfortable Corporate & Baby Seat Taxi Booking in Bangor",
    locationSection3Description: (
      <>
        Our
        <Link
          to={`/book-a-taxi`}
          className="underline font-semibold px-1"
        >
          Taxi Service in Bangor
        </Link>{" "}
        gives you lots of legroom. You get plenty of luggage space. You relax
        even when the car is full. You avoid tight seating. You miss awkward bag
        packing. Your trip becomes pleasant. Choosing our Taxi & Maxi Cabs
        Services in Bangor lets your group focus on the journey. We specialise
        in group transfers for families, sports teams, and work groups. Everyone
        arrives together. Booking is fast through our Bangor Cab Booking page.
        You arrange transport early. Business travellers can use our
        <Link
          to={`/services/corporate-tips`}
          className="underline font-semibold px-1"
        >
          Corporate Taxi Service
        </Link>{" "}
        for on-time, professional rides to meetings. Families add Baby Seat Taxi
        options for safer trips with young children. When style matters, our
        premium service gives extra comfort. Every car gets cleaned regularly. We
        keep high standards. You enjoy smooth, safe travel without traffic
        worries.
      </>
    ),
    locationSection4Title:
      "Reliable Bangor Taxi & Maxi Cab: Premium Solutions for All Your Travel Needs",
    locationSection4Desctiption: (
      <>
        Find professional transport made for Bangor residents and visitors.
        Our full range gives you exactly what you need, whether catching early
        flights or arranging
        <Link
          to={`/services/wedding-transfer`}
          className="underline font-semibold px-1"
        >
          wedding transport
        </Link>{" "}
        for many guests. We provide
        <Link
          to={`/services/book-taxi-sydney-airport`}
          className="underline font-semibold px-1"
        >
          Airport Transfers in Bangor
        </Link>{" "}
        with live flight tracking, Maxi Cab Services fitting up to eleven
        passengers,
        <Link
          to={`/services/baby-seat-taxi-sydney`}
          className="underline font-semibold px-1"
        >
          Baby Seat Taxi
        </Link>{" "}
        options with certified restraints, and Local Taxi Service for daily
        tasks. Business people rely on our Corporate Taxi Service, while those
        wanting luxury choose our Premium Service. We specialise in Wedding
        Transport,
        <Link
          to={`/services/event-transfer`}
          className="underline font-semibold px-1"
        >
          Event Transport,
        </Link>{" "}
        Cruise Transfers, Group Transport for large parties, and
        <Link
          to={`/services/wheelchair-accessible-taxi`}
          className="underline font-semibold px-1"
        >
          Wheelchair Accessible Taxi
        </Link>{" "}
        services. Every trip includes clear upfront pricing, real 24/7
        availability, and experienced local drivers who know Bangor well. From
        Door-to-Door Taxi Service to complex plans, Campbelltown Taxi & Maxi Cabs
        combines deep local knowledge with steady reliability—because your
        destination matters, and getting there should feel easy.
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle: "Taxi and Maxi Cab Solutions, Bangor for Every Occasion",
    serviceSubtitle: (
      <>
        We adjust transport to match your needs. Our
        <Link to={`/`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs Services
        </Link>{" "}
        in Bangor support family holidays, group outings, and business travel.
        Safety and punctuality guide everything we do. Every vehicle looks neat.
        Every driver trains well. You depend on us for airport trips, special
        events, and work journeys. Each ride stays simple and relaxed.
      </>
    ),
  
    cabChargeSectionTitle: "CabCharge Taxi Near Bangor",
    cabChargeSectionDesctiption: (
      <>
        Need flexible payment for work or personal trips? Our
        <Link
          to={`/cabcharge-taxi`}
          className="underline font-semibold px-1"
        >
          CabCharge Taxi Service in Bangor
        </Link>
        makes every journey simple and trackable. We accept secure CabCharge
        Payments, including the handy CabCharge Card, perfect for company
        travellers and approved users. Enjoy cashless payments, clear trip
        records, and easy billing every time. Dependable transport backed by
        trusted Cabcharge payment options.
      </>
    ),
  
    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            Travel in roomy vehicles. Bridal parties, relatives, and guests enjoy
            nice, comfortable rides to and from venues.
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },
  
      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            Pick our luxury option for VIP transfers, executive travel, and
            clients wanting more privacy and comfort.
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },
  
      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Families book cars with approved child seats. Young passengers stay
            safe throughout the trip.
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },
  
      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            Made for meetings and group business travel. On-time pickups help
            busy schedules.
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },
  
      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Enjoy easy trips between Bangor and cruise terminals. Plenty of
            space handles passengers and luggage together.
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },
  
      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            Use our service for concerts, parties, and social gatherings. Arrive
            on time. Avoid parking problems.
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },
  
      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            Ideal for larger groups in Bangor. Roomy seating and luggage space
            keep everyone together.
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },
  
      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            Safe, well-organised transfers from Bangor to Sydney Airport or
            business locations. Your team travels without worry.
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },
  
      S009: {
        service_id: "S009",
        title: "Reliable Airport Transfers",
        description: (
          <>
            Reliable 24/7 option across Bangor for everyday trips,
            appointments, and leisure activities.
          </>
        ),
        image: "/airport.png",
        pathname: "/services/taxi-sydney-service",
      },
  
      S010: {
        service_id: "S010",
        title: "Emergency Taxi",
        description: (
          <>
            Urgent need? Our Emergency Taxi in Bangor responds fast. We put
            your safety and speed first.
          </>
        ),
        image: "/emergency.png",
        pathname: "/book-a-taxi",
      },
    },
  
    fleetSectionTitle: "Premium Fleet for Your Bangor Transfer",
    fleetSectionSubTitle: (
      <>
        Choose from different vehicles matching your group size and comfort
        needs.
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Our fleet
        </Link>{" "}
        focuses on safety, space, and smooth rides. Solo travellers find good
        matches. Full groups get suitable options too.
      </>
    ),
  
    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Perfect for single riders or couples wanting quiet, comfortable trips
            with our reliable Door-to-Door Taxi Service throughout Bangor.
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },
  
      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Great for VIPs and business guests who value privacy, quality leather
            seats, and smart presentation on every trip.
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },
  
      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            Extra room for passengers and luggage. Good choice for families or
            small groups heading to Sydney Airport with comfort.
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },
  
      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Fits 6–7 passengers comfortably. Large luggage capacity suits group
            transfers, family holidays, and longer trips.
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },
  
      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Built for bigger groups or large families wanting spacious, clean
            interiors and a fully relaxed travel experience together.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
  
      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Provides accessible transport with properly trained drivers and the
            right safety features for all mobility needs and comfort.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },
  
    faqSectionTitle:
      "Frequently Asked Questions About Taxi Service in Bangor",
    faqs: [
      {
        question: "Which coastal spots near Bangor do you cover?",
        answer: (
          <>
            We service Bangor Beach, Freshwater, and Dee Why. Surf trips
            welcome. Boards fit in <Link
          to={`https://en.wikipedia.org/wiki/Maxi_taxi`}
          className="underline font-semibold px-1"
          target="_blank"
        >Maxi
        </Link> cabs. Beach transport sorted.
          </>
        ),
      },
      {
        question: "How do I arrange transport from Bangor to Manly Wharf?",
        answer: (
          <>
            Ring 1300 450 428. Short trips our specialty. Ferry connections are
            timed. Quick, reliable service every time.
          </>
        ),
      },
      {
        question: "Can I book a maxi cab for Bangor surf club functions?",
        answer: (
          <>
            Yes. We carry surfboards, gear, and teams. Nippers' events covered.
            Beach transport expertise guaranteed.
          </>
        ),
      },
      {
        question: "Do your drivers know ways around Pittwater Road congestion?",
        answer: (
          <>
            Absolutely. Northern Beaches locals. Traffic hotspots avoided. Back
            streets mastered. You get smart navigators.
          </>
        ),
      },
      {
        question: "What if I need a taxi for the Bangor dawn patrol surfing?",
        answer: (
          <>
            Early surf trips welcome. 4 AM pickups arranged. Wetsuit-friendly
            vehicles. Your wave chase is supported.
          </>
        ),
      },
      {
        question: "Can I ask for the same driver for regular Bangor trips?",
        answer: (
          <>
            Request when booking. Preferences noted. Same driver when possible.
            Relationship builds over time.
          </>
        ),
      },
      {
        question: "How do I organise wheelchair transport to Bangor Beach?",
        answer: (
          <>
            State needs when calling. Beach access vehicles are available. Help
            provided. Inclusion matters to us.
          </>
        ),
      },
      {
        question: "Are your Bangor taxis pet-friendly for vet visits?",
        answer: (
          <>
            Small pets in carriers are accepted. Harbord Vet trips are common.
            Service animals are always welcome. Mention when booking.
          </>
        ),
      },
      {
        question: "Can I set up account billing for Bangor business travel?",
        answer: (
          <>
            Corporate accounts available. Monthly statements. Priority bookings.
            Expense management simplified.
          </>
        ),
      },
      {
        question: "What sets you apart from rideshare apps in Bangor?",
        answer: (
          <>
            Phone bookings. Fixed rates. Local knowledge. No surge pricing.
            Personal service every trip.
          </>
        ),
      },
     
      {
        question: "How early should I book wedding cars for Bangor ceremonies?",
        answer: (
          <>
            Secure months ahead. Beach weddings are popular. Multiple vehicles
            coordinated. Your special day is perfected.
          </>
        ),
      },
      {
        question: "Can I pay with CabCharge for Bangor airport transfers?",
        answer: (
          <>
            CabCharge welcome. Corporate cards accepted. Cash and EFTPOS too.
            Flexible payment options.
          </>
        ),
      },
      {
        question: "What happens if my flight arrives early at Sydney Airport?",
        answer: (
          <>
            Live tracking is active. The driver adjusts the pickup. No waiting
            fees. Seamless collection guaranteed.
          </>
        ),
      },
      {
        question: "Do you service all Bangor streets including beachside lanes?",
        answer: (
          <>
            Yes. Every address found. Narrow lanes navigated. Beachfront pickups
            arranged. No confusion.
          </>
        ),
      },
    ],
  },
 "illawong-nsw": {
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d13228.23377463677!2d151.03360639999997!3d-34.01671074999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12bf35f1604e37%3A0x5017d681632bb80!2sIllawong%20NSW%202234%2C%20Australia!5e0!3m2!1sen!2sbd!4v1774725228965!5m2!1sen!2sbd",
    pageTitle:
      "Taxi & Maxi Cabs Services in Illawong, NSW - Family & Local Travel Experts",
    metaDescription:
      "Book Taxi & Maxi Cabs Services in Illawong for family travel, local trips & cruise transfers. Trusted drivers, baby seat options & fixed pricing available. Book now!",
    heroTitle:
      "24/7 Taxi & Maxi Cabs Services in Illawong for Fast & Safe Travel",
    heroDescription: (
      <>
        Need dependable rides around Illawong? Our
        <Link to={`/book-a-taxi`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs Services
        </Link>
        in Illawong deliver quick pickups every time you call. We handle your
        local trips with sharp timing that never fails. Our vehicles fit single
        travellers and large groups equally well. You get plenty of cabin space
        for people and luggage together. No one gets left out or squeezed inside.
        We run day and night without stopping. Your flight might land at 2 AM.
        Your shift could end at sunrise. Either way, we show up fast. Choose our
        luxury option for extra comfort. We manage smooth Illawong pick up and
        drop off to keep your schedule on track. You avoid delays. You skip
        stress.
        <Link to={`/`} className="underline font-semibold px-1">
          Campbelltown Taxi Cabs
        </Link>{" "}
        puts your timetable first always.
      </>
    ),
    bookingFormTitle: "Book Baby Taxi in Illawong NSW",
    locationSectionTitle: "Reliable Taxi Service in Illawong for Groups",
    locationSectionDescription: (
      <>
        Taking family or friends somewhere nice? Our Illawong Taxi Service suits
        small and large groups perfectly. Everyone travels together in one car.
        You miss the hassle of splitting into different vehicles. You avoid
        confusing planning. Through our dedicated
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab Services in Illawong,
        </Link>
        each person enjoys safe, comfortable travel. Maybe you leave Illawong
        for Sydney Airport. Maybe you head home after long trips. We keep our
        promises on timing. Our drivers know the best routes. They avoid traffic
        jams. They cut the waiting time. You can trust our Group Transport Curl
        Curl options when you need space, reliability, and clean cars. Booking
        takes seconds through our online system. You get confirmation quickly.
        You travel with confidence.
      </>
    ),
    locationSection2Title:
      "Affordable Taxi Service in Illawong with Maxi Cabs: safe and 24/7 transport",
    locationSection2Desctiption: (
      <>
        We believe cheap should never mean uncomfortable. Our
        <Link
          to={`/book-a-taxi`}
          className="underline font-semibold px-1"
        >
          Local Taxi Service
        </Link>
        in Illawong offers fair prices with full clarity. You see the cost
        before booking. You plan your budget with assurance. This helps when
        travelling with others. You can book a
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Maxi Cab for Group Travel
        </Link>{" "}
        that carries many passengers plus bags. Want something better? Upgrade to
        our premium service for nicer travel. Families can ask for
        <Link
          to={`/services/baby-seat-taxi-sydney`}
          className="underline font-semibold px-1"
        >
          Baby Seat Taxi
        </Link>{" "}
        options. Your children ride in approved, properly fitted seats. Our
        drivers have experience and manners. They help with special needs. They
        assist with luggage. From early flights to late arrivals, our 24/7 Taxi
        Illawong keeps you moving. Campbelltown{" "}
        <Link
          to={`/book-a-taxi`}
          className="underline font-semibold px-1"
        >
          Taxi & Maxi Cabs
        </Link>{" "}
        promises safe, reliable, stress-free transport for every customer.
      </>
    ),
    locationSection3Title:
      "Comfortable Corporate & Baby Seat Taxi Booking in Illawong",
    locationSection3Description: (
      <>
        Our
        <Link
          to={`/book-a-taxi`}
          className="underline font-semibold px-1"
        >
          Taxi Service in Illawong
        </Link>{" "}
        gives you lots of legroom. You get plenty of luggage space. You relax
        even when the car is full. You avoid tight seating. You miss awkward bag
        packing. Your trip becomes pleasant. Choosing our Taxi & Maxi Cabs
        Services in Illawong lets your group focus on the journey. We specialise
        in group transfers for families, sports teams, and work groups. Everyone
        arrives together. Booking is fast through our Illawong Cab Booking page.
        You arrange transport early. Business travellers can use our
        <Link
          to={`/services/corporate-tips`}
          className="underline font-semibold px-1"
        >
          Corporate Taxi Service
        </Link>{" "}
        for on-time, professional rides to meetings. Families add Baby Seat Taxi
        options for safer trips with young children. When style matters, our
        premium service gives extra comfort. Every car gets cleaned regularly. We
        keep high standards. You enjoy smooth, safe travel without traffic
        worries.
      </>
    ),
    locationSection4Title:
      "Reliable Illawong Taxi & Maxi Cab: Premium Solutions for All Your Travel Needs",
    locationSection4Desctiption: (
      <>
        Find professional transport made for Illawong residents and visitors.
        Our full range gives you exactly what you need, whether catching early
        flights or arranging
        <Link
          to={`/services/wedding-transfer`}
          className="underline font-semibold px-1"
        >
          wedding transport
        </Link>{" "}
        for many guests. We provide
        <Link
          to={`/services/book-taxi-sydney-airport`}
          className="underline font-semibold px-1"
        >
          Airport Transfers in Illawong
        </Link>{" "}
        with live flight tracking, Maxi Cab Services fitting up to eleven
        passengers,
        <Link
          to={`/services/baby-seat-taxi-sydney`}
          className="underline font-semibold px-1"
        >
          Baby Seat Taxi
        </Link>{" "}
        options with certified restraints, and Local Taxi Service for daily
        tasks. Business people rely on our Corporate Taxi Service, while those
        wanting luxury choose our Premium Service. We specialise in Wedding
        Transport,
        <Link
          to={`/services/event-transfer`}
          className="underline font-semibold px-1"
        >
          Event Transport,
        </Link>{" "}
        Cruise Transfers, Group Transport for large parties, and
        <Link
          to={`/services/wheelchair-accessible-taxi`}
          className="underline font-semibold px-1"
        >
          Wheelchair Accessible Taxi
        </Link>{" "}
        services. Every trip includes clear upfront pricing, real 24/7
        availability, and experienced local drivers who know Illawong well. From
        Door-to-Door Taxi Service to complex plans, Campbelltown Taxi & Maxi Cabs
        combines deep local knowledge with steady reliability—because your
        destination matters, and getting there should feel easy.
      </>
    ),
    locationSectionImg: corporateTripsImg,
    serviceTitle: "Taxi and Maxi Cab Solutions, Illawong for Every Occasion",
    serviceSubtitle: (
      <>
        We adjust transport to match your needs. Our
        <Link to={`/`} className="underline font-semibold px-1">
          Taxi & Maxi Cabs Services
        </Link>{" "}
        in Illawong support family holidays, group outings, and business travel.
        Safety and punctuality guide everything we do. Every vehicle looks neat.
        Every driver trains well. You depend on us for airport trips, special
        events, and work journeys. Each ride stays simple and relaxed.
      </>
    ),
  
    cabChargeSectionTitle: "CabCharge Taxi Near Illawong",
    cabChargeSectionDesctiption: (
      <>
        Need flexible payment for work or personal trips? Our
        <Link
          to={`/cabcharge-taxi`}
          className="underline font-semibold px-1"
        >
          CabCharge Taxi Service in Illawong
        </Link>
        makes every journey simple and trackable. We accept secure CabCharge
        Payments, including the handy CabCharge Card, perfect for company
        travellers and approved users. Enjoy cashless payments, clear trip
        records, and easy billing every time. Dependable transport backed by
        trusted Cabcharge payment options.
      </>
    ),
  
    locationServices: {
      S001: {
        service_id: "S001",
        title: "Wedding Transfer",
        description: (
          <>
            Travel in roomy vehicles. Bridal parties, relatives, and guests enjoy
            nice, comfortable rides to and from venues.
          </>
        ),
        image: "/car.png",
        pathname: "/services/wedding-transfer",
      },
  
      S002: {
        service_id: "S002",
        title: "Luxury Transfer",
        description: (
          <>
            Pick our luxury option for VIP transfers, executive travel, and
            clients wanting more privacy and comfort.
          </>
        ),
        image: "/vehicle.png",
        pathname: "/services/luxury-transfer",
      },
  
      S003: {
        service_id: "S003",
        title: "Baby Seat Taxi Sydney",
        description: (
          <>
            Families book cars with approved child seats. Young passengers stay
            safe throughout the trip.
          </>
        ),
        image: "/baby-seat.png",
        pathname: "/services/baby-seat-taxi-sydney",
      },
  
      S004: {
        service_id: "S004",
        title: "Corporate Transport Services",
        description: (
          <>
            Made for meetings and group business travel. On-time pickups help
            busy schedules.
          </>
        ),
        image: "/corporate.png",
        pathname: "/services/corporate-transport-services",
      },
  
      S005: {
        service_id: "S005",
        title: "Cruise Terminal Transfer",
        description: (
          <>
            Enjoy easy trips between Illawong and cruise terminals. Plenty of
            space handles passengers and luggage together.
          </>
        ),
        image: "/ship.png",
        pathname: "/services/cruise-terminal-transfer",
      },
  
      S006: {
        service_id: "S006",
        title: "Event Transfer",
        description: (
          <>
            Use our service for concerts, parties, and social gatherings. Arrive
            on time. Avoid parking problems.
          </>
        ),
        image: "/event.png",
        pathname: "/services/event-transfer",
      },
  
      S007: {
        service_id: "S007",
        title: "Maxi Taxi Service",
        description: (
          <>
            Ideal for larger groups in Illawong. Roomy seating and luggage space
            keep everyone together.
          </>
        ),
        image: "/users.png",
        pathname: "/services/maxi-taxi-service",
      },
  
      S008: {
        service_id: "S008",
        title: "Corporate Trips",
        description: (
          <>
            Safe, well-organised transfers from Illawong to Sydney Airport or
            business locations. Your team travels without worry.
          </>
        ),
        image: "/briefcase.png",
        pathname: "/services/corporate-tips",
      },
  
      S009: {
        service_id: "S009",
        title: "Reliable Airport Transfers",
        description: (
          <>
            Reliable 24/7 option across Illawong for everyday trips,
            appointments, and leisure activities.
          </>
        ),
        image: "/airport.png",
        pathname: "/services/taxi-sydney-service",
      },
  
      S010: {
        service_id: "S010",
        title: "Emergency Taxi",
        description: (
          <>
            Urgent need? Our Emergency Taxi in Illawong responds fast. We put
            your safety and speed first.
          </>
        ),
        image: "/emergency.png",
        pathname: "/book-a-taxi",
      },
    },
  
    fleetSectionTitle: "Premium Fleet for Your Illawong Transfer",
    fleetSectionSubTitle: (
      <>
        Choose from different vehicles matching your group size and comfort
        needs.
        <Link
          to={`/services/maxi-taxi-service`}
          className="underline font-semibold px-1"
        >
          Our fleet
        </Link>{" "}
        focuses on safety, space, and smooth rides. Solo travellers find good
        matches. Full groups get suitable options too.
      </>
    ),
  
    fleetSectionVehicles: {
      1: {
        id: 1,
        name: "Easy Sedan",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Perfect for single riders or couples wanting quiet, comfortable trips
            with our reliable Door-to-Door Taxi Service throughout Illawong.
          </>
        ),
        image: "/campbelltown-easy-sedan.png",
      },
  
      2: {
        id: 2,
        name: "Luxury Vehicle",
        passengerCapacity: 4,
        bagsCapacity: 2,
        description: (
          <>
            Great for VIPs and business guests who value privacy, quality leather
            seats, and smart presentation on every trip.
          </>
        ),
        image: "/campbelltown-luxury-vehicle.png",
      },
  
      3: {
        id: 3,
        name: "Suv or Wagon",
        passengerCapacity: 7,
        bagsCapacity: 5,
        description: (
          <>
            Extra room for passengers and luggage. Good choice for families or
            small groups heading to Sydney Airport with comfort.
          </>
        ),
        image: "/campbelltown-suv-wagon.png",
      },
  
      4: {
        id: 4,
        name: "Kia Carnival",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Fits 6–7 passengers comfortably. Large luggage capacity suits group
            transfers, family holidays, and longer trips.
          </>
        ),
        image: "/campbelltown-kia-carnival.png",
      },
  
      5: {
        id: 5,
        name: "Maxi Taxi",
        passengerCapacity: 11,
        bagsCapacity: 8,
        description: (
          <>
            Built for bigger groups or large families wanting spacious, clean
            interiors and a fully relaxed travel experience together.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
  
      6: {
        id: 6,
        name: "Wheelchair Taxi Service",
        passengerCapacity: 7,
        bagsCapacity: 8,
        description: (
          <>
            Provides accessible transport with properly trained drivers and the
            right safety features for all mobility needs and comfort.
          </>
        ),
        image: "/campbelltown-maxi-taxi.png",
      },
    },
  
    faqSectionTitle:
      "Frequently Asked Questions About Taxi Service in Illawong",
    faqs: [
      {
        question: "Which coastal spots near Illawong do you cover?",
        answer: (
          <>
            We service Illawong Beach, Freshwater, and Dee Why. Surf trips
            welcome. Boards fit in <Link
          to={`https://en.wikipedia.org/wiki/Maxi_taxi`}
          className="underline font-semibold px-1"
          target="_blank"
        >Maxi
        </Link> cabs. Beach transport sorted.
          </>
        ),
      },
      {
        question: "How do I arrange transport from Illawong to Manly Wharf?",
        answer: (
          <>
            Ring 1300 450 428. Short trips our specialty. Ferry connections are
            timed. Quick, reliable service every time.
          </>
        ),
      },
      {
        question: "Can I book a maxi cab for Illawong surf club functions?",
        answer: (
          <>
            Yes. We carry surfboards, gear, and teams. Nippers' events covered.
            Beach transport expertise guaranteed.
          </>
        ),
      },
      {
        question: "Do your drivers know ways around Pittwater Road congestion?",
        answer: (
          <>
            Absolutely. Northern Beaches locals. Traffic hotspots avoided. Back
            streets mastered. You get smart navigators.
          </>
        ),
      },
      {
        question: "What if I need a taxi for the Illawong dawn patrol surfing?",
        answer: (
          <>
            Early surf trips welcome. 4 AM pickups arranged. Wetsuit-friendly
            vehicles. Your wave chase is supported.
          </>
        ),
      },
      {
        question: "Can I ask for the same driver for regular Illawong trips?",
        answer: (
          <>
            Request when booking. Preferences noted. Same driver when possible.
            Relationship builds over time.
          </>
        ),
      },
      {
        question: "How do I organise wheelchair transport to Illawong Beach?",
        answer: (
          <>
            State needs when calling. Beach access vehicles are available. Help
            provided. Inclusion matters to us.
          </>
        ),
      },
      {
        question: "Are your Illawong taxis pet-friendly for vet visits?",
        answer: (
          <>
            Small pets in carriers are accepted. Harbord Vet trips are common.
            Service animals are always welcome. Mention when booking.
          </>
        ),
      },
      {
        question: "Can I set up account billing for Illawong business travel?",
        answer: (
          <>
            Corporate accounts available. Monthly statements. Priority bookings.
            Expense management simplified.
          </>
        ),
      },
      {
        question: "What sets you apart from rideshare apps in Illawong?",
        answer: (
          <>
            Phone bookings. Fixed rates. Local knowledge. No surge pricing.
            Personal service every trip.
          </>
        ),
      },
     
      {
        question: "How early should I book wedding cars for Illawong ceremonies?",
        answer: (
          <>
            Secure months ahead. Beach weddings are popular. Multiple vehicles
            coordinated. Your special day is perfected.
          </>
        ),
      },
      {
        question: "Can I pay with CabCharge for Illawong airport transfers?",
        answer: (
          <>
            CabCharge welcome. Corporate cards accepted. Cash and EFTPOS too.
            Flexible payment options.
          </>
        ),
      },
      {
        question: "What happens if my flight arrives early at Sydney Airport?",
        answer: (
          <>
            Live tracking is active. The driver adjusts the pickup. No waiting
            fees. Seamless collection guaranteed.
          </>
        ),
      },
      {
        question: "Do you service all Illawong streets including beachside lanes?",
        answer: (
          <>
            Yes. Every address found. Narrow lanes navigated. Beachfront pickups
            arranged. No confusion.
          </>
        ),
      },
    ],
  },
}